{
  "brand": {
    "entity": "Heraion",
    "product": "Metria"
  },
  "createHub": {
    "title": "Crea",
    "open": "Crea",
    "close": "Chiudi",
    "actionsHeader": "Avvia",
    "todayHeader": "Oggi",
    "newWorkout": {
      "title": "Nuovo allenamento",
      "sub": "Inizia subito un allenamento vuoto"
    },
    "repeatWorkout": {
      "title": "Ripeti allenamento",
      "sub": "Registra di nuovo da un allenamento passato"
    },
    "buildToday": {
      "title": "Costruisci la seduta di oggi",
      "sub": "Esercizi per i muscoli sotto il volume minimo",
      "subInstead": "Al posto del piano di oggi: i muscoli sotto il volume minimo"
    },
    "planProgram": {
      "title": "Pianifica un programma",
      "sub": "Crea un programma di più settimane"
    },
    "planWorkout": {
      "title": "Pianifica un allenamento",
      "sub": "Prepara una singola sessione per dopo"
    }
  },
  "library": {
    "header": "Sfoglia",
    "tabPrograms": "Programmi",
    "tabWorkouts": "Allenamenti",
    "tabPersonal": "Personali",
    "tabCoach": "Coach",
    "tabFavorites": "Preferiti",
    "favoriteA11y": "Preferito",
    "errFavorite": "Impossibile aggiornare i preferiti.",
    "emptyFavoritesTitle": "Nessun preferito",
    "emptyFavoritesSub": "Tocca la stella su un programma o un allenamento per tenerlo qui.",
    "sectionOfficial": "Di $t(brand.product)",
    "sectionPersonal": "Personali",
    "clone": "Clona",
    "copySuffix": "(copia)",
    "following": "Sto seguendo…",
    "alreadyYours": "Già tuo",
    "cloneFollowed": "Fanne una tua versione",
    "followed": "Ora segui \"{{name}}\".",
    "searchPlaceholder": "Cerca per nome…",
    "filters": "Filtri",
    "clearFilters": "Azzera",
    "axisLevel": "Livello",
    "axisPerWeek": "Sessioni / settimana",
    "noResultsTitle": "Nessun risultato",
    "noResultsSub": "Modifica la ricerca o i filtri.",
    "loading": "Carico la libreria…",
    "errLoad": "Impossibile caricare la libreria.",
    "errClone": "Clonazione non riuscita. Riprova.",
    "errDelete": "Eliminazione non riuscita. Riprova.",
    "leaveTitle": "Togliere dalla tua libreria?",
    "leaveBody_one": "{{name}} è assegnato anche a {{count}} altra persona. Lei lo mantiene: questo lo toglie solo dalla tua libreria.",
    "leaveBody_other": "{{name}} è assegnato anche ad altre {{count}} persone. Loro lo mantengono: questo lo toglie solo dalla tua libreria.",
    "leaveConfirm": "Togli",
    "errLeave": "Impossibile toglierlo dalla tua libreria. Riprova.",
    "unfollow": "Smetti di seguire",
    "unfollowHint": "Lo toglie dalla tua libreria. L'autore lo mantiene.",
    "unfollowTitle": "Smettere di seguire?",
    "unfollowBody": "{{name}} resta al suo autore. Questo lo toglie solo dalla tua libreria.",
    "errUnfollow": "Impossibile smettere di seguire. Riprova.",
    "errFollow": "Impossibile seguire il programma.",
    "errStatus": "Impossibile aggiornare il programma.",
    "errAssign": "Impossibile aggiornare gli assegnatari.",
    "assignSent": "Inviato — chi è nuovo nella lista riceve una richiesta che può accettare o rifiutare.",
    "assignSentSelf": "Inviato — essendo scritto da coach, controlla anche la tua inbox da atleta per accettarlo o rifiutarlo.",
    "emptyTitle": "Ancora niente qui",
    "emptySub": "I programmi e gli allenamenti che crei o cloni compaiono qui.",
    "emptyCoachTitle": "Ancora nessuna assegnazione",
    "emptyCoachSub": "Nessuno ti ha ancora assegnato un programma o un allenamento.",
    "assignedBy": "Assegnato da {{name}}",
    "followingVersion": "Segui la versione di {{name}}",
    "followingVersionUnknown": "Segui la versione di qualcun altro"
  },
  "common": {
    "weightUnit_kg": "kg",
    "weightUnit_lb": "lb",
    "lastDataAt": "Ultimo dato {{at}}",
    "noData": "Nessun dato",
    "lastDataOn": "Ultimo dato: {{date}}",
    "languageA11y": "Lingua",
    "infoA11y": "Info",
    "unsavedChanges": {
      "title": "Scartare le modifiche?",
      "body": "Le modifiche non salvate andranno perse.",
      "keepEditing": "Continua a modificare",
      "discard": "Scarta",
      "exitTitle": "Modifiche non salvate",
      "exitBody": "Queste modifiche non sono salvate. Puoi salvarle, tenerle come bozza su questo dispositivo o scartarle.",
      "exitBodyNoDraft": "Queste modifiche non sono salvate. Puoi salvarle o scartarle.",
      "save": "Salva",
      "keepDraft": "Tieni la bozza"
    },
    "relativeAge": {
      "today": "oggi",
      "days": "{{count}}g fa",
      "weeks": "{{count}} sett. fa",
      "months": "{{count}} mesi fa"
    },
    "loadMore": "Carica altro",
    "loadingMore": "Caricamento…",
    "pageOf": "{{current}} di {{total}}",
    "weekInProgress": "Settimana in corso",
    "weekDaysToGo_one": "manca {{count}} giorno",
    "weekDaysToGo_other": "mancano {{count}} giorni",
    "weekLastDay": "ultimo giorno",
    "noFullWeekYet": "Ancora nessuna settimana piena"
  },
  "bodymap": {
    "viewBack": "Schiena",
    "viewFront": "Fronte",
    "workedTitle": "Muscoli lavorati",
    "workedPrimary": "primari",
    "workedSecondary": "secondari",
    "heatmapTitle": "Muscoli più allenati",
    "heatmapLow": "poco",
    "heatmapHigh": "molto",
    "window7d": "7 giorni",
    "window30d": "30 giorni",
    "painTitle": "Mappa del dolore",
    "painHelp": "Tocca un muscolo per marcarlo, un lato alla volta: rosso (no carichi pesanti), giallo (attenzione). Salvato automaticamente.",
    "painRed": "evita",
    "painYellow": "attenzione",
    "painClearAll": "Cancella tutto",
    "painSaving": "Salvataggio…",
    "painSaveError": "Salvataggio fallito. Controlla la connessione.",
    "painRiskA11y": "Rischio dolore: {{severity}}",
    "painRiskSideA11y": "Rischio dolore: {{severity}}, {{side}}",
    "painBannerMuscleSide": "{{muscle}} (<side>{{side}}</side>)",
    "painSideOnly": {
      "left": "solo lato sinistro",
      "right": "solo lato destro"
    },
    "painSeverity": {
      "red": "alto",
      "yellow": "medio",
      "green": "basso"
    },
    "painPart": {
      "chest": "il petto",
      "chest_left": "il lato sinistro del petto",
      "chest_right": "il lato destro del petto",
      "biceps": "i bicipiti",
      "biceps_left": "il bicipite sinistro",
      "biceps_right": "il bicipite destro",
      "triceps": "i tricipiti",
      "triceps_left": "il tricipite sinistro",
      "triceps_right": "il tricipite destro",
      "forearm": "gli avambracci",
      "forearm_left": "l'avambraccio sinistro",
      "forearm_right": "l'avambraccio destro",
      "front-deltoids": "le spalle",
      "front-deltoids_left": "la spalla sinistra",
      "front-deltoids_right": "la spalla destra",
      "back-deltoids": "le spalle",
      "back-deltoids_left": "la spalla sinistra",
      "back-deltoids_right": "la spalla destra",
      "trapezius": "i trapezi",
      "trapezius_left": "il trapezio sinistro",
      "trapezius_right": "il trapezio destro",
      "upper-back": "la parte alta della schiena",
      "upper-back_left": "il lato sinistro della parte alta della schiena",
      "upper-back_right": "il lato destro della parte alta della schiena",
      "lower-back": "la zona lombare",
      "lower-back_left": "il lato sinistro della zona lombare",
      "lower-back_right": "il lato destro della zona lombare",
      "abs": "gli addominali",
      "abs_left": "il lato sinistro degli addominali",
      "abs_right": "il lato destro degli addominali",
      "obliques": "gli obliqui",
      "obliques_left": "l'obliquo sinistro",
      "obliques_right": "l'obliquo destro",
      "quadriceps": "i quadricipiti",
      "quadriceps_left": "il quadricipite sinistro",
      "quadriceps_right": "il quadricipite destro",
      "hamstring": "gli ischiocrurali",
      "hamstring_left": "gli ischiocrurali sinistri",
      "hamstring_right": "gli ischiocrurali destri",
      "gluteal": "i glutei",
      "gluteal_left": "il gluteo sinistro",
      "gluteal_right": "il gluteo destro",
      "adductors": "gli adduttori",
      "adductors_left": "gli adduttori sinistri",
      "adductors_right": "gli adduttori destri",
      "abductors": "gli abduttori",
      "abductors_left": "gli abduttori sinistri",
      "abductors_right": "gli abduttori destri",
      "calves": "i polpacci",
      "calves_left": "il polpaccio sinistro",
      "calves_right": "il polpaccio destro",
      "tibialis": "gli stinchi",
      "tibialis_left": "lo stinco sinistro",
      "tibialis_right": "lo stinco destro",
      "neck": "il collo",
      "neck_left": "il lato sinistro del collo",
      "neck_right": "il lato destro del collo",
      "head": "la testa",
      "head_left": "il lato sinistro della testa",
      "head_right": "il lato destro della testa"
    },
    "painSummaryAvoid": "Evita: {{parts}}",
    "painSummaryCaution": "Attenzione: {{parts}}",
    "zoomIn": "Ingrandisci",
    "zoomOut": "Riduci",
    "zoomReset": "Ripristina lo zoom",
    "zoomPinchHint": "Pizzica o usa i pulsanti.",
    "painListToggle": "Muscoli come elenco",
    "painListLeft": "{{muscle}} (sinistra)",
    "painListRight": "{{muscle}} (destra)",
    "painStateRed": "Niente carichi pesanti",
    "painStateYellow": "Attenzione",
    "painStateNone": "Non segnato",
    "painListRowA11y": "{{muscle}}, {{state}}"
  },
  "plates": {
    "title": "Carico dischi",
    "openHint": "Mostra il carico dei dischi",
    "close": "Chiudi",
    "targetLabel": "Obiettivo",
    "barLabel": "Bilanciere",
    "barAria": "Peso del bilanciere",
    "barNone": "Senza bilanciere",
    "perSide": "Per lato",
    "perSidePair": "{{count}} × {{plate}}",
    "barOnly": "Solo il bilanciere — non servono dischi.",
    "belowBar": "L'obiettivo è più leggero del bilanciere.",
    "invalidInput": "Inserisci prima un peso valido.",
    "remainder": "+{{weight}} sotto l'obiettivo con l'inventario attuale.",
    "fallbackPill": "massimo possibile",
    "inventoryLegend": "Coppie disponibili",
    "inventoryHint": "Coppie di ogni disco disponibili adesso. Metti 0 se la palestra non ce l'ha o se sono tutti occupati. Salvato tra le sessioni.",
    "pairsAria": "Coppie di {{plate}} disponibili",
    "loadedSide": "Lato caricato",
    "singleSideHint": "Un lato solo: i dischi vanno su un lato soltanto. Landmine, t-bar, slitte e leve per braccio si caricano così."
  },
  "app": {
    "title": "$t(brand.product)",
    "tagline": "Allenamento di forza, registrato senza fronzoli.",
    "signedInAs": "Accesso effettuato come <bold>{{email}}</bold>.",
    "signOut": "Esci",
    "loading": "Caricamento…",
    "checking": "verifica in corso…"
  },
  "auth": {
    "signIn": "Accedi",
    "signInFailed": "Accesso non riuscito. Controlla email e password.",
    "email": "Email",
    "emailPlaceholder": "email@esempio.com",
    "password": "Password",
    "passwordRules": {
      "length": "Almeno 10 caratteri",
      "uppercase": "Una maiuscola",
      "lowercase": "Una minuscola",
      "number": "Un numero",
      "met": "fatto",
      "unmet": "ancora da fare"
    },
    "revealPassword_one": "Mostra la password",
    "revealPassword_other": "Mostra le password",
    "hidePassword_one": "Nascondi la password",
    "hidePassword_other": "Nascondi le password",
    "passwordHint": "Almeno 10 caratteri con maiuscola, minuscola e un numero.",
    "invitedOnly": "Gli account si creano su invito. Se hai ricevuto un invito, entra con l'indirizzo e la password temporanea che ti sono arrivati per email.",
    "submitting": "Attendi…",
    "confirmTitle": "Conferma la tua email",
    "confirmHelp": "Ti abbiamo inviato un codice a <bold>{{email}}</bold>. Incollalo qui sotto per completare la registrazione.",
    "confirmCode": "Codice di conferma",
    "confirmSubmit": "Conferma",
    "confirming": "Conferma in corso…",
    "resendCode": "Rinvia il codice",
    "resentInfo": "Codice rinviato. Controlla la tua casella di posta.",
    "confirmedNowSignIn": "Account confermato. Accedi per continuare.",
    "forgotEmailRequired": "Scrivi l'email con cui accedi.",
    "forgotCodeRequired": "Scrivi il codice che ti abbiamo inviato.",
    "forgotLink": "Hai dimenticato la password?",
    "forgotTitle": "Reimposta la password",
    "forgotIntro": "Inserisci la tua email e ti invieremo un codice per reimpostare la password.",
    "forgotSendCode": "Invia codice",
    "forgotCodeSent": "Codice inviato. Controlla la posta.",
    "forgotConfirmHelp": "Codice inviato a <bold>{{email}}</bold>. Inseriscilo qui sotto.",
    "forgotResetSubmit": "Reimposta password",
    "forgotResetDone": "Password aggiornata. Accedi con la nuova.",
    "newPassword": "Nuova password",
    "backToSignIn": "Torna all'accesso",
    "welcome": {
      "title": "Benvenuto in $t(brand.product)",
      "help": "Sei stato invitato. Scegli la password che userai d'ora in poi, e dicci come chiamarti.",
      "name": "Come ti chiamiamo?",
      "namePlaceholder": "Il tuo nome",
      "nameRequired": "Scrivi un nome — è così che l'app ti saluterà.",
      "submit": "Entra"
    },
    "confirmPassword": "Conferma la password",
    "passwordsMatch": "Le due coincidono.",
    "passwordMismatch": "Le due password non coincidono.",
    "forgotCodeSubmit": "Continua",
    "forgotCodeIncomplete": "Inserisci tutte e sei le cifre del codice.",
    "forgotPasswordHelp": "Scegli la password che userai d'ora in poi.",
    "backStep": "Indietro",
    "forgotStep": "Passo {{n}} di 3",
    "forgotCodeWrong": "Il codice non è quello giusto. Controllalo e riprova.",
    "forgotCodeExpired": "Il codice è scaduto. Chiedine uno nuovo.",
    "forgotTooManyAttempts": "Troppi tentativi. Aspetta qualche minuto e riprova.",
    "forgotTooManyRequests": "Hai chiesto troppi codici. Aspetta qualche minuto.",
    "resendCodeIn": "Rinvia il codice ({{seconds}} s)"
  },
  "dashboard": {
    "meTitle": "Round-trip autenticato — /api/me",
    "healthTitle": "Stato API",
    "exportData": "Esporta i miei dati",
    "deleteAccount": "Elimina il mio account",
    "exporting": "Preparazione export…",
    "deleting": "Eliminazione…",
    "deleteConfirm": "Verranno eliminati definitivamente il tuo account e tutti i tuoi dati. Scrivi ELIMINA per confermare.",
    "deleteCancel": "Annulla",
    "deletePlaceholder": "ELIMINA",
    "deleteSuccess": "Account eliminato.",
    "exportFilename": "metria-export-{{date}}.json",
    "privacyTitle": "Privacy",
    "privacyHelp": "Esporta tutto in JSON o cancella l'account in modo definitivo. Le cancellazioni non si recuperano."
  },
  "privacy": {
    "linkLabel": "Privacy",
    "title": "Informativa sulla privacy",
    "lastUpdated": "Ultimo aggiornamento: 9 settembre 2026 (titolare del trattamento, conservazione, Health Connect, coach)",
    "intro": "Metria è un'app di allenamento pubblicata con il nome Heraion da Antenore Gatta, in Svizzera. Heraion non è una società registrata: il titolare del trattamento dei tuoi dati è una persona fisica, ed è con lei che hai a che fare. Questa informativa spiega cosa raccogliamo, perché, dove vivono i dati, quanto restano e cosa puoi chiederci.",
    "section1Title": "Cosa raccogliamo",
    "section1Body": "Solo ciò che serve all'app per funzionare, più ciò che scegli di metterci dentro. Per avere un account: il tuo indirizzo email, che è anche l'identificativo dell'account, e una password, che Amazon Cognito conserva solo come impronta crittografica — il testo in chiaro non arriva mai a noi. Nel profilo: un nome visualizzato, che è obbligatorio e può benissimo essere un soprannome invece del tuo nome anagrafico, e, se li compili, una fascia d'età e il sesso biologico, che l'app usa per le formule della massa grassa e per la figura del corpo che disegna. Poi tutto ciò che inserisci allenandoti: allenamenti, serie, carichi, programmi, note, record personali e, se usi quelle parti dell'app, misure corporee, peso, segnalazioni di dolore e valori di salute. Non ti chiediamo l'indirizzo postale, il numero di telefono, la data di nascita né dati di pagamento, e non usiamo analytics, pubblicità o tracciamento: da nessuna parte esiste un profilo comportamentale che ti riguarda. Peso, misure corporee, segnalazioni di dolore e tutto ciò che leggiamo da Health Connect sono dati sanitari — categoria particolare ai sensi dell'art. 9 GDPR e dati degni di particolare protezione ai sensi dell'art. 5 lett. c nLPD — quindi non vengono mai aggregati, non finiscono mai nei nostri log e se ne vanno insieme al tuo account.",
    "section2Title": "Dove vivono i dati, e chi altro li tocca",
    "section2Body": "Tutti i dati sono archiviati nella regione AWS eu-central-2 (Zurigo, Svizzera). Amazon Web Services è l'unico responsabile del trattamento di cui ci serviamo: l'autenticazione gira su Amazon Cognito, i dati strutturati su Amazon DynamoDB, il codice del server su AWS Lambda, e i file statici dell'app sono serviti da Amazon CloudFront. Non utilizziamo alcun servizio di analytics, pubblicità o tracciamento, non vendiamo né affittiamo i tuoi dati e non li consegniamo a nessun altro. Le uniche due strade per cui i tuoi dati vanno più lontano sono le due che accendi tu: Health Connect sul telefono e un coach che inviti. Ciascuna ha la sua sezione qui sotto.",
    "section3Title": "I tuoi diritti",
    "section3Body": "Dall'app puoi esportare l'intero set dei tuoi dati in JSON e puoi cancellare definitivamente il tuo account; la cancellazione rimuove il record di autenticazione e tutto ciò che è archiviato sotto il tuo account, senza alcun soft-delete dietro. Oltre a questi due pulsanti hai i diritti che la legge ti riconosce: sapere cosa abbiamo su di te, farlo correggere, farlo cancellare, riceverne una copia in un formato portabile, opporti a un trattamento o chiederne la limitazione, e revocare un consenso che avevi dato — la revoca ci ferma da lì in avanti e non rende illecito ciò che è stato fatto finché valeva. Scrivi a {{email}} e ti risponde una persona. Se pensi che abbiamo trattato male i tuoi dati puoi anche rivolgerti a un'autorità di controllo: in Svizzera l'Incaricato federale della protezione dei dati e della trasparenza, nell'Unione europea l'autorità del paese in cui vivi.",
    "section4Title": "Chi è responsabile, e come raggiungerci",
    "section4Body": "Il titolare del trattamento dei tuoi dati è Antenore Gatta, che pubblica Metria con il nome Heraion dalla Svizzera. Heraion è il nome di un progetto, non una società registrata, quindi la responsabilità qui è personale e non societaria. Domande, richieste e reclami: {{email}}.",
    "section5Title": "Base giuridica",
    "section5Body": "L'account e i tuoi dati di allenamento sono trattati per fornirti il servizio che hai chiesto — l'esecuzione dell'accordo fra noi, art. 6 par. 1 lett. b GDPR, e lo stesso scopo ai sensi della legge svizzera sulla protezione dei dati. I dati sanitari — peso, misure corporee, segnalazioni di dolore e tutto ciò che leggiamo da Health Connect — sono trattati solo sul tuo consenso esplicito, art. 9 par. 2 lett. a GDPR, che dai accendendo quella parte dell'app e revochi spegnendola o cancellando i dati. Non allunghiamo l'interesse legittimo per coprire qualcosa che non ti aspetteresti, e aggiorneremo questa informativa prima di aggiungere qualsiasi nuova finalità.",
    "section6Title": "Chi può usare Metria",
    "section6Body": "Metria non è pensata per i bambini. Per avere un account devi avere almeno 13 anni, o l'età superiore richiesta dalla legge del tuo paese. Al di sotto di quell'età deve acconsentire per te un genitore o chi esercita la responsabilità genitoriale, che ne supervisiona l'uso. Gli account non si aprono con una registrazione pubblica: ti invita qualcuno che è già in Metria e l'account viene creato per te, quindi un invito indirizzato a un minorenne deve essere accettato da un genitore o da chi esercita la responsabilità genitoriale.",
    "section7Title": "Quanto conserviamo, e cosa toglie la cancellazione",
    "section7Body": "Finché il tuo account esiste, ciò che hai inserito resta: non facciamo scadere il tuo storico e non lo spostiamo altrove quando smetti di allenarti. Qualcosa dura di meno, ed è voluto. Quando cancelli un allenamento, al suo posto resta un segnaposto per 30 giorni, così un dispositivo che era offline viene a sapere che la seduta non c'è più; poi se ne va anche quello. Una cache che impedisce a una richiesta di essere applicata due volte tiene la sua voce per 24 ore. Il nostro database ha un backup continuo e può essere ripristinato a qualsiasi istante dei 35 giorni precedenti, quindi un dato che hai cancellato può ancora esistere dentro un backup per quel tempo prima di essere irrecuperabile — un backup lo ripristiniamo solo per riparare un guasto, mai per far tornare un account che qualcuno ha cancellato. La cancellazione dell'account rimuove il record di autenticazione e ogni record archiviato sotto di esso, compreso ciò che era stato importato da Health Connect e il legame con il coach da entrambe le parti; passata la finestra di backup non ne resta nulla. Una cosa sola viene tenuta e staccata invece che cancellata: una segnalazione che ci hai mandato dall'app resta, perché parla dell'app e non di te, ma da lei viene tolto chi l'ha scritta.",
    "section8Title": "Health Connect",
    "section8Body": "Su Android, Metria può collegarsi a Health Connect. È spento finché non lo accendi nelle impostazioni, Health Connect ti chiede di concedere ogni tipo di dato separatamente, e l'app funziona anche senza. Quando è acceso, Metria legge i tuoi allenamenti insieme a frequenza cardiaca, calorie attive e distanza, così una seduta registrata dall'orologio compare nella tua timeline con il suo sforzo; il tuo peso, la massa grassa e la massa magra, così la sezione del corpo mostra uno storico solo invece di due; e le tue glicemie e i dati di nutrizione, così la scheda metabolica può mettere i carboidrati di oggi e le tue letture di glicemia accanto all'allenamento. Metria riscrive in Health Connect due cose sole, e solo quelle che hai inserito qui tu: una pesata e una lettura di glicemia, così un valore digitato in Metria non resta prigioniero di Metria. Ciò che leggiamo lascia il telefono: è archiviato sui nostri server a Zurigo con il resto dei tuoi dati e alle stesse regole — mai usato per pubblicità, mai venduto, mai passato a terzi, mai usato per addestrare un modello. Resta finché non cancelli quei dati o l'account, come descritto nella sezione precedente. Puoi scollegarti dalle impostazioni di Metria o revocare i permessi da Health Connect stesso in qualsiasi momento: l'una o l'altra cosa ferma ogni ulteriore lettura, e i valori già importati restano tuoi da cancellare dentro Metria.",
    "section9Title": "Se hai un allenatore",
    "section9Body": "Metria può collegare un atleta e un allenatore. Il legame parte da un invito indirizzato a un indirizzo email, che conserviamo sull'invito perché solo chi ha quell'indirizzo possa accettarlo e che viene cancellato quando il legame diventa attivo. Finché il legame è attivo l'allenatore può leggere il lato allenamento dell'atleta — sedute e loro risultati, programmi e obiettivi, massimali e record, e il profilo — e non può cambiare nulla, a meno che l'atleta gli abbia concesso il diritto di fissare gli obiettivi; un allenatore non può concederselo da solo. Entrambe le parti possono chiudere il legame dall'app in qualsiasi momento, e chiuderlo ferma l'accesso. Invitare un atleta più giovane dell'età indicata nella sezione precedente richiede l'accordo di un genitore o di chi esercita la responsabilità genitoriale: quell'accordo è responsabilità di chi manda l'invito, e Metria non lo chiede né lo verifica.",
    "back": "Indietro"
  },
  "terms": {
    "linkLabel": "Condizioni",
    "title": "Condizioni d'uso",
    "lastUpdated": "Ultimo aggiornamento: 9 settembre 2026 (chi siamo, come si accetta, lingue)",
    "intro": "Queste condizioni sono l'accordo fra te e noi per l'uso di Metria. Usando l'app le accetti. Se non le accetti, non usare Metria.",
    "section1Title": "Chi siamo",
    "section1Body": "Metria è pubblicata con il nome Heraion da Antenore Gatta, in Svizzera. Heraion è il nome del progetto, non una società registrata: la persona con cui stai contrattando è una persona fisica. Puoi scriverci a {{email}}.",
    "section2Title": "Queste condizioni",
    "section2Body": "Gli account non si aprono con una registrazione pubblica: ti invita qualcuno che è già in Metria e l'account viene creato per te. Usando Metria una volta che l'account esiste — accedendo, registrando un allenamento — accetti queste condizioni, che diventano l'accordo fra te e noi. Se non le accetti, non usare Metria e chiedici di cancellare l'account. Se sei un consumatore, nulla di quanto è scritto qui ti toglie un diritto che la legge del tuo paese ti riconosce e a cui non puoi rinunciare.",
    "section3Title": "Chi può usare Metria",
    "section3Body": "Per avere un account devi avere almeno 13 anni, o l'età superiore richiesta dalla legge del tuo paese. Al di sotto di quell'età deve accettare queste condizioni per te un genitore o chi esercita la responsabilità genitoriale, che ne supervisiona l'uso. L'account è personale: tieni la password per te e avvisaci se pensi che qualcun altro la conosca.",
    "section4Title": "Metria non dà consigli medici",
    "section4Body": "Metria è uno strumento di allenamento. Non è un dispositivo medico e non dà consigli medici. I carichi, le ripetizioni e i tempi di recupero che mostra sono proposte calcolate dai numeri che hai inserito, non una prescrizione: decidi tu cosa sollevare, e ti alleni a tuo rischio. L'allenamento con i pesi può causare infortuni. Se hai una condizione medica o un infortunio, se sei incinta o se torni ad allenarti dopo una lunga pausa, parla con un medico prima di cominciare — e fermati quando qualcosa fa male. Ogni segnalazione di dolore, misura corporea o valore di salute che l'app mostra, compreso ciò che arriva da Health Connect, è la registrazione di ciò che hai inserito tu o il tuo dispositivo, mai una diagnosi: Metria non rileva e non monitora alcuna condizione medica.",
    "section5Title": "Ciò che inserisci resta tuo",
    "section5Body": "Gli allenamenti, i programmi, le misure e le note che inserisci appartengono a te. Per far funzionare il servizio ci serve una licenza limitata per conservarli, salvarli, elaborarli e mostrarli — a te e alle persone con cui hai scelto di condividerli. Nulla di più, e finisce quando cancelli i dati o l'account. Cosa raccogliamo e perché sta nell'informativa privacy.",
    "section6Title": "Coach e atleti",
    "section6Body": "Se inviti qualcuno come suo coach, devi avere prima il suo accordo, e il suo accordo su ciò che potrai vedere. I suoi dati restano suoi: il tuo accesso dipende dal ruolo che ha nell'app e lui può revocarlo. Se l'atleta è più giovane dell'età indicata nella sezione precedente, devi avere l'accordo di un genitore o di chi esercita la responsabilità genitoriale prima di invitarlo.",
    "section7Title": "Uso corretto",
    "section7Body": "Usa Metria nel rispetto della legge. Non tentare di raggiungere account, dati o parti del servizio che non sono tuoi, non estrarne i contenuti né rivenderli, non caricare contenuti illeciti e non inserire i dati di un'altra persona senza il suo accordo.",
    "section8Title": "Prezzo",
    "section8Body": "Oggi Metria è gratuita. Se introdurremo funzioni a pagamento lo diremo chiaramente e in anticipo, e il pagamento passerà dallo store di Apple o di Google, le cui regole governano addebito, rinnovo e rimborsi. Un contenuto digitale che parte subito su tua richiesta può non avere diritto di recesso; dove la legge te lo riconosce, resta tuo.",
    "section9Title": "Disponibilità e modifiche",
    "section9Body": "Forniamo Metria così com'è e per come è disponibile: non promettiamo che sarà ininterrotta o priva di errori. Possiamo aggiungere, cambiare o togliere funzioni, e prima di una modifica che riduce in modo sensibile qualcosa su cui contavi te lo diremo dentro l'app.",
    "section10Title": "Come finisce",
    "section10Body": "Puoi smettere quando vuoi: cancella i tuoi dati o il tuo account dall'app. Possiamo sospendere o chiudere un account che viola queste condizioni o che siamo tenuti a chiudere per legge, e a meno che non sia illecito o irragionevole te ne diremo prima il motivo. La cancellazione dell'account rimuove i tuoi dati come descritto nell'informativa privacy.",
    "section11Title": "Responsabilità",
    "section11Body": "Rispondiamo dei danni causati da dolo o colpa grave, delle lesioni alla vita, all'integrità fisica o alla salute, e di tutto ciò che la legge non ci consente di escludere — inclusi i tuoi diritti inderogabili di consumatore. Oltre a questo non rispondiamo di danni indiretti o imprevedibili, degli infortuni derivanti dall'allenamento che hai scelto di fare, né dei dati persi perché non erano stati esportati.",
    "section12Title": "App di Apple e Google",
    "section12Body": "Se usi l'app iOS, questo accordo è fra te e noi, non con Apple. Apple non è responsabile dell'app né di alcuna pretesa che la riguardi e non fornisce assistenza; Apple e le sue controllate possono far valere questo accordo come terzi beneficiari. Se usi l'app Android valgono anche le regole dello store da cui l'hai installata.",
    "section13Title": "Modifiche a queste condizioni",
    "section13Body": "Possiamo modificare queste condizioni. La nuova versione viene pubblicata qui con la sua data e, per le modifiche che ti riguardano davvero, te lo diremo dentro l'app prima che abbiano effetto. Se continui a usare Metria dopo, vale la nuova versione.",
    "section14Title": "Legge e controversie",
    "section14Body": "Si applica il diritto svizzero. Se sei un consumatore conservi anche la protezione delle norme inderogabili del paese in cui vivi e puoi rivolgerti ai giudici di quel paese. I consumatori dell'Unione europea possono usare anche la piattaforma europea di risoluzione delle controversie online su ec.europa.eu/consumers/odr.",
    "section15Title": "Lingue",
    "section15Body": "Queste condizioni sono pubblicate in inglese, italiano, francese, tedesco e russo. L'inglese è la lingua in cui sono state redatte ed è la versione che prevale se una traduzione dice qualcosa di diverso — salvo dove la legge del tuo paese dia la precedenza alla versione nella tua lingua, nel qual caso vale quella per te. L'informativa privacy è pubblicata nelle stesse cinque lingue, allo stesso titolo.",
    "back": "Indietro"
  },
  "errors": {
    "generic": "Qualcosa è andato storto."
  },
  "feedback": {
    "title": "Invia feedback",
    "help": "Hai trovato un bug, vuoi una feature o qualcos'altro? Scrivilo qui. I messaggi finiscono nella inbox dell'admin.",
    "kindLabel": "Tipo",
    "kind_bug": "Bug",
    "kind_feature": "Richiesta funzionalità",
    "kind_other": "Altro",
    "kind_crash": "Segnalazione crash",
    "bodyLabel": "Cosa è successo?",
    "bodyPlaceholder": "Descrivi cosa hai visto, cosa ti aspettavi e come riprodurlo.",
    "send": "Invia",
    "sending": "Invio…",
    "sentFlash": "Grazie — inviato.",
    "sentHint": "Lo gestiremo nella prossima sessione. Puoi chiudere.",
    "close": "Chiudi",
    "errEmpty": "Scrivi qualcosa prima di inviare.",
    "errSubmit": "Invio non riuscito. Riprova fra poco.",
    "errRateLimit": "Troppi invii nell'ultima ora. Riprova più tardi.",
    "inboxTitle": "Inbox feedback",
    "loading": "Caricamento feedback…",
    "empty": "Nessun feedback da mostrare.",
    "filterAll": "Tutti",
    "loadMore": "Carica altri",
    "status_open": "Aperto",
    "status_in_progress": "In corso",
    "status_shipped": "Risolto",
    "status_wontfix": "Non risolto",
    "priorityLabel": "Priorità",
    "priorityNone": "Nessuna",
    "statusLabel": "Stato",
    "head_open": "{{count}} aperti",
    "head_in_progress": "{{count}} in corso",
    "head_shipped": "{{count}} risolti",
    "head_wontfix": "{{count}} non risolti",
    "headTotal": "{{count}} in totale"
  },
  "profile": {
    "title": "Profilo",
    "loading": "Caricamento profilo…",
    "name": "Nome visualizzato",
    "namePlaceholder": "Come dobbiamo chiamarti?",
    "role": "Ruolo",
    "roleCoach": "Coach",
    "roleAthlete": "Atleta",
    "roleBoth": "Entrambi",
    "ageBucket": "Fascia d'età (facoltativa)",
    "ageBucketHelp": "Utilizzata solo per statistiche di gruppo anonime opt-in. Resta vuota se non la compili.",
    "ageBucketNone": "Preferisco non rispondere",
    "unitsPreference": "Unità preferita",
    "unitsPreferenceHelp": "I pesi sono sempre archiviati in chilogrammi. Per ogni serie potrai cambiare l'unità di input.",
    "preferredFigure": "Figura del corpo sulla bodymap",
    "preferredFigureHelp": "Scegli la figura delle mappe muscolari.",
    "figure_masculine": "Maschile",
    "figure_feminine": "Femminile",
    "save": "Salva",
    "saving": "Salvataggio…",
    "saved": "Profilo salvato.",
    "agePrefix_under_18": "Meno di 18",
    "age_18-24": "18-24",
    "age_25-29": "25-29",
    "age_30-34": "30-34",
    "age_35-39": "35-39",
    "age_40-44": "40-44",
    "age_45-49": "45-49",
    "age_50-54": "50-54",
    "age_55-59": "55-59",
    "age_60-64": "60-64",
    "age_65-69": "65-69",
    "age_70-plus": "70+",
    "bodyweight": "Peso corporeo (facoltativo)",
    "bodyweightPlaceholder": "es. 78",
    "bodyweightHelp": "Serve solo a calcolare il carico effettivo negli esercizi a corpo libero. Mai aggregato, mai nei log, cancellato con l'account.",
    "errBodyweight": "Inserisci un peso tra 20 e 300 kg (o l'equivalente in lb).",
    "apk": {
      "title": "APK Android (build di test)",
      "hint": "Build di test ad uso famiglia. Su Android abilita «Installa da app sconosciute» nel browser, poi apri il file.",
      "download": "Scarica APK"
    },
    "email": "Email",
    "metaTitle": "Sessione"
  },
  "workout": {
    "title": "Allenamenti",
    "loading": "Caricamento allenamenti…",
    "empty": "Nessun allenamento registrato.",
    "logNew": "Registra allenamento",
    "startedAt": "Quando",
    "exercise": "Esercizio",
    "exercisePlaceholder": "Scegli un esercizio",
    "errPickExercise": "Scegli un esercizio dal catalogo.",
    "catalogEmptyCoach": "Il catalogo è vuoto. Aggiungi almeno un esercizio prima di registrare un allenamento.",
    "catalogEmptyAthlete": "Il catalogo è vuoto. Uno dei tuoi coach deve aggiungere gli esercizi prima che tu possa registrare un allenamento.",
    "setsLegend": "Serie",
    "set": "Serie",
    "reps": "Ripetizioni",
    "amrapHint": "AMRAP — supera il floor prescritto",
    "weight": "Peso",
    "extra": "Extra (+/−)",
    "unit": "Unità",
    "rpe": "RPE",
    "addSet": "Aggiungi serie",
    "removeSet": "Rimuovi serie",
    "notes": "Note (facoltative)",
    "setNoteToggle": "Aggiungi una nota a questa serie",
    "setNotePlaceholder": "Cosa è cambiato in questa serie",
    "prefillFromDate": "Pre-compila da {{date}}?",
    "prefillAccept": "Usa",
    "savePromptTitle": "Verifica prima di salvare",
    "savePromptContinue": "Torna al workout",
    "savePromptAnyway": "Salva comunque",
    "unmarkedPromptBody": "{{count}} serie con valori ma senza marcatura.",
    "unmarkedPromptFail": "Marca come fallite e salva",
    "unmarkedPromptComplete": "Marca come fatte e salva",
    "outlierPromptBody": "{{count}} voci sembrano anomale:",
    "outlierItem": "{{exercise}}: {{weight}} (max storico {{expected}})",
    "outlierE1rmItem": "{{exercise}}: 1RM stimato {{e1rm}} (max storico {{expected}})",
    "outlierPerImplementItem": "{{exercise}}: {{weight}} è circa il doppio del tuo solito {{expected}} — hai inserito il peso di UN solo attrezzo o il totale dei due?",
    "outlierRepsItem": "{{exercise}}: {{reps}} ripetizioni — sembrano troppe",
    "outlierZeroWeightItem": "{{exercise}}: {{reps}} ripetizioni senza peso",
    "save": "Salva",
    "saving": "Salvataggio…",
    "saved": "Allenamento salvato.",
    "savedEdit": "Allenamento aggiornato.",
    "deleted": "Allenamento eliminato.",
    "cancel": "Annulla",
    "errNoSets": "Aggiungi almeno una serie valida.",
    "creatingTitle": "Nuovo allenamento",
    "editingTitle": "Modifica allenamento",
    "exerciseN": "Esercizio {{n}}",
    "addExercise": "Aggiungi un altro esercizio",
    "removeExercise": "Rimuovi esercizio",
    "removeExerciseConfirm": "Rimuovere {{name}} da questo allenamento? Le serie già registrate andranno perse.",
    "groupAlignTitle": "Numero di serie diverso",
    "groupAlignBody": "I membri di questo gruppo hanno tra {{shortest}} e {{longest}} serie. Allinearli per far quadrare i giri?",
    "groupAlignPad": "+ Allunga a {{n}}",
    "groupAlignTrim": "− Accorcia a {{n}}",
    "groupAlignTrimWarning": "Accorciare cancella serie già registrate, e non si torna indietro.",
    "groupAlignTrimHint": "Cancella le serie in eccesso da ogni membro del gruppo. Non si torna indietro.",
    "groupAlignKeep": "Mantieni così",
    "splitGroup": "Sciogli",
    "splitGroupTitle": "Sciogliere il gruppo?",
    "splitGroupBody": "I membri mantengono le loro serie e restano nel workout, solo non più collegati. Puoi riformare il gruppo quando vuoi.",
    "splitGroupConfirm": "Sciogli",
    "removeRoundConfirmTitle": "Rimuovere questo giro?",
    "removeRoundConfirmBody": "Il giro {{n}} di {{names}} verrà eliminato insieme.",
    "bilateral": "Bilaterale",
    "unilateral": "Unilaterale",
    "edit": "Modifica",
    "repeat": "Ripeti",
    "delete": "Elimina",
    "deleting": "Eliminazione…",
    "deleteConfirm": "Eliminare questo allenamento?",
    "distance": "m",
    "duration": "s",
    "cardioDuration": "Durata",
    "cardioDistance": "Distanza",
    "cardioWeight": "Peso",
    "cardioHr": "FC media",
    "cardioCalories": "Calorie",
    "cardioOptionalsShow": "Altri campi",
    "cardioOptionalsHide": "Altri campi",
    "dateEditor": "Data e durata",
    "dateLabel": "Data",
    "startTimeLabel": "Inizio",
    "endTimeLabel": "Fine",
    "durationLabel": "Durata",
    "side": "Lato",
    "sideLeft": "Sinistro",
    "sideRight": "Destro",
    "sideBoth": "Entrambi",
    "showRpe": "Mostra RPE",
    "showDuration": "Mostra durata",
    "rir": "RIR {{n}}",
    "swap": "Cambia",
    "swapHint": "Panca occupata? Scegli un esercizio simile.",
    "descriptionToggle": "Mostra / nascondi descrizione",
    "failShort": "F",
    "failToggle": "Segna la serie come fallita",
    "failHint": "Ultima rep non chiusa. Conta nel volume, esclusa dai PR.",
    "startRest": "Avvia il timer di recupero",
    "restStartDefault": "Avvia recupero ({{n}}s)",
    "restStartCustom": "Avvia recupero ({{n}}s, default dell'esercizio)",
    "setComplete": "Segna la serie come fatta",
    "setCompleteHint": "Timbra la serie e parte il recupero da {{n}}s.",
    "setCompleteHintCustom": "Timbra la serie e parte il recupero da {{n}}s (default dell'esercizio).",
    "setUndo": "Annulla il completamento",
    "setUndoHint": "Tocca di nuovo per annullare e resettare il recupero.",
    "restLeft": "Recupero",
    "restDone": "Tempo scaduto",
    "restStop": "Stop",
    "restPause": "Pausa",
    "restResume": "Riprendi",
    "restSound": "Bip a fine recupero",
    "instructions": "Indicazioni del coach (opzionale)",
    "instructionsPlaceholder": "Focus della sessione, cosa saltare se manca tempo, intento.",
    "lastTime": "Ultima",
    "lastToday": "oggi",
    "lastDaysAgo": "{{n}}g fa",
    "dropsetShort": "Drop",
    "dropsetToggle": "Aggiungi catena dropset",
    "dropsetTitle": "Dropset",
    "dropsetVariant": "Variante",
    "dropsetClassical": "Classico (peso scende)",
    "dropsetMyorep": "Myo-rep (stesso peso)",
    "dropsetHintClassical": "Cala il carico del 10–30% e chiudi a cedimento. Niente pausa.",
    "dropsetHintMyorep": "Stesso peso, meno reps, 10–20s di respiro, ripeti.",
    "dropsetSameLoad": "= sopra",
    "dropsetAddStep": "Aggiungi drop",
    "dropsetRemove": "Rimuovi",
    "dropsetRemoveConfirm": "Hai {{n}} drop step. Convertire di nuovo in working set e scartarli?",
    "dropsetRemoveStep": "Rimuovi drop",
    "groupLabel": "Gruppo",
    "groupNone": "(nessuno)",
    "groupCreate": "Crea nuovo",
    "groupNewSuperset": "Nuovo superset",
    "groupNewCircuit": "Nuovo circuit",
    "groupJoinExisting": "Unisci a un gruppo esistente",
    "groupLeave": "Sciogli",
    "groupSharedHint": "Condiviso. Apri un altro esercizio e seleziona lo stesso gruppo dalla tendina per accoppiarli.",
    "supersetN": "Superset {{n}}",
    "circuitN": "Circuit {{n}}",
    "supersetDerived": "Superset (auto)",
    "supersetDerivedTitle": "Rilevato dall'alternanza dei set in questa sessione",
    "playActiveTitle": "Esercizio attivo — set completato più di recente",
    "errGroupKindMixed": "Un gruppo non può mischiare superset e circuit. Scegli un solo tipo.",
    "exerciseNew": "Nuovo esercizio",
    "cardMenu": "Opzioni esercizio",
    "menuReplace": "Sostituisci esercizio",
    "menuGroup": "Gruppo / superset",
    "menuMoveUp": "Sposta su",
    "menuMoveDown": "Sposta giù",
    "menuShowNotes": "Mostra note",
    "menuHideNotes": "Nascondi note",
    "menuShowDescription": "Mostra descrizione",
    "menuHideDescription": "Nascondi descrizione",
    "tipAlternatives": "Esercizi alternativi",
    "tipCoachNote": "Nota del coach",
    "perImplementHint": "Ne usi due, o un lato per volta? Scrivi il peso di uno solo. L'app conta entrambi (×2).",
    "tipProgramNote": "In questo programma",
    "tipNoAlternatives": "Nessun esercizio simile in catalogo",
    "tipClose": "Chiudi",
    "painBanner": {
      "red": "Sollecita un muscolo dolorante",
      "yellow": "Attenzione: carica un muscolo segnalato",
      "green": "Nessun rischio segnalato"
    },
    "setCycleHint": "Tap: chiusa · ancora: fallita · ancora: annulla",
    "setStatePending": "Serie aperta",
    "setStateDone": "Serie chiusa",
    "setStatePr": "Serie chiusa, record personale",
    "setStateFailed": "Serie segnata come fallita",
    "prShort": "🏆",
    "addDrop": "+ drop",
    "groupBannerSuperset": "SUPERSET",
    "groupBannerCircuit": "CIRCUIT",
    "groupAutoTag": "AUTO",
    "groupAutoConfirm": "Conferma",
    "groupAutoConfirmAria": "Blocca il gruppo: termina la rilevazione e tieni gli esercizi raggruppati",
    "groupAutoDismissAria": "Ignora la rilevazione: gli esercizi tornano a essere singoli",
    "groupAddSetAll": "Aggiungi serie a tutti",
    "nameLabel": "Nome (opzionale)",
    "namePlaceholder": "Es. Push A · Lower Quad-Dominant",
    "durationStepperA11y": "stepper durata",
    "rirLabel": "RIR",
    "showRir": "Mostra RIR",
    "maxDownA11y": "Il MAX potrebbe essere sceso",
    "animationOf": "Animazione di {{name}}",
    "animationZoomHint": "Apre l'animazione a tutto schermo",
    "closeAnimation": "Chiudi l'animazione",
    "showAnimation": "Mostra l'animazione",
    "showBodyMap": "Mostra i muscoli coinvolti",
    "pagerDot": "{{target}}, {{current}} di {{total}}",
    "pagePrev": "Pagina precedente",
    "pageNext": "Pagina successiva",
    "editUnsupportedTitle": "Modifica non ancora supportata",
    "editUnsupportedBody": "Questo workout contiene tipi di esercizi (P1RM, loaded carry) che il logger non sa ancora modificare."
  },
  "program": {
    "title": "Programmi",
    "help": "Cicli di allenamento multi-settimana. La fase 5.1 spedisce lo scheletro: nome, settimane, sessioni per settimana. Il builder di slot e progressione arriva nella prossima fase.",
    "new": "Nuovo programma",
    "newTitle": "Nuovo programma",
    "name": "Nome",
    "namePlaceholder": "es. Powerbuilding 6 settimane",
    "cycleWeeks": "Settimane del ciclo",
    "sessionsPerWeek": "Sessioni a settimana",
    "description": "Descrizione",
    "descriptionPlaceholder": "A cosa serve il ciclo, a chi è rivolto, eventuali note per gli atleti.",
    "create": "Crea",
    "creating": "Nuovo programma: {{name}}",
    "cancel": "Annulla",
    "delete": "Elimina",
    "deleteConfirm": "Confermi?",
    "deleteConfirmYes": "Sì, elimina",
    "loading": "Caricamento programmi…",
    "empty": "Nessun programma ancora. Creane uno per pianificare un ciclo multi-settimana.",
    "statusDraft": "Bozza",
    "statusActive": "Attivo",
    "statusArchived": "Archiviato",
    "cycleWeeksLabel": "Ciclo di {{n}} settimane",
    "sessionsPerWeekLabel": "{{n}}× / settimana",
    "slotCount": "{{n}} slot",
    "skeletonHint": "Solo scheletro. Gli slot si riempiono nella prossima fase.",
    "sessionDefaultName": "Sessione {{n}}",
    "edit": "Modifica",
    "editing": "Modifica: {{name}}",
    "assign": "Assegna",
    "backToList": "Torna ai programmi",
    "save": "Salva",
    "saving": "Salvataggio…",
    "errSave": "Impossibile salvare il programma.",
    "metaLegend": "Programma",
    "status": "Stato",
    "metaCyclesLive": "Le modifiche strutturali (giorni, settimane) si applicano subito",
    "ordinalSession": "{{n}}ª sessione",
    "sessionName": "Nome sessione",
    "slotN": "Slot {{n}}",
    "addSlot": "Aggiungi slot",
    "removeSlot": "Elimina",
    "moveUp": "Sposta su",
    "moveDown": "Sposta giù",
    "exercise": "Esercizio",
    "exercisePick": "Scegli un esercizio",
    "setsLegend": "Set",
    "addSet": "Aggiungi set",
    "removeSet": "Elimina set",
    "reps": "Reps",
    "setNotesPlaceholder": "Nota per il set (opzionale)",
    "set": "Set",
    "intensityKind": "Intensità",
    "intensityNone": "Libera",
    "intensityPercent": "% del MAX",
    "intensityAbs": "kg (assoluti)",
    "intensityRpe": "RPE",
    "intensity_percent-of-max": "Percentuale",
    "intensity_absolute": "Peso (kg)",
    "intensity_rpe": "RPE",
    "weekShort": "S{{n}}",
    "previewShow": "Anteprima",
    "previewHide": "Nascondi anteprima",
    "previewMuscles": "Muscoli coinvolti",
    "previewSets": "{{n}} set",
    "previewEmptySession": "Nessuno slot in questa sessione.",
    "previewEmptyProgram": "Nessuno slot ancora. Apri Modifica per aggiungerli.",
    "start": "Avvia sessione",
    "startCancel": "Annulla",
    "startGo": "Avvia",
    "starting": "Avvio in corso…",
    "startWeek": "Settimana",
    "startSession": "Sessione",
    "progressNext": "Prossima: S{{w}} · Sessione {{s}}",
    "instructions": "Istruzioni",
    "instructionsPlaceholder": "Tempo, durata pausa, focus tecnico, RPE target.",
    "amrapLastSet": "AMRAP sull'ultimo set",
    "maxAttempt": "Tentativo 1MAX",
    "amrapBadge": "AMRAP",
    "maxBadge": "1MAX",
    "slotCycleHint": "Applicato sulle {{n}} settimane del ciclo.",
    "catalogLoading": "Caricamento del catalogo esercizi…",
    "builderComingSoon": "Il builder di slot e progressione arriva con la fase 5.2. Per ora questo crea uno scheletro vuoto, eliminabile o riempibile dopo.",
    "errCycleWeeks": "Le settimane devono essere tra 1 e 12.",
    "errSessionsPerWeek": "Le sessioni a settimana devono essere tra 1 e 7.",
    "errName": "Il nome del programma è obbligatorio.",
    "errSchema": "Dati del programma non validi.",
    "errCreate": "Impossibile creare il programma.",
    "errCode": {
      "sessionNameEmpty": "Ogni giorno di allenamento deve avere un nome.",
      "slotNoExercise": "Scegli un esercizio per ogni slot.",
      "slotNoSets": "Ogni esercizio deve avere almeno una serie.",
      "slotAllWeeksInactive": "Un esercizio è disattivato in tutte le settimane. Attiva una settimana o rimuovilo.",
      "rowWidthMismatch": "Una riga di serie non corrisponde al numero di settimane. Riapri l'esercizio e riprova.",
      "invalidReps": "Controlla le ripetizioni: usa un numero come 8, oppure 8+ per l'AMRAP.",
      "groupKindMixed": "Un superset mescola tipi di serie diversi. Dai lo stesso tipo ai suoi esercizi.",
      "schemaInvalid": "Dati del programma non validi.",
      "noSession": "Non c'è nessun allenamento da salvare.",
      "planNameEmpty": "Il nome del piano è obbligatorio.",
      "planNoExercises": "Aggiungi almeno un esercizio al piano.",
      "invalidIntensityValue": "Controlla il valore di intensità: deve essere un numero.",
      "weightOutOfRange": "Questo peso è fuori intervallo.",
      "pctOutOfRange": "La percentuale deve essere tra 0 e 200.",
      "rpeOutOfRange": "L'RPE deve essere tra 1 e 10.",
      "rirOutOfRange": "Il RIR deve essere tra 0 e 10.",
      "unknownIntensityKind": "Tipo di intensità sconosciuto.",
      "invalidSeconds": "Controlla i secondi: un set a tempo vuole una durata, in secondi interi fino a 3600.",
      "invalid_email": "Quell'indirizzo email non è valido.",
      "email_not_found": "Nessun account trovato con quell'email.",
      "too_many_assignees": "Massimo 20 persone per programma.",
      "programNameEmpty": "Il nome del programma è obbligatorio.",
      "sessionEmpty": "Ogni giorno di allenamento deve avere almeno un esercizio.",
      "sessionTooManyExercises": "Un giorno di allenamento può avere al massimo 20 esercizi.",
      "amrapWithTime": "Una serie a tempo non può essere anche AMRAP. Togli una delle due.",
      "client_outdated": "Aggiorna l'app per salvare questo programma.",
      "invalidRepsRange": "Controlla l'intervallo: un minimo e un massimo attorno all'obiettivo, come 8-12 attorno a 10."
    },
    "cardMenu": "Menù slot",
    "menuGroup": "Gruppo",
    "groupNone": "Nessun gruppo",
    "groupJoinExisting": "Aggiungi a un gruppo",
    "groupCreate": "Crea",
    "groupNewSuperset": "Nuovo superset",
    "groupNewCircuit": "Nuovo circuito",
    "groupSupersetN": "Superset {{letter}}",
    "groupCircuitN": "Circuito {{letter}}",
    "assignTo": "Assegna agli atleti",
    "assignToHelp": "Assegnarlo è una proposta: entra nella libreria solo se accetta, e ciò che ha accettato resta suo se lo togli. Serve un coach edge attivo con te.",
    "assignSelf": "Tu (autore)",
    "addAssignee": "Aggiungi",
    "removeAssignee": "Rimuovi",
    "removeAssigneeConfirm": "Togliere l'accesso?",
    "removeAssigneeHint": "L'atleta lo perderà dalla sua libreria. Tocca di nuovo per rimuovere.",
    "pendingAssigneeCaption": "In attesa",
    "rosterSectionLabel": "Dal tuo roster",
    "rosterEmpty": "Nessun atleta nel tuo roster.",
    "rosterAllAssigned": "Tutti gli atleti del tuo roster sono già assegnati.",
    "shareTo": "Condividi con",
    "shareToHelp": "Condividere è una proposta: arriva nella loro libreria solo se accettano, e ciò che hanno accettato resta loro anche se li rimuovi.",
    "shareSectionLabel": "Persone con cui condividere",
    "shareEmpty": "Non hai ancora nessuno con cui condividere.",
    "shareAllShared": "Tutti quelli con cui puoi condividere ce l'hanno già.",
    "emailSectionLabel": "Via email",
    "assigneePlaceholder": "atleta@esempio.com",
    "invalidEmailFormat": "Non sembra un indirizzo email valido.",
    "follow": "Segui",
    "unfollow": "Non seguire",
    "followHint": "Segui questo programma (compare in In corso)",
    "publish": "Pubblica",
    "unpublish": "Riporta a bozza",
    "publishAndFollow": "Pubblica e segui",
    "publishHint": "Rendi questo programma disponibile da seguire",
    "chipDraft": "Bozza",
    "chipPublished": "Pubblicato",
    "chipFollowed": "Seguito",
    "kindShortPercent": "%MAX",
    "kindShortHistory": "STOR",
    "kindShortRpe": "RPE",
    "kindShortRir": "RIR",
    "languageUndeclared": "Lingua",
    "languageA11y": "Lingua di scrittura",
    "languageSwitchQuestion": "In che lingua stai scrivendo?",
    "languageDeclareQuestion": "In che lingua è scritto questo programma?",
    "languageFootnote": "Le traduzioni sono facoltative: un programma in una lingua sola è completo.",
    "languageDeclareFootnote": "Non traduce niente: indica soltanto la lingua.",
    "languageAuto": "Traduzione automatica",
    "languageNotYetWritten": "Manca ancora la versione in {{lang}}. Il testo in {{original}} resta al suo posto.",
    "setBound": "Limite",
    "boundReps": "Reps",
    "boundTime": "Tempo",
    "boundOpen": "Libero",
    "workSeconds": "Lavoro (s)",
    "restSeconds": "Recupero (s)",
    "restSecondsPlaceholder": "auto",
    "prescribeTime": "Tempo",
    "prescribeTimeA11y": "Prescrivi lavoro e recupero in secondi",
    "seconds": "Secondi",
    "amrapNotWithTime": "Un set da {{secs}}s non può essere anche AMRAP: un piano non può chiedere quante ne farai. Togli il + o il tempo.",
    "workSecondsRequired": "Quanto dura?",
    "descriptionAdd": "Aggiungi una descrizione",
    "descriptionExpand": "Apre la descrizione per modificarla",
    "descriptionCollapse": "Chiudi la descrizione",
    "undo": "Annulla",
    "redo": "Ripeti",
    "saveStatus": {
      "saving": "Salvataggio…",
      "unsaved": "Non salvato",
      "queued": "Senza rete",
      "saved": "Salvato"
    },
    "draftConflict": {
      "title": "Il programma è cambiato",
      "body": "È stato modificato altrove dopo l'inizio della tua bozza. Tieni la tua bozza o usa la versione aggiornata? Nulla cambia finché non tocchi Salva.",
      "keepDraft": "Tieni la mia bozza",
      "useUpdated": "Usa la versione aggiornata"
    },
    "savedElsewhere": {
      "body": "È stato modificato altrove dopo che l'hai aperto. Non è stato salvato niente. Se tieni la tua bozza, sostituisce quella versione.",
      "statusNotApplied": "Il cambio di stato non è stato applicato."
    },
    "savedStaysOpen": "Salvato. L'editor resta aperto.",
    "savedQueuedStaysOpen": "In coda: parte quando torna la rete.",
    "newDraft": {
      "title": "Una bozza in corso",
      "body": "Una bozza iniziata su questo dispositivo il {{when}} non è mai stata salvata. Vuoi riprenderla o iniziare da capo e buttarla?",
      "bodyNoTime": "Una bozza iniziata su questo dispositivo non è mai stata salvata. Vuoi riprenderla o iniziare da capo e buttarla?",
      "resume": "Riprendi",
      "startOver": "Inizia da capo"
    },
    "repsRange": "Intervallo",
    "repsRangeMin": "Ripetizioni minime",
    "repsRangeMax": "Ripetizioni massime",
    "prescribeRangeA11y": "Prescrivi un intervallo di ripetizioni sulle serie"
  },
  "me": {
    "targets": {
      "title": "Obiettivi",
      "historyByCoach": "Il tuo coach",
      "errNotFound": "Impossibile trovare i tuoi obiettivi. Torna indietro e riprova."
    }
  },
  "coach": {
    "title": "Coach e atleti",
    "subtitle": "Atleti che alleni e coach che ti allenano. L'invito richiede il consenso di entrambe le parti prima che gli assegnamenti possano fluire.",
    "subLabel": "sub",
    "inviteAthleteLabel": "Invita un atleta via email",
    "invitePlaceholder": "atleta@esempio.com",
    "inviteNotePlaceholder": "Nota (facoltativa)",
    "inviteSend": "Manda invito",
    "inviteSending": "Invio…",
    "inviteSent": "Invito mandato. L'atleta lo vede al prossimo accesso.",
    "athletesHeading": "Atleti che alleno",
    "coachesHeading": "Coach che mi allenano",
    "athletesEmpty": "Nessun atleta. Inviane uno qui sopra.",
    "pendingInLabel": "In attesa di risposta tua",
    "pendingOutLabel": "In attesa di risposta loro",
    "activeLabel": "Attivi",
    "accept": "Accetta",
    "decline": "Rifiuta",
    "cancel": "Annulla invito",
    "revoke": "Revoca",
    "leave": "Lascia coach",
    "busy": "In corso…",
    "loading": "Carico…",
    "loadFailed": "Caricamento fallito. Ricarica per riprovare.",
    "errCode": {
      "invalid_email": "Email malformata.",
      "email_not_found": "Nessun account verificato con quell'email.",
      "peer_required": "Indica un'email o un sub.",
      "edge_exists": "Esiste già un edge con questo peer.",
      "userpool_not_configured": "Server malconfigurato: user pool non disponibile.",
      "io_error": "Errore di rete o server. Riprova.",
      "not_pending": "Questo invito non è più in attesa.",
      "wrong_party": "Solo l'altra parte può accettare questo invito.",
      "missing_claims": "La sessione è scaduta. Accedi di nuovo.",
      "table_not_configured": "Server mal configurato: tabella non disponibile.",
      "not_found": "Questo invito non esiste più."
    },
    "dashboard": {
      "title": "Panoramica squadra",
      "unnamedAthlete": "Atleta",
      "empty": "Ancora nessun atleta",
      "emptySub": "Invita atleti da Coach e atleti per vederli qui.",
      "loading": "Carico la tua squadra…",
      "loadFailed": "Impossibile caricare la squadra. Aggiorna per riprovare.",
      "noProgram": "Nessun programma",
      "kpiAssigned": "Atleti",
      "kpiActive": "Attivi questa settimana",
      "kpiAttention": "Richiedono attenzione",
      "kpiAdherence": "Aderenza media",
      "kpiSessions": "Sessioni questa settimana",
      "kpiNotLoaded": "Non caricati: {{count}}. Contati solo in Atleti.",
      "adherence": "aderenza",
      "lastNever": "mai allenato",
      "flagStale": "Non si allena",
      "flagUnderTarget": "Sotto target",
      "flagOnTrack": "In linea",
      "flagNoProgram": "Nessun programma"
    },
    "detail": {
      "back": "Torna alla squadra",
      "maxesTitle": "MAX attuali",
      "maxesEmpty": "Nessun MAX registrato",
      "rhythmSummary": "media {{avg}}/settimana su {{weeks}} settimane · ultima settimana: {{last}}",
      "effortTitle": "Copertura effort",
      "effortLabel": "serie con RIR registrato",
      "effortSummary": "{{tagged}} serie su {{counted}} conteggiate, riscaldamenti inclusi",
      "effortEra": "I dati effort partono dal {{date}} · {{count}} serie precedenti non sono conteggiate",
      "effortNone": "Nessuna serie porta ancora un valore di effort: i numeri su hard set e target non hanno su cosa poggiare.",
      "effortError": "Impossibile caricare i dati effort.",
      "maxesSeeAll": "Mostra tutti (+{{count}})",
      "maxesShowFewer": "Mostra meno",
      "assignProgram": "Assegna programma"
    },
    "targets": {
      "eyebrow": "Obiettivi settimanali",
      "edit": "Modifica obiettivi",
      "degradedHint": "Questo atleta non ha ancora obiettivi settimanali. Impostane qualcuno per valutare la sua settimana rispetto a un traguardo.",
      "noGrant": "Sola lettura — l'atleta non ti ha concesso la modifica degli obiettivi.",
      "historyTitle": "Cronologia modifiche",
      "historyEmpty": "Ancora nessuna modifica.",
      "historyByYou": "Tu",
      "historyTruncated": "Mostro le 1000 modifiche più recenti.",
      "histGeneric": "Obiettivi aggiornati",
      "histSet": "impostato a {{value}}",
      "histRemoved": "rimosso",
      "histChanged": "{{from}} → {{to}}",
      "histLine": "{{label}} · {{metric}}: {{body}}",
      "historyLoading": "Caricamento…",
      "errLoad": "Impossibile caricare questi obiettivi. Torna indietro e riprova.",
      "errStale": "Questi obiettivi sono cambiati mentre li modificavi. Ricarica e riapplica.",
      "errNoGrant": "L'atleta non ti ha concesso la modifica degli obiettivi.",
      "errNotCoach": "Non sei il coach di questo atleta.",
      "errMultiAssignee": "Questo programma è condiviso da più di un atleta.",
      "errRetry": "Ancora in caricamento, riprova tra un istante.",
      "errNotFound": "Questo programma non esiste più.",
      "errOffline": "Salvataggio non riuscito. Controlla la connessione e riprova."
    },
    "assignPicker": {
      "title": "Assegna a {{name}}",
      "cancel": "Annulla",
      "rowA11y": "Assegna {{name}}",
      "assignedTitle": "Inviato",
      "assignedBody": "Inviato a {{name}} — in attesa che accetti.",
      "alreadyTitle": "Già assegnato",
      "alreadyBody": "{{name}} ce l'ha già.",
      "errAssign": "Impossibile assegnare. Riprova."
    },
    "sessions": {
      "title": "Sedute",
      "setsTitle": "Serie",
      "noSets": "Nessuna serie registrata in questa seduta.",
      "setA11y": "Serie {{n}}: {{summary}}",
      "loadFailed": "Impossibile caricare le sedute.",
      "unavailable": "Impossibile aprire questa seduta. Torna indietro e riprova."
    }
  },
  "plans": {
    "assign": "Assegna",
    "title": "Piani",
    "help": "Prepara un allenamento per te stesso. I target possono essere in kg assoluti o in percentuale del MAX, convertiti in kg quando avvii il piano.",
    "loading": "Caricamento piani…",
    "empty": "Nessun piano ancora. Aggiungine uno per preparare la sessione.",
    "todayPill": "Oggi",
    "add": "Aggiungi piano",
    "edit": "Modifica",
    "start": "Avvia",
    "cancel": "Annulla",
    "save": "Salva",
    "saving": "Salvataggio…",
    "saved": "Piano salvato.",
    "savedEdit": "Piano aggiornato.",
    "deleted": "Piano eliminato.",
    "delete": "Elimina",
    "deleting": "Eliminazione…",
    "deleteConfirm": "Eliminare questo piano?",
    "creatingTitle": "Nuovo piano",
    "editingTitle": "Modifica piano",
    "name": "Nome",
    "namePlaceholder": "es. Giorno squat",
    "scheduledFor": "Data prevista (opzionale)",
    "pickDate": "Scegli una data",
    "pickDateHint": "Apre il selettore di data",
    "clearDate": "Cancella la data",
    "noDate": "Non impostata",
    "notes": "Note (opzionale)",
    "rpeEnabledLabel": "Mostra colonna RPE nel Logger",
    "rpeEnabledHelp": "Quando attivo, le sessioni avviate da questo piano si aprono con la colonna RPE visibile. L'atleta può comunque modificarla a sessione.",
    "exercise": "Esercizio",
    "exercisePlaceholder": "Scegli un esercizio",
    "exerciseN": "Esercizio {{n}}",
    "removeExercise": "Rimuovi esercizio",
    "addExercise": "Aggiungi un altro esercizio",
    "setsLegend": "Serie",
    "targetReps": "Reps",
    "targetWeight": "Peso",
    "targetKind": "Unità",
    "targetRpe": "RPE",
    "noMaxYet": "nessun MAX",
    "addSet": "Aggiungi serie",
    "removeSet": "Rimuovi serie",
    "statusDraft": "Bozza",
    "statusScheduled": "Pianificato",
    "statusCompleted": "Completato",
    "statusSkipped": "Saltato",
    "errNotSignedIn": "Serve l'accesso.",
    "errNameRequired": "Dai un nome al piano.",
    "errPickExercise": "Scegli un esercizio dal catalogo.",
    "errNoSets": "Aggiungi almeno una serie valida.",
    "errGroupKindMixed": "Due esercizi hanno lo stesso group id ma uno è superset e l'altro circuito. Scegli un tipo e salva.",
    "errCode": {
      "invalid_email": "Quell'indirizzo email non è valido.",
      "email_not_found": "Nessun account trovato con quell'email.",
      "too_many_assignees": "Massimo 20 persone per programma."
    },
    "assignTo": "Assegna agli atleti",
    "assignToHelp": "Assegnarlo è una proposta: entra nella libreria solo se accetta, e ciò che ha accettato resta suo se lo togli. Serve un coach edge attivo con te.",
    "assignSelf": "Tu (autore)",
    "addAssignee": "Aggiungi",
    "removeAssignee": "Rimuovi",
    "removeAssigneeConfirm": "Togliere l'accesso?",
    "removeAssigneeHint": "L'atleta lo perderà dalla sua libreria. Tocca di nuovo per rimuovere.",
    "pendingAssigneeCaption": "In attesa",
    "rosterSectionLabel": "Dal tuo roster",
    "rosterEmpty": "Nessun atleta nel tuo roster.",
    "rosterAllAssigned": "Tutti gli atleti del tuo roster sono già assegnati.",
    "shareTo": "Condividi con",
    "shareToHelp": "Condividere è una proposta: arriva nella loro libreria solo se accettano, e ciò che hanno accettato resta loro anche se li rimuovi.",
    "shareSectionLabel": "Persone con cui condividere",
    "shareEmpty": "Non hai ancora nessuno con cui condividere.",
    "shareAllShared": "Tutti quelli con cui puoi condividere ce l'hanno già.",
    "emailSectionLabel": "Via email",
    "assigneePlaceholder": "nome@esempio.com",
    "invalidEmailFormat": "Non sembra un indirizzo email valido.",
    "exerciseNew": "Scegli un esercizio",
    "setIndex": "Serie {{n}}",
    "cardMenu": "Menù scheda",
    "menuGroup": "Gruppo",
    "menuMoveUp": "Sposta su",
    "menuMoveDown": "Sposta giù",
    "groupNone": "Nessun gruppo",
    "groupJoinExisting": "Aggiungi a un gruppo",
    "groupCreate": "Crea",
    "groupNewSuperset": "Nuovo superset",
    "groupNewCircuit": "Nuovo circuito",
    "groupSupersetN": "Superset {{letter}}",
    "groupCircuitN": "Circuito {{letter}}",
    "details": "Dettagli",
    "exercisesLabel": "Esercizi",
    "editorEmpty": "Nessun esercizio. Aggiungine uno per iniziare a costruire questo piano.",
    "selectExercisePrompt": "Seleziona un esercizio per modificarne le serie.",
    "addExerciseCta": "Aggiungi esercizio",
    "removeExerciseConfirm": "Rimuovere questo esercizio?",
    "removeExerciseHint": "Tocca una volta per confermare, poi tocca di nuovo per rimuovere.",
    "collapseExercise": "Comprimi esercizio",
    "supersetTag": "SUPERSET",
    "exerciseNoteLabel": "Nota esercizio (opzionale)"
  },
  "templates": {
    "show": "Sfoglia i template di partenza",
    "hide": "Nascondi i template",
    "help": "Piani e programmi comuni pronti all'uso. Clonane uno nel tuo account — la copia è tua, modificala o cancellala senza toccare il template.",
    "loading": "Caricamento template…",
    "empty": "Nessun template disponibile al momento.",
    "errLoad": "Impossibile caricare i template.",
    "clone": "Clona nei miei",
    "cloning": "Clonazione…",
    "cloned": "Clonato \"{{name}}\".",
    "alreadyCloned": "Già clonato",
    "difficultyBeginner": "Principiante",
    "difficultyIntermediate": "Intermedio",
    "difficultyAdvanced": "Avanzato",
    "planMeta": "{{n}} esercizio/i",
    "programMeta": "Ciclo di {{weeks}} settimane · {{sessions}}× / settimana"
  },
  "maxes": {
    "title": "Massimali",
    "countLabel_one": "{{count}} impostato",
    "countLabel_other": "{{count}} impostati",
    "help": "Il MAX è quello che puoi alzare oggi, impostato da te. I programmi lo usano come base per le percentuali. Il massimale stimato nel grafico Andamento è solo informativo.",
    "loading": "Caricamento massimali…",
    "empty": "Nessun massimale impostato. Aggiungine uno per guidare la programmazione a percentuale.",
    "add": "Aggiungi massimale",
    "edit": "Modifica",
    "delete": "Elimina",
    "deleteAction": "Elimina MAX",
    "deleting": "Eliminazione…",
    "deleted": "MAX eliminato.",
    "deleteConfirm": "Eliminare il MAX di {{name}}? Anche lo storico viene rimosso. Un prossimo seed dallo storico potrà ripopolarlo dai tuoi allenamenti.",
    "exercise": "Esercizio",
    "exercisePlaceholder": "Scegli un esercizio",
    "value": "Valore",
    "source": "Origine",
    "sourceManual": "Impostato a mano",
    "sourceTested": "Testato in palestra",
    "sourceDerived": "Derivato da una serie loggata",
    "sourceCalculated": "Stimato dalla storia",
    "sourceImported": "Importato",
    "notes": "Note (facoltative)",
    "save": "Salva",
    "saving": "Salvataggio…",
    "saved": "Massimale salvato.",
    "cancel": "Annulla",
    "errPickExercise": "Scegli un esercizio.",
    "errInvalidValue": "Inserisci un valore tra 0 e 2000.",
    "seed": {
      "start": "Suggerisci dallo storico",
      "loading": "Lettura dello storico in corso…",
      "reviewIntro": "{{count}} esercizi hanno una serie top credibile nello storico. Seleziona quali usare come MAX. Gli esercizi che hanno già un MAX vengono saltati.",
      "selectAll": "Seleziona tutto",
      "selectNone": "Deseleziona tutto",
      "fromSet": "da {{weight}} × {{reps}}",
      "cancel": "Annulla",
      "apply": "Imposta {{count}} MAX",
      "applying": "Salvataggio: {{done}} / {{total}}",
      "applied": "Impostati {{count}} MAX dallo storico.",
      "noneApplicable": "Nulla da impostare. O ogni esercizio ha già un MAX, o non è stato trovato storico pesato.",
      "close": "Chiudi"
    }
  },
  "progress": {
    "coverageTitle": "Copertura muscolare",
    "coverageSeeAll": "Vedi tutti i muscoli (+{{count}})",
    "coverageShowFewer": "Mostra meno",
    "coverageCompact": {
      "doneOfExpected": "{{done}} / {{expected}} a oggi",
      "doneOfExpectedA11y_one": "{{done}} serie su {{expected}} a oggi",
      "doneOfExpectedA11y_other": "{{done}} serie su {{expected}} a oggi",
      "behind": "indietro di {{n}}",
      "onPace": "in linea",
      "titleBehind_one": "Indietro di {{count}} serie sul ritmo",
      "titleBehind_other": "Indietro di {{count}} serie sul ritmo",
      "titleOnPace": "In linea",
      "subtitle": "serie dure a oggi rispetto al ritmo della banda"
    },
    "period": {
      "days": "{{days}} g",
      "painDays": "7 / {{days}} g"
    },
    "title": "Andamento",
    "show": "Mostra",
    "hide": "Nascondi",
    "help": "Il MAX è il valore che imposti tu; il massimale stimato usa Epley come riferimento. Il volume è la somma di peso per ripetizioni della seduta.",
    "e1rm": "Massimale stimato",
    "max": "MAX",
    "maxLabel": "MAX",
    "estimatedBadge": "1RM stimato tratteggiato",
    "volume": "Volume",
    "sessions": "{{n}} sedute",
    "prFound": "Record personale a {{weight}}.",
    "prUpdating": "Aggiornamento…",
    "viewByExercise": "Per esercizio",
    "viewByTag": "Per tag",
    "noTags": "Nessuna seduta taggata ancora. Tagga gli esercizi nel catalogo per vedere il volume aggregato qui.",
    "totalVolume": "Totale {{weight}}",
    "recordsScope": "Record",
    "recordsAllTime": "Tutti",
    "recordsThisYear": "{{year}}",
    "filterPlaceholder": "Filtra esercizi",
    "filterCount": "{{visible}} su {{total}}",
    "filterNoMatch": "Nessun esercizio corrisponde al filtro.",
    "coverageNoData": "Ancora niente da valutare: registra una seduta, o imposta un target settimanale.",
    "volumeLandmark": {
      "source": {
        "rp": "Renaissance Periodization"
      },
      "citation": {
        "rp": "Riferimenti di pratica pubblicati. La varianza individuale è grande — i tuoi dati restringono questa banda."
      },
      "zone": {
        "belowMev": "sotto MEV",
        "mevMav": "MEV–MAV",
        "mavMrv": "MAV–MRV",
        "aboveMrv": "oltre MRV",
        "noBand": "nessuna banda pubblicata"
      },
      "yourTarget": "il tuo target {{v}}",
      "athleteTarget": "target {{v}}",
      "sets_one": "{{n}} serie",
      "sets_other": "{{n}} serie"
    },
    "chartGapShort": "+{{count}}g",
    "chartGapLong_one": "{{count}} giorno dal punto precedente",
    "chartGapLong_other": "{{count}} giorni dal punto precedente",
    "chartMorePoints_one": "+{{count}} altro punto",
    "chartMorePoints_other": "+{{count}} altri punti",
    "chartWindowA11y": "dal {{from}} al {{to}}",
    "chartSummaryA11y": "{{range}}, ultimo {{last}}, {{window}}",
    "chartTapHint": "Tocca un punto per leggerne il valore",
    "chartCapped": "Mostra solo i dati più recenti. Quelli più vecchi non sono nel grafico.",
    "muscleState": {
      "thin": "Storia troppo breve per un ritmo: {{n}} sessioni su {{needed}}",
      "none": "Nessuna serie dura registrata",
      "a11yOver": "carico recente {{pct}}% sopra il ritmo di 28 giorni",
      "a11yUnder": "carico recente {{pct}}% sotto il ritmo di 28 giorni",
      "a11yLevel": "carico recente pari al ritmo di 28 giorni"
    },
    "gapProposal": {
      "toggle": "Chiudi il buco",
      "toMev_one": "manca <num>{{n}}</num> serie/sett al MEV",
      "toMev_other": "mancano <num>{{n}}</num> serie/sett al MEV",
      "basis": "MEV {{mev}} − media {{avg}}/sett = {{gap}}/sett",
      "eachAlone": "Ognuno di questi lo chiude da solo:",
      "alsoWorks": "allena anche {{muscles}}",
      "atPlace": "A {{place}}, senza ciò che lì hai segnato come mancante.",
      "noPlace": "Catalogo intero: nessun luogo predefinito.",
      "wholeCatalog": "Catalogo intero: il luogo dell'atleta non è condiviso con i coach.",
      "noneAtPlace": "Non resta nulla a {{place}}: ogni esercizio per questo muscolo lì è segnato come mancante.",
      "noneInCatalog": "Nessun esercizio del catalogo allena questo muscolo.",
      "shortHistory_one": "Per misurare il buco servono 4 settimane piene di storico: finora {{n}}.",
      "shortHistory_other": "Per misurare il buco servono 4 settimane piene di storico: finora {{n}}.",
      "a11yToggle": "{{muscle}}: chiudi il buco, {{gap}} serie a settimana al MEV",
      "buildToday": "Costruisci la seduta di oggi da questi buchi"
    }
  },
  "cohort": {
    "compare": "Confronta col gruppo (anonimo)",
    "hide": "Nascondi confronto",
    "loading": "Caricamento dati gruppo…",
    "empty": "Per ora non ci sono abbastanza contributi per mostrare un confronto. La soglia è dieci persone nella stessa fascia d'età.",
    "contributors": "Basato su {{n}} contributi anonimi con fascia d'età indicata.",
    "yourGroup": "il tuo gruppo"
  },
  "catalog": {
    "title": "Catalogo esercizi",
    "empty": "Nessun esercizio.",
    "region": "Distretto",
    "region_lower": "Parte bassa",
    "region_posterior": "Catena posteriore",
    "region_chest": "Petto",
    "region_back": "Schiena",
    "region_shoulders": "Spalle",
    "region_arms": "Braccia",
    "region_core": "Core",
    "region_cardio": "Cardio",
    "region_other": "Altro",
    "pattern": "Pattern",
    "pattern_squat": "Squat",
    "pattern_hinge": "Hinge",
    "pattern_horizontal-push": "Spinta orizzontale",
    "pattern_vertical-push": "Spinta verticale",
    "pattern_horizontal-pull": "Tirata orizzontale",
    "pattern_vertical-pull": "Tirata verticale",
    "pattern_lunge": "Affondo",
    "pattern_carry": "Carry",
    "pattern_core": "Core",
    "pattern_isolation": "Isolamento",
    "pattern_mobility": "Mobilità",
    "pattern_cardio": "Cardio",
    "pattern_other": "Altro",
    "equipment": "Attrezzo",
    "equipment_barbell": "Bilanciere",
    "equipment_dumbbell": "Manubri",
    "equipment_kettlebell": "Kettlebell",
    "equipment_cable": "Cavi",
    "equipment_machine": "Macchina",
    "equipment_bodyweight": "Corpo libero",
    "equipment_band": "Elastico",
    "equipment_other": "Altro",
    "tags": "Tag",
    "equipment_treadmill": "Tapis roulant",
    "equipment_exercise-bike": "Cyclette",
    "equipment_elliptical": "Ellittica",
    "equipment_rower": "Vogatore",
    "equipment_stair-climber": "Scalapendio",
    "equipment_jump-rope": "Corda per saltare",
    "equipment_battle-ropes": "Corde nautiche",
    "equipment_sled": "Slitta",
    "deletedExercise": "Esercizio cancellato"
  },
  "swap": {
    "title": "Cambia esercizio",
    "currentLabel": "Attuale",
    "searchPlaceholder": "Cerca nel catalogo…",
    "showAll": "Mostra tutti gli esercizi",
    "noMatches": "Nessun esercizio corrisponde alla ricerca.",
    "noSuggestions": "Nessun simile per tag. Spunta \"Mostra tutti\" per esplorare il catalogo.",
    "close": "Chiudi",
    "reasonTags": "Tag in comune ×{{count}}",
    "reasonPrimary": "Muscoli in comune ×{{count}}",
    "reasonDifferentEquipment": "Attrezzo diverso",
    "suggestedSection": "Suggeriti",
    "allSection": "Tutti gli esercizi",
    "whichMachine": "Quale macchina?",
    "defaultMachine": "Macchina predefinita",
    "machineLabel": "Macchina {{letter}}",
    "setMachine": "Imposta macchina",
    "machineChoices": "Macchine note: {{count}}",
    "newMachine": "Nuova macchina",
    "bandSession": "Sessione",
    "bandCurrentExercise": "Questo esercizio",
    "bandOtherExercises": "Passa a un altro esercizio",
    "equipmentKey": "Attrezzo",
    "currentConsequence": "I set già registrati restano: cambia solo l'attrezzo su cui sono segnati.",
    "unavailableTitle": "Non c'è qui?",
    "unavailableBody": "Spunta l'attrezzo di {{exercise}} che non c'è a {{place}}. Si registra solo ciò che spunti.",
    "unavailableConfirm": "Salva",
    "unavailableOpen": "Attrezzo non disponibile qui",
    "unavailableOpenHint": "Chiede quale attrezzo di questo esercizio manca.",
    "unavailableBadge": "Non c'è qui",
    "unavailableRestore": "Di nuovo disponibile qui",
    "unavailableErrorTitle": "Salvataggio non riuscito",
    "unavailableErrorBody": "L'attrezzo risulta ancora disponibile qui.",
    "unavailableConfirmHint": "Spuntane almeno uno per salvare.",
    "pinDefaultMachine": "Usa sempre la macchina predefinita qui",
    "pinMachine": "Usa sempre {{machine}} qui",
    "pinHint": "Smette di chiedere quale macchina, in questa palestra, per questo esercizio.",
    "pinErrorTitle": "Salvataggio non riuscito",
    "pinErrorBody": "La macchina predefinita qui non è cambiata.",
    "unpinDefaultMachine": "Smetti di usare sempre la macchina predefinita qui",
    "unpinMachine": "Smetti di usare sempre {{machine}} qui",
    "pinnedFootnoteDefault": "Qui si usa sempre la macchina predefinita.",
    "pinnedFootnoteMachine": "Qui si usa sempre {{machine}}.",
    "unpinHint": "Torna a chiedere quale macchina, in questa palestra, per questo esercizio."
  },
  "mobile": {
    "bodymap": {
      "muscle": {
        "chest": "Petto",
        "biceps": "Bicipiti",
        "triceps": "Tricipiti",
        "forearm": "Avambracci",
        "front-deltoids": "Spalle",
        "back-deltoids": "Deltoidi posteriori",
        "trapezius": "Trapezi",
        "upper-back": "Schiena",
        "lower-back": "Lombari",
        "abs": "Core",
        "obliques": "Core",
        "quadriceps": "Quadricipiti",
        "hamstring": "Femorali",
        "gluteal": "Glutei",
        "adductors": "Adduttori",
        "abductors": "Abduttori",
        "calves": "Polpacci",
        "tibialis": "Tibiale",
        "neck": "Collo",
        "head": "Testa"
      }
    },
    "tabs": {
      "workouts": "Allenamenti",
      "plan": "Home",
      "progress": "Progressi",
      "catalog": "Catalogo",
      "profile": "Profilo",
      "settings": "Impostazioni",
      "inbox": "Inbox",
      "athletes": "Atleti",
      "library": "Libreria",
      "me": "Io"
    },
    "me": {
      "sectionTraining": "Allenamento",
      "navTargets": "Obiettivi",
      "navTargetsSub": "I tuoi target settimanali"
    },
    "settings": {
      "title": "Impostazioni",
      "exercisesSection": "Esercizi",
      "navExercisesSub": "MAX, catalogo, scala sforzo",
      "navCatalog": "Catalogo esercizi",
      "selectPrompt": "Seleziona un'impostazione per aprirla.",
      "navCatalogSub": "Sfoglia la libreria esercizi",
      "navEffort": "Impostazioni sforzo",
      "navEffortSub": "Scala RIR / RPE + legenda",
      "navLicenses": "Licenze open source",
      "navLicensesSub": "Le librerie che fanno funzionare l'app",
      "sectionAccount": "Account",
      "sectionTraining": "Allenamento",
      "sectionBody": "Corpo",
      "sectionPrefs": "Preferenze",
      "sectionCoach": "Coach",
      "sectionAbout": "Info",
      "sectionHealthConnect": "Health Connect",
      "navHealthConnect": "Health Connect",
      "navHealthConnectSub": "Sincronizza allenamenti e dati di salute dal dispositivo"
    },
    "energySource": {
      "zepp": "Zepp",
      "googleFit": "Google Fit",
      "healthConnect": "Health Connect",
      "jlEstimate": "$t(brand.product)",
      "pillLabel": "Origine calorie",
      "projectionNote": "Include la serie che stai per fare: una proiezione dell'intera seduta, non il lavoro che hai già registrato.",
      "selected": "selezionata"
    },
    "hc": {
      "preferences": "Preferenze",
      "caloriesWins": "Health Connect vince sulle calorie",
      "caloriesWinsHelp": "Quando esistono entrambe, mostra le calorie misurate da Health Connect invece della stima di $t(brand.product). Off = preferisci la stima. Senza un valore da Health Connect, si usa sempre la stima.",
      "title": "Health Connect",
      "intro": "Importa l'attività di orologio e telefono in $t(brand.product). Camminate, escursioni e uscite in bici diventano allenamenti; frequenza cardiaca e calorie arricchiscono le sessioni che registri. Spento finché non lo colleghi.",
      "checking": "Controllo…",
      "unavailable": "Health Connect non è disponibile su questo dispositivo.",
      "updateRequired": "Aggiorna l'app Health Connect per continuare.",
      "notConnected": "Non collegato.",
      "connect": "Collega Health Connect",
      "connectHelp": "Scegli tu quali dati $t(brand.product) può leggere. Puoi cambiarlo in qualsiasi momento in Health Connect.",
      "connected": "Collegato",
      "reads": "Legge allenamenti, frequenza cardiaca e calorie.",
      "syncNow": "Sincronizza ora",
      "neverSynced": "Mai sincronizzato.",
      "lastSyncedAt": "Ultima sincronizzazione: {{when}}",
      "syncDelayNote": "Una nuova attività può metterci qualche minuto ad arrivare su Health Connect dal tuo dispositivo: una camminata o una pedalata recente potrebbe comparire solo a una sincronizzazione successiva. È un ritardo normale.",
      "syncFullHistory": "Sincronizza tutto lo storico",
      "syncingFullHistory": "Sincronizzazione dello storico in corso",
      "syncFullHistoryHelp": "Ricontrolla tutto lo storico e colma eventuali buchi in Health Connect. Usalo se lì manca una correzione fatta in passato. Si può ripetere senza rischi.",
      "resultSummary": "{{imported}} importati · {{enriched}} arricchiti · {{skipped}} saltati",
      "error": "Qualcosa è andato storto. Riprova.",
      "grantRefused": "Il tuo account non ha registrato questo consenso, quindi $t(brand.product) non leggerà Health Connect. Riprova a collegarti più tardi.",
      "revokeRefused": "Health Connect è scollegato su questo telefono, ma il tuo account non ha registrato la revoca e mostra ancora il tuo consenso. Riprova più tardi.",
      "revokedElsewhere": "Hai ritirato il consenso su un altro dispositivo, quindi Health Connect è scollegato su questo telefono.",
      "manageInHc": "Gestisci in Health Connect",
      "disconnect": "Disconnetti",
      "disconnectTitle": "Disconnettere Health Connect?",
      "disconnectBody": "$t(brand.product) smetterà di leggere i tuoi dati di Health Connect. Gli allenamenti già importati restano nella cronologia.",
      "logoA11y": "Health Connect",
      "privacyTitle": "I tuoi dati",
      "privacyBody": "$t(brand.product) legge solo ciò che autorizzi in Health Connect, e solo su questo telefono dopo che ti colleghi. Sono salvati nel tuo account $t(brand.product) privato, mai condivisi né venduti. Disconnetti quando vuoi per fermare tutto.",
      "explainerTitle": "Cosa legge $t(brand.product), e perché",
      "explainerIntro": "Poi te lo chiede Android. Puoi consentire tutto, una parte o niente, e cambiare quando vuoi in Health Connect.",
      "explainerContinue": "Continua su Android",
      "explainerCancel": "Non ora",
      "consentGiven": "Consenso dato il {{when}}.",
      "consentWithdrawn": "Consenso dato il {{given}}, revocato il {{withdrawn}}.",
      "consentWithdrawnOnly": "Consenso revocato il {{withdrawn}}.",
      "consentBeforeRecord": "Consenso dato prima che $t(brand.product) ne registrasse la data.",
      "consentCategories": "Cosa hai consentito",
      "consentRecordNote": "Questo registro appartiene al tuo account e conserva ogni consenso e ogni revoca con la sua data. Android dà il permesso su ogni telefono separatamente.",
      "explainerMore": "Continua sotto, scorri per leggere tutto.",
      "deviceAllowed": "Su questo telefono: consentito da Android.",
      "deviceNotAllowed": "Su questo telefono: non consentito da Android.",
      "driftDeviceOff": "Il tuo account ha il tuo consenso, ma Android non lo consente più su questo telefono. Consentilo di nuovo per sincronizzare qui.",
      "driftNoRecord": "Android lo consente su questo telefono, ma il tuo account non ha un consenso in corso. Rivedi cosa legge $t(brand.product), poi conferma nella richiesta di Android. Il tuo account lo registra con la data di oggi.",
      "driftUndated": "Il tuo consenso non ha ancora una data. Rivedi cosa legge $t(brand.product), poi conferma nella richiesta di Android: il tuo account lo registra con la data di oggi.",
      "allowOnPhone": "Consenti su questo telefono",
      "confirmConsent": "Rivedi e conferma",
      "permOther": "Altro permesso",
      "perm": {
        "readExerciseSession": {
          "name": "Sessioni di esercizio",
          "use": "Una camminata, una corsa o un giro in bici registrati da orologio o telefono compaiono nella tua timeline come allenamento."
        },
        "readHeartRate": {
          "name": "Frequenza cardiaca",
          "use": "La frequenza media e quella di picco compaiono su ogni allenamento, e servono alla stima delle calorie."
        },
        "readActiveCaloriesBurned": {
          "name": "Calorie attive",
          "use": "Le calorie misurate compaiono su ogni allenamento, accanto alla stima."
        },
        "readDistance": {
          "name": "Distanza",
          "use": "Completa la distanza nelle serie cardio di un allenamento registrato da orologio o telefono."
        },
        "readWeight": {
          "name": "Peso",
          "use": "Entra nello storico e nel grafico del peso corporeo in Corpo."
        },
        "readBodyFat": {
          "name": "Massa grassa",
          "use": "Compare nel grafico della composizione corporea in Corpo."
        },
        "readLeanBodyMass": {
          "name": "Massa magra",
          "use": "Compare nel grafico della composizione corporea in Corpo."
        },
        "readNutrition": {
          "name": "Alimentazione",
          "use": "I carboidrati di oggi compaiono nella scheda Metabolico, accanto alla glicemia."
        },
        "readBloodGlucose": {
          "name": "Glicemia",
          "use": "Le tue misurazioni compaiono nella scheda Metabolico, come curva e ultimo valore."
        },
        "writeBloodGlucose": {
          "name": "Scrittura glicemia",
          "use": "Una glicemia che inserisci in $t(brand.product) viene salvata anche in Health Connect."
        },
        "writeWeight": {
          "name": "Scrittura peso",
          "use": "Una pesata che inserisci in $t(brand.product) viene salvata anche in Health Connect."
        }
      },
      "bodyResult": "{{imported}} corporee importate · {{skipped}} saltate",
      "bodyNotGranted": "Dati corporei non ancora concessi. Tocca Concedi dati corporei.",
      "readsFull": "Legge allenamenti, frequenza cardiaca e calorie, peso e composizione corporea, glicemia e nutrizione. Scrive glicemia e peso su Health Connect.",
      "backfillTitle": "Importare lo storico da maggio?",
      "backfillBody": "Scansiona lo storico di Health Connect fino a maggio e importa ciò che manca. Si può rilanciare senza problemi: gli elementi già importati vengono saltati.",
      "backfillNow": "Importa storico",
      "grantExtra": "Concedi dati salute",
      "extraGrantBody": "Importa anche peso, composizione corporea, glicemia e nutrizione.",
      "metabolicResult": "{{glucose}} glicemie · {{nutrition}} nutrizione importate",
      "metabolicNotGranted": "Glicemia e nutrizione non ancora concesse.",
      "writeGlucoseGrantBody": "Consenti a $t(brand.product) di scrivere la glicemia su Health Connect.",
      "grantWrite": "Consenti scrittura",
      "syncGlucoseToHc": "Scrivi glicemia su Health Connect"
    },
    "metabolic": {
      "title": "Metabolico",
      "loading": "Caricamento…",
      "empty": "Collega Health Connect e sincronizza per vedere qui glicemia e nutrizione.",
      "glucoseEmpty": "Nessuna lettura di glicemia",
      "mgdl": "mg/dL",
      "targetBand": "Range target tipico {{lo}}–{{hi}} {{unit}}.",
      "carbsToday": "Carboidrati oggi",
      "grams": "g",
      "glucoseTitle": "Glicemia",
      "glucoseCurrent": "Ultima: {{value}} {{unit}}",
      "glucoseNone": "Registra una lettura per seguire la glicemia.",
      "help": "La tua glicemia da Health Connect, con i carboidrati recenti sotto. Tocca un punto del grafico per leggerne valore e ora."
    },
    "exercisesScreen": {
      "back": "Indietro"
    },
    "body": {
      "back": "Indietro",
      "title": "Corpo",
      "navTitle": "Corpo",
      "navSub": "Sesso, età, figura",
      "navPainMapSub": "Segna dove fa male",
      "trendsWebHint": "I grafici di composizione corporea sono nell'app mobile.",
      "sexLabel": "Sesso",
      "sexHelp": "Usato solo per la stima della massa grassa. La figura della mappa muscolare è una scelta separata qui sotto.",
      "sex_male": "Uomo",
      "sex_female": "Donna",
      "measurementsTitle": "Misure",
      "measurementsSub": "Peso, circonferenze, stima massa grassa",
      "measureTitle": "NUOVA MISURA",
      "weight": "Peso",
      "field_heightCm": "Altezza",
      "field_neckCm": "Collo",
      "field_chestCm": "Petto",
      "field_waistCm": "Vita",
      "field_hipsCm": "Fianchi",
      "field_bicepsLCm": "Bicipite (Sx)",
      "field_bicepsRCm": "Bicipite (Dx)",
      "field_forearmsLCm": "Avambraccio (Sx)",
      "field_forearmsRCm": "Avambraccio (Dx)",
      "field_thighsLCm": "Coscia (Sx)",
      "field_thighsRCm": "Coscia (Dx)",
      "field_calvesLCm": "Polpaccio (Sx)",
      "field_calvesRCm": "Polpaccio (Dx)",
      "measureSave": "Salva i valori inseriti",
      "measureHelpC": "Compila solo ciò che hai misurato. I campi vuoti non vengono salvati.",
      "useLastA11y": "Usa l'ultimo valore {{value}}",
      "saveFailedTitle": "Salvataggio non riuscito",
      "saveFailedBody": "La misura non è stata salvata. I valori restano — tocca Salva per riprovare.",
      "editTitle": "MODIFICA — {{date}}",
      "saveChanges": "Salva modifiche",
      "editCancelA11y": "Annulla modifica",
      "editRowA11y": "Modifica misura {{date}}",
      "editHelp": "Cambia un valore, oppure cancellalo per rimuoverlo dallo storico.",
      "trendsLabel": "TREND",
      "trendsHint": "scegli le misure",
      "trendsExpandA11y": "Mostra tutte le misure",
      "trendsCollapseA11y": "Comprimi le misure",
      "trendsPick": "Scegli una misura qui sopra per vedere il suo andamento.",
      "metricComposition": "Composizione",
      "metricBodyFat": "Grasso",
      "metricLeanMass": "Massa magra",
      "loadError": "Impossibile caricare le misure — controlla la connessione.",
      "navyTitle": "COMPOSIZIONE CORPOREA (NAVY)",
      "navyNeedsEntry": "Salva una misura qui sotto per stimare la massa grassa.",
      "navyNeedsSex": "Imposta il sesso qui sopra per stimare la massa grassa.",
      "navyNeedsInputs": "Aggiungi altezza, collo e vita (e fianchi, per la formula femminile) per stimare la massa grassa.",
      "navyBodyFat": "Massa grassa ≈ {{pct}}%",
      "navyLeanMass": "Massa magra ≈ {{mass}}",
      "navyDisclaimer": "Stima US Navy (~±3,5%). Guarda l'andamento, non il singolo numero.",
      "historyEmpty": "Ancora nessuna misura. Salvane una qui sopra per iniziare a monitorare.",
      "historyTitle": "STORICO",
      "trendWeight": "ANDAMENTO PESO",
      "trendBodyFat": "ANDAMENTO MASSA GRASSA",
      "deleteTitle": "Eliminare la misura?",
      "deleteEmptyTitle": "Rimuovere questa misura?",
      "deleteEmptyBody": "Tutti i suoi valori sono stati cancellati, quindi la voce verrà eliminata.",
      "deleteCancel": "Annulla",
      "deleteConfirm": "Elimina",
      "ageLabel": "Età",
      "ageHelp": "Opzionale. Tocca di nuovo per azzerare.",
      "dualCurveLegend": "Linea piena: stima · Tratteggio: Health Connect",
      "estimateSeriesName": "Stima",
      "bodyFatProvenance": "Il grasso si calcola misurando vita e collo.",
      "bodyFatProvenanceWithHips": "Il grasso si calcola misurando vita, collo e fianchi.",
      "trendsHelp": "Un grafico per ogni misura scelta sopra. Tocca un punto di un grafico per leggerne valore e data."
    },
    "effortSettings": {
      "back": "Indietro",
      "title": "Sforzo",
      "scaleLabel": "Scala dello sforzo",
      "scaleHelp": "Quale scala usa il Logger. RIR = ripetizioni che ti restano in tasca; RPE = sforzo percepito. RPE = 10 − RIR, quindi sono lo stesso sforzo su due scale."
    },
    "plan": {
      "currentBlockError": "Impossibile impostare il blocco attivo. Riprova.",
      "currentBlockOn": "Blocco attivo — tocca per rimuovere",
      "currentBlockOff": "Imposta come blocco attivo",
      "currentBlockHint": "Fissa i target settimanali di questo programma sul meter della Home",
      "title": "Pianifica",
      "start": "Inizia",
      "starting": "Apertura…",
      "programWeekSession": "Settimana {{week}}/{{cycle}} · {{session}}",
      "programLastCompleted": "Ultima: S{{week}} · {{session}}",
      "programNextHeader": "Prossima",
      "programStartCta": "▶ Inizia {{session}}",
      "programChangeLink": "Cambia settimana o sessione ›",
      "carouselPosition": "Programma {{n}} di {{total}}",
      "carouselPrev": "Programma precedente",
      "carouselNext": "Programma successivo",
      "programWeekLabel": "Settimana",
      "singleCycle": "Ciclo unico, uguale ogni settimana",
      "programSessionLabel": "Sessione",
      "programWeekShort": "S{{n}}",
      "programDayShort": "G{{n}}",
      "sessionN": "Sessione {{n}}",
      "sessionNShort": "S{{n}}",
      "programConfirm": "Inizia S{{week}} · {{session}}",
      "cancel": "Annulla",
      "newWorkout": "Nuovo allenamento",
      "programsHint": "Cicli multi-settimana che avanzano in automatico quando registri le sessioni.",
      "planDeleteTitle": "Eliminare il piano?",
      "programDeleteTitle": "Eliminare il programma?",
      "programStatusError": "Impossibile aggiornare il programma. Riprova.",
      "view": "Vedi",
      "hide": "Nascondi",
      "programUnfollowHint": "Smetti di seguire questo programma (resta in I miei programmi)",
      "programNextInline": "Prossimo: W{{week}} · {{session}}",
      "programStartA11y": "Avvia {{session}}",
      "startPlanA11y": "Avvia {{name}}"
    },
    "preview": {
      "muscles": "Muscoli",
      "noSets": "Nessuna serie prevista",
      "alternates": "Alternative: {{names}}",
      "gridTitle": "Intensità · giorno × settimana",
      "gridHint": "Tocca un giorno per vederne le alzate.",
      "matrixTitle": "Intensità · per serie",
      "matrixHint": "Tocca un esercizio per vederne le serie.",
      "restDay": "Riposo / leggero",
      "intensity": {
        "work": "lavoro",
        "moderate": "moderato",
        "heavy": "pesante",
        "max": "Max",
        "free": "libero"
      }
    },
    "catalog": {
      "title": "Catalogo",
      "search": "Cerca esercizi",
      "empty": "Nessun esercizio corrisponde.",
      "back": "Indietro",
      "notFound": "Esercizio non trovato.",
      "metaPrimaryMuscle": "Muscolo primario",
      "metaPattern": "Pattern",
      "metaEquipment": "Attrezzo",
      "metaP1RM": "Programmabile",
      "metaP1RMYes": "Sì",
      "metaP1RMNo": "No",
      "metaDefaultBar": "Bilanciere predefinito",
      "metaBarLoading": "Caricamento",
      "metaBarLoadingSingleSide": "Un lato solo",
      "aliasesLabel": "Conosciuto anche come",
      "tagsLabel": "Tag",
      "historyLabel": "Sessioni recenti",
      "historyEmpty": "Nessuna sessione passata per questo esercizio.",
      "historyError": "Impossibile caricare la cronologia.",
      "historyBodyweight": "{{reps}} reps a corpo libero",
      "recordsLabel": "Record",
      "recordsEmpty": "Ancora nessun record.",
      "selectPrompt": "Seleziona un esercizio per vederne i dettagli.",
      "recordsError": "Impossibile caricare i record.",
      "refreshing": "Aggiornamento…"
    },
    "maxes": {
      "title": "MAX",
      "back": "Indietro",
      "search": "Cerca esercizi",
      "empty": "Nessun esercizio corrisponde.",
      "editCancel": "Annulla",
      "editSave": "Salva",
      "errInvalid": "Inserisci un peso valido.",
      "clearAction": "Rimuovi MAX",
      "clearTitle": "Rimuovere questo MAX?",
      "clearBody": "Il valore corrente e lo storico restano sul server, ma il MAX risulterà non impostato.",
      "clearCancel": "Annulla",
      "clearConfirm": "Rimuovi",
      "selectPrompt": "Seleziona un esercizio per impostarne il MAX.",
      "unitChipLabel": "Unità di peso: {{unit}}",
      "unitKg": "chilogrammi",
      "unitLb": "libbre",
      "unitChipHint": "Cambia unità e converte il valore",
      "notSet": "Non impostato",
      "loadFailed": "Caricamento non riuscito"
    },
    "login": {
      "title": "$t(brand.product)",
      "subtitle": "Accedi al tuo account",
      "submit": "Accedi"
    },
    "workouts": {
      "title": "Allenamenti",
      "empty": "Nessun allenamento registrato.",
      "fallbackName": "Allenamento",
      "endOfList_one": "{{count}} sessione — fine.",
      "endOfList_other": "{{count}} sessioni — fine.",
      "newButton": "Nuovo",
      "queueDismissCancel": "Annulla",
      "editUnsupportedTitle": "Modifica non ancora supportata su mobile",
      "editUnsupportedBody": "Questo workout contiene tipi di esercizi (P1RM, loaded carry) che il logger mobile non sa ancora modificare. Aprilo sull'app web.",
      "editUnsupportedAck": "OK",
      "repeat": "Ripeti l'allenamento",
      "resumePillAction": "Riprendi",
      "resumePillFallback": "Allenamento in corso",
      "cancel": "Annulla",
      "loadOlder": "Carica i mesi precedenti",
      "selectPrompt": "Seleziona un allenamento per vederne il riepilogo.",
      "loadError": "Impossibile caricare questa sessione.",
      "importedBadge": "Importato"
    },
    "outboxDetail": {
      "errCorrectionTooBig": "Troppe serie cambiate insieme per il server.",
      "errCorrectionBusy": "Il server era occupato con questo allenamento.",
      "errCorrectionConflict": "Questo allenamento è cambiato su un altro dispositivo.",
      "errCorrectionStale": "Questo allenamento è stato salvato di nuovo dopo l'inizio della correzione.",
      "errCorrectionTimes": "L'allenamento finisce prima di iniziare.",
      "errCorrectionGone": "Questo allenamento è stato cancellato su un altro dispositivo.",
      "errSetsUnknownExercise": "Il server non ha riconosciuto un esercizio di questo allenamento.",
      "errSetsInvalidTag": "Il server non ha accettato un tag su una serie di questo allenamento.",
      "errSetsInvalid": "Il server ha trovato non valide alcune serie di questo allenamento.",
      "errSetsNotSaved": "Non tutte le serie sono arrivate al server.",
      "close": "Chiudi",
      "empty": "Non resta niente da inviare.",
      "statusQueued": "In coda",
      "statusSending": "Invio in corso",
      "statusFailed4xx": "Server ha rifiutato",
      "statusPermanentFail": "Ho rinunciato",
      "attempts_one": "{{count}} tentativo",
      "attempts_other": "{{count}} tentativi",
      "dismissOne": "Scarta",
      "dismissOneTitle": "Scartare questo workout?",
      "dismissOneBody": "Il workout del {{date}} sarà rimosso senza essere salvato.",
      "dismissCancel": "Annulla",
      "dismissConfirm": "Scarta",
      "retryAll": "Riprova tutto",
      "queueWorkout": "Allenamento",
      "queueWorkoutNote": "Nota allenamento",
      "queueMeasurement": "Misurazione",
      "queueMax": "Massimale",
      "queueProfile": "Profilo",
      "queueHealth": "Dati salute",
      "queueMetabolic": "Dati metabolici",
      "queueRequest": "Modifica",
      "stuckTitle": "Salvataggi non passati"
    },
    "progress": {
      "title": "Progressi",
      "windowAll": "Sessioni recenti",
      "window30d": "Ultimi 30 giorni",
      "window7d": "Ultimi 7 giorni",
      "lastSession": "Ultima sessione",
      "frequencyTitle": "Frequenza settimanale",
      "frequencyHelp": "Sessioni a settimana, la corrente a destra.",
      "rhythmThisWeek": "Questa settimana finora: {{n}}",
      "rhythmAverageWeeks_one": "Media su {{count}} settimana completa: {{avg}}",
      "rhythmAverageWeeks_other": "Media su {{count}} settimane complete: {{avg}}",
      "weekBars": {
        "thisWeek": "questa settimana finora",
        "weekOf": "settimana del {{date}}",
        "sessions": "Sessioni"
      },
      "weekStreakCurrent": "Serie attuale",
      "weekStreakBest": "Serie migliore",
      "weekStreakWeeks_one": "settimana",
      "weekStreakWeeks_other": "settimane",
      "weekStreakStatA11y_one": "{{label}}: {{count}} settimana",
      "weekStreakStatA11y_other": "{{label}}: {{count}} settimane",
      "weekStreakWithThisWeek_one": "{{count}} settimana di fila con almeno una seduta, compresa questa.",
      "weekStreakWithThisWeek_other": "{{count}} settimane di fila con almeno una seduta, compresa questa.",
      "weekStreakUpToLastWeek_one": "{{count}} settimana di fila con almeno una seduta, fino alla settimana scorsa. Questa settimana è ancora aperta.",
      "weekStreakUpToLastWeek_other": "{{count}} settimane di fila con almeno una seduta, fino alla settimana scorsa. Questa settimana è ancora aperta.",
      "weekStreakNone": "Nessuna seduta la settimana scorsa e ancora nessuna questa settimana. Questa settimana è ancora aperta.",
      "weekStreakEmpty": "Ancora nessuna seduta.",
      "weekStreakSessionsHelp": "Sessioni di ciascuna settimana. La colonna col bordo è questa settimana: conta già.",
      "recordsTitle": "Record",
      "recordsHelp": "Migliori record per ripetizione per esercizio. Più recenti in alto.",
      "recordsEmpty": "Nessun record. Logga qualche serie con peso per popolare la lista.",
      "recordsAllTime": "Sempre",
      "recordsThisYear": "{{year}}",
      "recordsSearch": "Filtra per esercizio",
      "recordsNoMatch": "Nessun esercizio corrisponde al filtro.",
      "tagVolumeTitle": "Volume per tag",
      "tagVolumeWeeksHelp": "Il volume di allenamento di un muscolo per settimana. Scegli il muscolo.",
      "chartE1rm": "1RM stimato",
      "chartVolume": "Volume",
      "chartLoadFailed": "Impossibile caricare il grafico.",
      "chartEmpty": "Nessuna serie con peso nella finestra recente.",
      "viewByExercise": "Per esercizio",
      "viewByTag": "Per tag",
      "noTags": "Nessun volume sui muscoli nelle ultime settimane.",
      "chartMax": "MAX (kg)",
      "chartEstimatedBadge": "con overlay e1RM",
      "prFound": "PR trovato: {{weight}}",
      "prUpdating": "Aggiorno…",
      "painSeverity": {
        "red": "rosso",
        "yellow": "giallo",
        "green": "verde"
      },
      "balance": {
        "title": "Bilanciamento dei movimenti",
        "help": "Serie e volume per pattern di movimento su {{days}} giorni, ordinati per serie. Il piccolo numero \"X/7g\" conta gli ultimi 7 di quei giorni, utile per individuare una singola spinta recente (o un calo voluto) che la finestra più lunga nasconde."
      },
      "empty": "Nessuna attività recente da confrontare",
      "pain": {
        "title": "Dolore × volume",
        "help": "Per ogni muscolo segnalato nella tua mappa del dolore, mostra il carico di allenamento recente. Pallino rosso = dolore segnalato rosso (evita carichi pesanti), giallo = cautela, verde = monitora. I due numeri di volume sono il carico degli ultimi 7 giorni e quello dell'intera finestra di {{days}} giorni su quel muscolo. Un carico pesante prolungato su un muscolo rosso è il segnale a più alto rischio di questa pagina.",
        "noPain": "Nessun muscolo segnalato nella tua mappa del dolore",
        "sevRed": "Evita",
        "sevYellow": "Cautela",
        "sevGreen": "Monitora"
      },
      "trends": {
        "a11yUp": "in progressione",
        "a11yFlat": "plateau",
        "a11yDown": "in regressione",
        "title": "Trend E1RM",
        "help": "Per ogni pattern di movimento (squat, hinge, push, pull, …) mostra l'esercizio con l'e1RM massimo più alto, contando solo gli esercizi con un trend leggibile: almeno {{points}} punti distribuiti su almeno {{spanDays}} giorni. Grafico = punti e1RM su {{days}} giorni (tocca un punto per leggerne valore e data). Freccia = trend su quei giorni: ↗ in progressione, → plateau, ↘ in regressione. Un pattern allenato in cui nessun esercizio arriva a quella soglia lo dice, invece di mostrare un numero. Un esercizio fermo da oltre {{freshDays}} giorni cede il pattern a quello allenato ora, e resta sul grafico dietro di esso.",
        "fewData": "Pochi dati in {{days}} g",
        "noEligible": "Nessun esercizio con almeno {{points}} punti in {{spanDays}} giorni.",
        "notMeasurable": "Non ancora misurabile: nessuna serie di {{name}} è andata vicino al limite. Una serie portata quasi a cedimento (un AMRAP) mostrerebbe qui la forza.",
        "machineNotMeasurable": "{{value}}, non ancora misurabile",
        "machineMore": "{{machine}} · +{{count}}",
        "machineA11y_one": "{{exercise}}, {{machine}}. Mostra l'altra macchina.",
        "machineA11y_other": "{{exercise}}, {{machine}}. Mostra le altre {{count}} macchine.",
        "machineSessions_one": "{{count}} seduta",
        "machineSessions_other": "{{count}} sedute",
        "compareCtaA11y": "Cambia l'esercizio con cui confrontare {{pattern}}",
        "compareSeparator": "vs",
        "compareClearA11y": "Togli il tuo confronto per {{pattern}} e torna a quello suggerito",
        "comparedManualA11y": "{{current}} confrontato con {{name}}, scelta tua",
        "comparedWithA11y": "{{current}} confrontato con {{name}}, che occupava prima questo pattern"
      },
      "repsAtLoad": {
        "a11yUp": "in salita",
        "a11yFlat": "stabile",
        "a11yDown": "in calo",
        "title": "Ripetizioni a carico fisso",
        "help": "Per gli esercizi in cui ripeti lo stesso carico, mostra come vanno le ripetizioni a quel peso fisso su {{days}} giorni: il guadagno di forza che il grafico e1RM non vede sugli alti-rep e sulle macchine. Barre = ripetizioni al carico, una per seduta (tocca una barra per la data). Freccia = trend: ↗ in salita, → stabile, ↘ in calo. Contano solo le serie con lo sforzo registrato, così più ripetizioni non possono voler dire solo una giornata più facile.",
        "repsValue": "{{reps}} × {{load}}",
        "fewData": "Pochi dati in {{days}} g",
        "notMeasurable": "Non ancora misurabile: le tue serie di {{name}} a {{load}} non hanno lo sforzo registrato, quindi più ripetizioni potrebbero voler dire solo una giornata più facile. Una serie portata quasi a cedimento — o lo sforzo registrato — mostrerebbe qui la tua forza."
      },
      "period": {
        "all": "tutto"
      },
      "loadFailed": "Impossibile caricare",
      "density": {
        "title": "Densità",
        "help": "Volume diviso per la durata della sessione, kg/min. Si legge come \"quanto era densa quella sessione\": in salita significa lo stesso carico in meno tempo (migliore condizionamento) o più carico nello stesso tempo (migliore forza). Un calo improvviso senza cambiare il programma spesso indica fatica: i recuperi si sono allungati anche se non era previsto.",
        "empty": "Servono 3+ sessioni cronometrate per tracciare la densità"
      },
      "frequency": {
        "title": "Esercizi più trascurati",
        "help": "Top 8 esercizi ordinati per giorni dall'ultima registrazione, dai più trascurati. Il suffisso X/{{days}}g conta le serie degli ultimi {{days}} giorni. Un lungo stop significa che o è stato tolto di proposito o il programma è andato alla deriva. Utile per individuare il lavoro accessorio sparito in silenzio."
      },
      "intensityHeatmap": {
        "title": "Heatmap di intensità",
        "help": "Griglia per-esercizio dei set completati ordinati per fascia di ripetizioni e intensità (% del 1RM). Range di forza (85%+) in basso a destra, ipertrofia in mezzo, resistenza in alto a sinistra. Scegli un esercizio per vedere dove si concentrano i suoi set.",
        "exerciseLabel": "Esercizio",
        "choosePrompt": "Scegli un esercizio",
        "noEligible": "Registra un 1RM su almeno un esercizio per calcolare l'intensità.",
        "noMax": "Nessun 1RM registrato per questo esercizio.",
        "totalSets": "{{n}} set · 1RM {{max}}",
        "clear": "Nessuno"
      },
      "prTimeline": {
        "title": "Timeline dei PR",
        "help": "I massimali nel tempo, dal più recente. Testato significa un PR a una ripetizione confermato; ogni altra etichetta è una stima di partenza, non un massimale testato.",
        "empty": "Nessun massimale registrato.",
        "rowA11y": "{{name}}, {{value}}, {{date}}, {{source}}",
        "truncated_one": "Ultimi {{cap}} di {{count}} MAX",
        "truncated_other": "Ultimi {{cap}} di {{count}} MAX",
        "source": {
          "manual": "Manuale",
          "tested": "Testato",
          "derived": "Derivato",
          "calculated_seed": "Valore iniziale",
          "imported": "Importato",
          "unknown": "Sconosciuto"
        },
        "helpPeriod": "I massimali fissati in questo periodo, dal più recente. Testato significa un PR a una ripetizione confermato; ogni altra etichetta è una stima di partenza, non un massimale testato.",
        "emptyPeriod": "Nessun massimale fissato in questo periodo."
      },
      "a11y": {
        "severityAlarm": "Allarme",
        "severityWarn": "Avviso",
        "severityInfo": "Info"
      },
      "config": {
        "title": "Personalizza Progressi",
        "open": "Personalizza Progressi",
        "saveError": "Non è stato possibile salvare la disposizione di Progressi. Riprova.",
        "widget": {
          "rhythm": "Ritmo di allenamento",
          "prTimeline": "Timeline dei PR",
          "weekStreak": "Serie di costanza"
        }
      },
      "coverageRefreshing": "Aggiornamento…",
      "report": {
        "open": "Crea un report",
        "title": "Report di allenamento",
        "titleOf": "Report di allenamento: {{name}}",
        "period": "dal {{from}} al {{to}}",
        "from": "Dal",
        "to": "Al",
        "pickA11y": "{{label}}: {{value}}. Cambia la data",
        "periodHint": "Qualsiasi periodo fino a {{days}} giorni, anche nel passato.",
        "chooseSections": "Scegli le sezioni",
        "shareImage": "Condividi come immagine",
        "advanced": "Report avanzato",
        "pdfExport": "Esporta in PDF",
        "comparePeriods": "Confronta due periodi",
        "sectionsTitle": "Sezioni del report",
        "advancedSections": "Sezioni avanzate",
        "noSections": "Nessuna sezione scelta. Scegli le sezioni per vedere il report.",
        "sessions": "Sedute nel periodo",
        "frequencyHelp": "Sedute per settimana lungo il periodo.",
        "premiumHint": "Le opzioni Premium non fanno parte del report base.",
        "shareNeedsSection": "Scegli almeno una sezione per condividere il report.",
        "pagesTruncated": "Il report condiviso si ferma a {{max}} immagini. Scegli meno sezioni per condividere il resto.",
        "preparing": "Preparo l'immagine {{page}}…",
        "pagesReady": "Le immagini sono pronte da condividere.",
        "adjustedToday": "Un report finisce al più tardi oggi: la data è stata spostata a oggi.",
        "adjustedOther": "L'altra data si è spostata per tenere il periodo in ordine.",
        "adjustedCapped": "Un report copre al massimo {{days}} giorni: l'altra data si è spostata.",
        "emptyPeriod": "Nessun allenamento in questo periodo."
      },
      "coverageNotConfirmed": "Aggiornamento non riuscito — questi sono gli ultimi numeri che abbiamo"
    },
    "profile": {
      "title": "Profilo",
      "navMaxes": "MAX",
      "navMaxesSub": "Imposta, modifica e rivedi i tuoi MAX per esercizio.",
      "navCatalogSub": "Sfoglia esercizi, record e cronologia.",
      "navRestTimer": "Timer",
      "navRestTimerSub": "Default recupero + tenuta, suono, per esercizio",
      "labelEmail": "EMAIL",
      "labelApp": "VERSIONE APP",
      "labelBackend": "VERSIONE BACKEND",
      "labelPrivacy": "PRIVACY",
      "privacyHelp": "Esporta tutto in JSON o cancella l'account in modo definitivo.",
      "legalLinkHint": "Si apre nel browser",
      "exportButton": "Esporta i miei dati",
      "deleteButton": "Elimina il mio account",
      "deleteAlertTitle": "Elimina account",
      "deleteAlertBody": "Verranno eliminati definitivamente il tuo account, le sessioni, i piani, i programmi e i MAX. Le cancellazioni non si recuperano.",
      "deleteAlertCancel": "Annulla",
      "deleteAlertConfirm": "Elimina",
      "signOut": "Esci",
      "exportShareTitle": "Export $t(brand.product) {{date}}",
      "labelLanguage": "Lingua",
      "languageHelp": "Scegli la lingua usata nell'app. Salvata su questo dispositivo.",
      "languageCancel": "Chiudi"
    },
    "summary": {
      "prBadge": "record personale"
    },
    "logger": {
      "title": "Nuovo workout",
      "cancel": "Annulla",
      "swapKindTitle": "Cambiare tipo di esercizio?",
      "swapKindBody": "Questo esercizio si registra in modo diverso, quindi i set già inseriti qui verranno cancellati.",
      "swapKindConfirm": "Cambia e cancella",
      "failConfirmTitle": "Reps valide",
      "failConfirmBody_one": "Salvo {{count}} rep pulita. Quella fallita non conta.",
      "failConfirmBody_other": "Salvo {{count}} rep pulite. Quella fallita non conta.",
      "failConfirmHint": "Correggi se ne hai fatte di più o di meno.",
      "failConfirmStepDown": "Una rep pulita in meno",
      "failConfirmStepUp": "Una rep pulita in più",
      "failConfirmSave": "Salva",
      "amrapConfirmTitle": "Fino a cedimento?",
      "amrapConfirmBody": "Rispondi sì solo se la ripetizione dopo non sarebbe salita.",
      "amrapNeedsReps": "Scrivi le ripetizioni che hai fatto per registrare la serie.",
      "amrapBadgeWithFloor": "AMRAP ≥ {{reps}}",
      "amrapPrescribedFloorA11y": "AMRAP: almeno {{reps}} ripetizioni, poi il più possibile",
      "amrapConfirmAtFloor": "Hai segnato {{reps}}, e il programma ne chiedeva almeno {{floor}}.",
      "amrapFloorPlaceholder": "≥ {{reps}}",
      "amrapConfirmYes": "Sì, a cedimento",
      "amrapConfirmNo": "No, ne avevo ancora",
      "failBadge": "Fallita",
      "failBadgeA11y": "serie fallita",
      "save": "Salva",
      "remove": "Rimuovi",
      "replace": "Sostituisci",
      "addExercise": "Aggiungi esercizio",
      "addSet": "Aggiungi serie",
      "addRound": "Aggiungi giro",
      "pickerTitle": "Scegli esercizio",
      "pickerSearch": "Cerca esercizi",
      "pickerResultsN_one": "{{count}} risultato",
      "pickerResultsN_other": "{{count}} risultati",
      "pickerEmpty": "Nessun esercizio corrisponde.",
      "pickerClearFilters": "Pulisci filtri",
      "pickerFilters": "Filtri",
      "pickerFiltersN": "Filtri ({{n}})",
      "empty": "Nessun esercizio. Aggiungine uno per iniziare.",
      "setReps": "RIP",
      "amrapPrescribedA11y": "AMRAP: almeno le ripetizioni previste, poi quante ne riesci",
      "setPercentOfMax": "%",
      "prescribedLoadTip": "Il carico che stai prescrivendo, nell'unità in cui è scritto il programma. Se sono chili o una % del massimale lo scegli qui sotto.",
      "setPercentOfMaxA11y": "Percentuale del massimale",
      "stepAdd": "Aumenta",
      "stepSubtract": "Diminuisci",
      "amrapChipPrescribe": "Prescrivi più ripetizioni possibili",
      "tipAmrapPrescribe": "Chiede all'atleta più ripetizioni possibili su questa serie. Il numero di ripetizioni resta il minimo da raggiungere.",
      "entryNoteEdit": "Modifica la nota dell'esercizio",
      "entryNoteAdd": "＋ Nota esercizio",
      "setWeightBothSidesA11y": "Peso di un lato, contati entrambi i lati ({{unit}})",
      "setTypeWorking": "Normale",
      "setTypeDropset": "Dropset",
      "setTypeMyorep": "Myo-rep",
      "setCommentLabel": "Commento del set",
      "unitLabel": "Unità",
      "discardTitle": "Scartare il workout?",
      "discardBody": "Perderai le serie inserite fin qui.",
      "discardCancel": "Continua",
      "discardConfirm": "Scarta",
      "discardEditTitle": "Scartare le modifiche?",
      "discardEditBody": "La sessione salvata resta com'era.",
      "discardEditCancel": "Continua a modificare",
      "errNoEntries": "Aggiungi almeno un esercizio.",
      "errNoSets": "Ogni esercizio richiede almeno una serie con ripetizioni e peso.",
      "errInvalid": "Il workout non si può salvare così.",
      "errSaveFailed": "Salvataggio fallito. Il workout è ancora qui: premi di nuovo Salva.",
      "errNotSignedIn": "Non hai effettuato l'accesso. Il workout resta qui: salvalo quando rientri.",
      "errSetsUnknownExercise": "Un esercizio di questo allenamento non è riconosciuto. Cambialo e salva di nuovo.",
      "errSetsInvalidTag": "Un tag su una serie non è accettato. Toglilo e salva di nuovo.",
      "errSetsInvalid": "Alcune serie non sono valide. Controlla peso e ripetizioni, poi salva di nuovo.",
      "errSetsNotSaved": "Alcune serie non sono arrivate al server. Prova a salvare di nuovo.",
      "errCorrectionTooBig": "Troppe serie cambiate insieme. Salva meno modifiche, poi il resto.",
      "errCorrectionBusy": "L'allenamento era occupato. Aspetta un momento e salva di nuovo.",
      "errCorrectionConflict": "L'allenamento è cambiato su un altro dispositivo. Chiudilo, riaprilo e correggilo di nuovo.",
      "errCorrectionStale": "L'allenamento è stato salvato di nuovo dopo che l'hai aperto. Chiudilo, riaprilo e correggilo di nuovo.",
      "errCorrectionTimes": "L'allenamento finisce prima di iniziare. Controlla inizio e fine, poi salva.",
      "errCorrectionImport": "Questo allenamento arriva da Health Connect e non si corregge da qui. Correggilo in Health Connect.",
      "errCorrectionGone": "Questo allenamento è stato cancellato su un altro dispositivo. La correzione non è persa: la trovi in cima ad Allenamenti, tocca Salva come nuovo.",
      "errCorrectionGoneHere": "Questo allenamento è stato cancellato su un altro dispositivo. La correzione non è persa: tocca Salva come nuovo per tenerla come nuovo allenamento.",
      "correctionToBell": "La correzione precedente di questo allenamento è stata rifiutata, e questa si è unita a lei. Non è persa: la trovi in cima ad Allenamenti, tocca Salva come nuovo.",
      "setNumberHeader": "SET",
      "removeSetA11y": "Rimuovi questa serie",
      "serverErrorTitle": "IL SERVER HA RIFIUTATO IL SALVATAGGIO",
      "serverErrorHint": "Correggi il workout e riprova. Se il messaggio non è chiaro, condividilo con il tuo coach.",
      "setExtra": "EXTRA",
      "setWeightTip": "Peso sollevato per serie. Cambia kg/lb col chip unità su ogni riga.",
      "setExtraTip": "Assistenza o carico aggiunto al corpo libero. Scrivi un meno (−) per l'assistenza con elastico/macchina (il campo diventa ambra); cintura/disco aggiunto è positivo.",
      "setWeightMixedTip": "Gruppo misto: carico bilanciere/stack nelle righe con peso, ± extra nelle righe a corpo libero (meno = assistenza).",
      "editTitle": "Modifica workout",
      "planTitle": "Pianifica",
      "programTitle": "Programma",
      "repeatTitle": "Ripeti workout",
      "minimize": "Riduci workout",
      "closeWorkout": "Chiudi workout",
      "saveWorkout": "Salva workout",
      "bilateral": "Bilaterale",
      "unilateral": "Unilaterale",
      "plates": "Dischi",
      "numInvalid": "Numero non valido",
      "numRange": "{{label}} {{min}}–{{max}}",
      "setRpeHint": "Sforzo 1–10",
      "setNoteLabel": "Nota",
      "setNotePlaceholder": "Cue, tecnica, sensazione…",
      "totalsSets_one": "{{count}} serie",
      "totalsSets_other": "{{count}} serie",
      "totalsReps_one": "{{count}} rep",
      "totalsReps_other": "{{count}} reps",
      "totalsTitle": "Totali workout",
      "totalsVolume": "Volume",
      "totalsSetsShort": "Serie",
      "totalsRepsShort": "Reps",
      "totalsByMuscle": "Lavoro per muscolo",
      "restRest": "Recupero",
      "startRestManual": "Avvia recupero",
      "restSkip": "Salta",
      "restWord": "Riposo",
      "restAddStep": "+{{n}} secondi",
      "restSubtractStep": "−{{n}} secondi",
      "restStartedA11y": "Recupero iniziato, {{time}}.",
      "restEndedA11y": "Recupero finito.",
      "restInviteLabel": "Recupero un po' più lungo?",
      "restInviteAdd": "+{{time}}",
      "restInviteAddA11y": "Aggiungi {{time}} al recupero",
      "restInviteA11y": "Recupero un po' più lungo? Puoi aggiungere {{time}}.",
      "setsCarriedOverA11y": "Serie riprese dall'ultima volta.",
      "restInviteTipTitle": "Perché un recupero più lungo?",
      "restInviteTipBody": "Quella serie è finita a cedimento o quasi. Negli studi, un recupero più lungo dopo serie così ha conservato più forza per la serie successiva. Circa 3 min, fino a 5 sui carichi pesanti. Quanto recuperare lo decidi tu.",
      "loadBarA11y": "Controlli del peso",
      "restBarA11y": "Timer del recupero",
      "restRemainingA11y": "{{time}} di riposo",
      "restEditA11y": "Imposta il recupero predefinito per questo esercizio",
      "restEditTitle": "Recupero predefinito",
      "restEditBody": "Salva questo recupero come predefinito per {{name}}",
      "restEditSave": "Salva",
      "restEditSaving": "Salvataggio…",
      "restEditError": "Impossibile salvare il recupero predefinito. Riprova.",
      "restEditCancel": "Annulla",
      "restEditSaveAsGlobal": "Usa come default globale",
      "restStepMinus": "Diminuisci di {{step}} secondi",
      "restStepPlus": "Aumenta di {{step}} secondi",
      "restPause": "Pausa",
      "restResume": "Riprendi",
      "restExpiredTitle": "Riposo finito",
      "holdExpiredTitle": "Tempo finito",
      "restExpiredBody": "È ora di riprendere.",
      "holdExpiredBody": "Tocca la banda dello sforzo per registrare la serie.",
      "boutExpiredTitle": "Bout finito",
      "boutExpiredBody": "Serie registrata da sola.",
      "workStartedTitle": "Via",
      "cueLeadInWork": "Lavoro — {{n}} s",
      "cueLeadInRest": "Recupero — {{n}} s",
      "cueChannel": {
        "tick": "Bip del conto alla rovescia",
        "work": "Inizio del lavoro"
      },
      "boutAutoLoggedA11y": "Bout finito, {{time}} registrati.",
      "workoutFgsTitle": "Allenamento in corso",
      "workoutFgsBodyNamed": "{{name}} · tocca per riprendere",
      "workoutFgsBody": "Tocca per riprendere la sessione",
      "descriptionToggle": "Mostra / nascondi descrizione",
      "notesToggle": "Note per questo allenamento",
      "infoButton": "Info",
      "notesEmpty": "Nessuna nota per questo allenamento",
      "notesProgramLabel": "Programma",
      "notesWorkoutLabel": "Questo allenamento",
      "note": "Nota",
      "rpeChip": "RPE",
      "historyChip": "Storico",
      "more": "Altre azioni",
      "addGroup": "Crea un superset con un altro esercizio",
      "cardioDuration": "Durata",
      "cardioDurationPlaceholder": "Secondi",
      "cardioDistance": "Distanza",
      "cardioWeight": "Peso",
      "cardioHr": "FC media",
      "cardioCalories": "Calorie",
      "cardioOptionalsShow": "Mostra altri campi",
      "cardioOptionalsHide": "Nascondi altri campi",
      "dateEditor": "Data e durata",
      "dateLabel": "Data",
      "startTimeLabel": "Inizio",
      "endTimeLabel": "Fine",
      "durationLabel": "Durata",
      "historyToggle": "Storico",
      "historyBest": "Migliore",
      "historyCopy": "Copia",
      "historyBodyweight": "{{reps}} reps PC",
      "historyEstimateHeader": "Stima da un esercizio simile",
      "historyEstimatedFrom": "Da {{name}}",
      "historyNoEstimate": "Nessuno storico, e nessun esercizio simile da cui stimare.",
      "copyDialogTitle": "Copia sessione",
      "copyDialogBody": "Sovrascrivi le serie in attesa o aggiungile alle esistenti?",
      "copyOverwrite": "Sovrascrivi",
      "copyAppend": "Aggiungi",
      "resumeDiscard": "Scarta",
      "conflictTitle": "Allenamento in corso",
      "conflictBody": "Stai già registrando un allenamento. Continua oppure mostralo per salvarlo o scartarlo.",
      "nameLabel": "Nome workout",
      "namePlaceholder": "Nome: es. Push…",
      "editNameA11y": "Modifica nome allenamento",
      "setStateA11y": "serie {{index}} {{state}}",
      "rpePlaceholder": "RPE",
      "unitA11y": "unità {{unit}}",
      "stepperPositive": "aggiungi",
      "stepperNegative": "sottrai",
      "rirPlaceholder": "RIR",
      "effortMeterEasy": "Facile",
      "effortMeterHard": "Difficile",
      "effortWord": "Sforzo",
      "holdSlotDone": "FATTO",
      "holdSlotHeld": "TENUTO",
      "holdSlotDoneA11y": "{{time}} fatti",
      "holdSlotFailedA11y": "{{time}}, non completato",
      "holdSlotHeldA11y": "{{time}} tenuti",
      "effortMeterFail": "Fail",
      "effortMeterTargetWord": "obiettivo",
      "effortQuestionRir": "Reps in riserva?",
      "effortQuestionRpe": "Quanto è stato duro?",
      "effortQuestionHint": "Apre la scala dello sforzo — com'è fatta e come cambiarla",
      "effortMeterHintLog": "Registra anche il set come completato",
      "effortMeterHintRunning": "Ferma il timer e registra la serie",
      "effortMeterHintEdit": "Aggiorna lo sforzo di questo set registrato",
      "effortMeterFailHintLog": "Registra il set come fallito",
      "effortMeterFailHintEdit": "Alterna il set tra completato e fallito",
      "effortMeterTapCta": "Tocca per registrare il set",
      "effortMeterStopCta": "Tocca per fermare e registrare",
      "effortNudgeOptOut": "Disattiva promemoria",
      "effortNudgeOptOutHint": "Prima chiede conferma. Puoi riattivarlo in Impostazioni.",
      "effortNudgeOptOutConfirmTitle": "Disattivare questo promemoria?",
      "effortNudgeOptOutConfirmBody": "Puoi riattivarlo in qualsiasi momento in Impostazioni.",
      "effortNudgeOptOutConfirmButton": "Disattiva",
      "effortMeterAmrapDone": "Fatto",
      "effortMeterAmrapHint": "Registra la serie a cedimento — nessuna ripetizione rimasta",
      "amrapChip": "Più ripetizioni possibili",
      "burnPlus": "Burn+",
      "burnPlusChip": "Tecnica di intensità Burn+ (dropset / myo-rep)",
      "loadAxisTitle": "Cosa determina il carico",
      "timedChip": "A tempo",
      "noteChip": "Nota",
      "noteClose": "Fatto",
      "effortLegendA11y": "Aiuto sulla scala dello sforzo",
      "rirLegendTitle": "RIR: ripetizioni di riserva",
      "rirLegendBody": "0 = nessuna ripetizione in tasca\n1 = 1 ripetizione in tasca\n2 = 2 ripetizioni\n3 = buon margine — è ancora una serie allenante\n4–5 = lavoro leggero, non conta\n6+ = riscaldamento",
      "rpeLegendTitle": "RPE: sforzo percepito",
      "rpeLegendBody": "10 = nessuna ripetizione in tasca\n9 = 1 ripetizione in tasca\n8 = 2 ripetizioni\n7 = buon margine — è ancora una serie allenante\n5–6 = lavoro leggero, non conta\n4 o meno = riscaldamento",
      "timerStartCountdown": "Avvia il conto alla rovescia",
      "timerStartCountup": "Avvia il cronometro",
      "timerSettings": "Timer predefiniti per questo esercizio",
      "holdHeaderHours": "h",
      "holdHeaderMinutes": "min",
      "holdHeaderSeconds": "s",
      "holdHours": "Ore",
      "holdMinutes": "Minuti",
      "holdSeconds": "Secondi",
      "holdSubTen": "-10s",
      "holdAddTen": "+10s",
      "holdCancel": "Annulla",
      "holdClockElapsedA11y": "{{time}} trascorsi",
      "holdClockOvertimeA11y": "{{time}} oltre il target",
      "pausedReadoutA11y": "{{label}}, in pausa",
      "holdClockRemainingA11y": "{{time}} rimanenti",
      "holdFlip": "Cambia direzione",
      "holdExtraWeight": "Extra",
      "lateralityTipUni": "UNI · registra un lato; il volume conta entrambi (×2).",
      "lateralityTipBi": "BI · carico bilaterale; il volume conta una volta (×1).",
      "tabExercises": "Esercizi",
      "tabSuperset": "Superset",
      "pickerAddN": "Aggiungi {{n}}",
      "pickerAlreadyInWorkout": "Già in questo allenamento",
      "pickerAlreadyInBlock": "Già in questo blocco",
      "pickerPin": "Aggiungi ai preferiti",
      "pickerUnpin": "Rimuovi dai preferiti",
      "noteReadA11y": "Nota esercizio — tocca per leggerla intera",
      "prescriptionReadA11y": "Indicazione serie — tocca per leggerla intera",
      "tipAmrap": "Più ripetizioni possibili — porta la serie al cedimento tecnico.",
      "tipBurnPlus": "Tecniche di intensità — mostra Dropset o Myo-rep per spingere la serie oltre il cedimento.",
      "targetEyebrow": "Traguardo",
      "historySetCount": "ultimi {{n}} set",
      "historyBlinkToggle": "Lampeggia quando un esercizio non lo fai da un pezzo",
      "historyCopyLast": "Copia l'ultima seduta",
      "historyLooking": "Cerco questo esercizio…",
      "historyUnavailable": "Non riesco a raggiungere il tuo storico adesso — non vuol dire che non ci sia.",
      "historyBlinkOn": "Lampeggio acceso",
      "historyBlinkOff": "Lampeggio spento",
      "historyToggleAged": "Storico, ultima volta {{age}}",
      "maxEditNoneA11y": "Imposta il tuo massimale per questo esercizio",
      "maxEditA11y": "Modifica il tuo massimale",
      "maxEditStaleA11y": "Modifica il tuo massimale, ultima volta {{age}}",
      "maxHeaderNone": "Nessun MAX ancora",
      "maxHeaderValue": "MAX {{weight}}",
      "maxHeaderStale": "MAX {{weight}} · {{age}}",
      "proposedWeightTipTestedMax": "Proposto perché questa serie arrivi a {{effort}}, ricavato dal massimale che hai testato. È un punto di partenza, non una prescrizione: cambialo.",
      "proposedWeightTipMax": "Proposto perché questa serie arrivi a {{effort}}, ricavato dal tuo massimale registrato. È un punto di partenza, non una prescrizione: cambialo.",
      "proposedWeightTipHistory": "Proposto perché questa serie arrivi a {{effort}}, ricavato dalla tua ultima serie su questo esercizio. È un punto di partenza, non una prescrizione: cambialo.",
      "historySectionComputed": "Da dove viene questo peso",
      "historyProposalSource_one": "Dalla tua ultima seduta di {{name}}",
      "historyProposalSource_other": "Dalle tue ultime {{count}} sedute di {{name}}",
      "historyProposalAxisReps": "Più ripetizioni, stesso peso",
      "historyProposalAxisLoad": "Più peso, stesse ripetizioni",
      "historyProposalAxisTrade": "Scambio: più peso, meno ripetizioni",
      "historyInUse": "in uso",
      "historyCopyWeightA11y": "Usa questo peso sul set che stai facendo",
      "historyCopySetA11y": "Copia questo set su quello che stai facendo",
      "historyNone": "Questo esercizio non l'hai ancora registrato.",
      "historySourceTestedMax": "Per arrivare a {{effort}} — dal 1RM che hai testato",
      "historySourceMax": "Per arrivare a {{effort}} — dal tuo massimale registrato",
      "historySourceLastSet": "Per arrivare a {{effort}} — dal tuo ultimo set qui",
      "historySourcePercent": "Una percentuale del tuo massimale, decisa dal programma",
      "historySourcePrescribed": "Il peso scritto nel programma",
      "historySourceLastWeight": "L'ultimo peso che hai davvero usato qui",
      "historySourceManual": "Questo l'hai scritto tu",
      "historySourcePercentOf": "{{pct}}% del tuo massimale, deciso dal programma",
      "draftToday": {
        "status": "Bozza · non salvata",
        "title": "Seduta di oggi",
        "exercises_one": "{{count}} esercizio",
        "exercises_other": "{{count}} esercizi",
        "scope": "Per i muscoli sotto il volume minimo che non alleni da almeno {{hours}} ore.",
        "scopeMav": "Per i muscoli sotto il volume minimo, poi per quelli sotto MAV, che non alleni da almeno {{hours}} ore.",
        "scopeAnyway": "Riposo ignorato: prima i muscoli che non alleni da più tempo.",
        "reason_one": "<b>{{muscle}}</b>: {{n}} serie al minimo questa settimana",
        "reason_other": "<b>{{muscle}}</b>: {{n}} serie al minimo questa settimana",
        "reasonMav_one": "<b>{{muscle}}</b>: {{n}} serie sotto MAV questa settimana",
        "reasonMav_other": "<b>{{muscle}}</b>: {{n}} serie sotto MAV questa settimana",
        "lastTrained": "ultima volta {{age}}",
        "noHistory": "Mai fatto · ancora nessuna rep né kg",
        "reps": "reps",
        "painVeto": "Esclusi per {{parts}} (mappa del dolore): {{muscles}}.",
        "source": "Reps: il tuo set migliore delle ultime 8 settimane. Kg: calcolati per lasciare 3 reps in riserva. Non si salva niente finché non inizi.",
        "discard": "Scarta la bozza",
        "timeA11y": "Tempo a disposizione",
        "minutes": "{{n}} min",
        "estimate": "~{{n}} min",
        "shuffleRowA11y": "Un altro esercizio per {{muscle}}",
        "shuffleAllA11y": "Altri esercizi per ogni muscolo",
        "shuffleAll": "Rimescola tutto",
        "allSets_one": "vale per tutte le {{n}} serie",
        "allSets_other": "vale per tutte le {{n}} serie",
        "intensityChoice": "{{n}}%",
        "intensityA11y": "Intensità: quota del volume settimanale",
        "intensityChipA11y": "{{n}}% del volume settimanale",
        "intensityToday": "oggi al {{n}}%",
        "surprise": "Sorprendimi",
        "surpriseHint": "Esercizi a caso invece di quelli che fai più spesso",
        "anchorOwn": "Dal tuo set migliore, {{date}} · {{age}}",
        "anchorSimilar": "Reps da {{name}} · ancora nessun kg per questo",
        "timeTitle": "Tempo (min)",
        "intensityTitle": "Intensità",
        "restTitle": "Riposo",
        "restChoice": "{{n}} h",
        "restA11y": "Riposo: un muscolo allenato in questo intervallo resta fuori",
        "restChipA11y_one": "{{count}} ora",
        "restChipA11y_other": "{{count}} ore",
        "restingUntil": "{{muscles}}: a riposo fino a {{day}}",
        "atMinimum": "Ogni muscolo è al suo minimo settimanale.",
        "buildAnyway": "Costruisci comunque",
        "newWorkout": "Nuovo allenamento"
      },
      "pin": "Pin",
      "pinned": "fissato",
      "hintTitle": "Tocca per sostituire questo esercizio.",
      "hintHowTo": "Come si esegue questo esercizio.",
      "hintTarget": "Serie di questa settimana per muscolo.",
      "hintTrash": "Toglie questo esercizio dall'allenamento.",
      "hintClock": "Le serie passate di questo esercizio.",
      "hintSuperset": "Superset: abbina a un altro esercizio e alterna le serie.",
      "hintSupersetCue": "Superset: tocca per passare all'esercizio successivo.",
      "hintSupersetMenu": "Opzioni superset: aggiungi, riordina, togli o sciogli.",
      "hintWeek": "Tocca per la settimana dopo. Scorri la griglia per tornare indietro.",
      "hintTimed": "A tempo: questa serie si tiene per un tempo, senza contare le ripetizioni.",
      "hintNote": "Nota: scrivi un'indicazione per questa serie.",
      "hintDropsetRemove": "Torna a una sola serie allenante.",
      "hintPinOn": "Fissato: resta in primo piano dopo il recupero. Tocca per sbloccare.",
      "hintPinOff": "Pin: dopo il recupero resti su questo esercizio.",
      "holdHintIntro": "Tieni premuto un bottone per sapere cosa fa.",
      "showHint": "Mostra suggerimento",
      "pickerInDays": "In quali giorni",
      "pickerAddNInDays_one": "Aggiungi {{n}} in {{count}} giorno",
      "pickerAddNInDays_other": "Aggiungi {{n}} in {{count}} giorni",
      "repsRangeA11y": "Intervallo di ripetizioni da {{min}} a {{max}}"
    },
    "coachEdges": {
      "empty": "Nessun edge coach. Un coach può invitarti dall'app web."
    },
    "recovery": {
      "banner": "Allenamento recuperato",
      "orphanedBanner": "Hai corretto questo allenamento, ma era stato cancellato su un altro dispositivo. Tocca Salva come nuovo per tenere la correzione come nuovo allenamento.",
      "tooBigBanner": "La correzione cambiava troppe serie per salvarla in una volta: l'allenamento è rimasto com'era. Tocca Salva come nuovo per tenere la tua versione come nuovo allenamento.",
      "conflictBanner": "L'allenamento è cambiato su un altro dispositivo prima della tua correzione: è rimasto com'era. Tocca Salva come nuovo per tenere la correzione come nuovo allenamento.",
      "timesBanner": "La tua correzione finisce prima di iniziare: l'allenamento è rimasto com'era. Tocca Salva come nuovo, sistema gli orari e salva.",
      "staleBanner": "L'allenamento è stato salvato di nuovo dopo l'inizio della correzione. È rimasto com'era. Tocca Salva come nuovo per tenere la correzione.",
      "refusedBanner": "Il server ha rifiutato la correzione: l'allenamento è rimasto com'era. Tocca Salva come nuovo per tenere la tua versione come nuovo allenamento.",
      "saveAsNew": "Salva come nuovo",
      "title": "Allenamento recuperato",
      "openBody": "Questo allenamento era stato interrotto ed è stato recuperato. Controlla le serie e tocca Salva per registrarlo come nuovo allenamento.",
      "open": "Apri",
      "cancel": "Annulla",
      "liveBusy": "Hai un allenamento in corso. Salvalo o scartalo prima di recuperare questo.",
      "discardTitle": "Scartare l'allenamento recuperato?",
      "discardBody": "L'allenamento recuperato verrà eliminato definitivamente.",
      "discardConfirm": "Scarta",
      "error": "Impossibile recuperare l'allenamento. Riprova.",
      "mergeTitle": "Unisci allenamento",
      "mergePrompt": "Scegli un allenamento dello stesso giorno in cui unire:",
      "noSameDay": "Nessun allenamento dello stesso giorno in cui unire. Usa \"Salva come nuovo\".",
      "nothingToMerge": "Nessuna serie completata da unire. Usa \"Salva come nuovo\".",
      "supportPrefix": "Allenamento tenuto su questo telefono dopo un crash, inviato dalla campanella. JSON della bozza in allegato."
    },
    "group": {
      "title": "Raggruppa questo esercizio",
      "close": "Chiudi",
      "standalone": "Singolo",
      "supersetSection": "SUPERSET",
      "circuitSection": "CIRCUITI",
      "supersetN": "Superset {{n}}",
      "circuitN": "Circuito {{n}}",
      "newSuperset": "+ Nuovo superset",
      "newCircuit": "+ Nuovo circuito"
    },
    "webview": {
      "close": "Chiudi",
      "openExternal": "Apri nel browser",
      "errorTitle": "La pagina non si è caricata",
      "errorBody": "Tocca qui sotto per provare nel browser di sistema.",
      "fallbackErrorTitle": "Impossibile aprire il browser",
      "fallbackErrorBody": "Riprova da un'altra connessione."
    },
    "plates": {
      "title": "Calcolatore dischi",
      "close": "Chiudi",
      "apply": "Applica",
      "targetLabel": "Obiettivo",
      "barLabel": "Bilanciere ({{unit}})",
      "barOptionLabel": "Bilanciere — {{weight}}",
      "barCustom": "Altro…",
      "barCustomLabel": "Peso del bilanciere personalizzato",
      "perSide": "Per lato: {{weight}}",
      "barOnly": "Solo bilanciere — nessun disco.",
      "pairs_one": "{{count}} coppia",
      "pairs_other": "{{count}} coppie",
      "plates_one": "{{count}} disco",
      "plates_other": "{{count}} dischi",
      "loadedSide": "Lato caricato: {{weight}}",
      "singleSideHint": "Un lato solo: i dischi vanno su un lato soltanto. Landmine, t-bar, slitte e leve per braccio si caricano così.",
      "remainder": "Mancano {{weight}} — l'inventario non corrisponde esattamente.",
      "belowBar": "Obiettivo inferiore al bilanciere.",
      "invalid": "Inserisci un peso valido.",
      "inventoryTitle": "Coppie disponibili ({{unit}})",
      "pairsIncrement": "Aggiungi una coppia da {{weight}}",
      "pairsDecrement": "Rimuovi una coppia da {{weight}}",
      "signLabel": "SEGNO EXTRA",
      "signAdd": "+ Peso aggiunto",
      "signAssist": "− Assistito",
      "loadShapeLabel": "Come si carica",
      "loadShapeTwoSides": "Due lati",
      "loadShapeOneSide": "Un lato solo",
      "loadShapeTwoSidesHint": "coppie",
      "loadShapeOneSideHint": "pila unica",
      "composeTitle": "Dischi ({{unit}}) — tocca per aggiungere",
      "composeEmpty": "Nessun disco impostato — indica qui sotto le coppie che hai.",
      "composeAddPair": "Metti una coppia da {{weight}} sul bilanciere",
      "composeAddPlate": "Metti un disco da {{weight}} sul bilanciere",
      "composeRemovePair": "Togli una coppia da {{weight}} dal bilanciere",
      "composeRemovePlate": "Togli un disco da {{weight}} dal bilanciere",
      "roundToLoadable": "Arrotonda a un peso caricabile",
      "calcOpen": "Calcolatrice",
      "calcResult": "Risultato: {{value}} {{unit}}",
      "calcClearKey": "C",
      "calcClear": "Azzera",
      "calcDecimal": "Virgola",
      "calcOpPlus": "Più",
      "calcOpMinus": "Meno",
      "calcOpTimes": "Per",
      "calcOpDivide": "Diviso",
      "calcDismiss": "Chiudi",
      "calcCopy": "Copia nel peso",
      "calcCopyBlocked": "Prima componi un peso maggiore di zero."
    },
    "restTimerScreen": {
      "title": "Timer",
      "back": "Indietro"
    },
    "licenses": {
      "title": "Licenze open source",
      "back": "Indietro",
      "headlineIntro": "$t(brand.product) si appoggia a un piccolo gruppo di librerie che danno forma all'app. Tocca una riga per aprire il progetto — e considera di sostenere quelle che usi di più.",
      "coreSection": "Librerie principali ({{count}})",
      "viewAllTitle": "Mostra tutti i pacchetti",
      "viewAllSub": "Attribuzione completa per i {{count}} pacchetti inclusi nell'APK, raggruppati per progetto.",
      "allTitle": "Tutti i pacchetti ({{count}})",
      "searchAll": "Cerca nome, gruppo, licenza o autore",
      "groupOther": "Altri pacchetti",
      "empty": "Nessun pacchetto corrisponde alla ricerca.",
      "footer": "Generato il {{date}}",
      "openErrorTitle": "Impossibile aprire il link"
    },
    "share": {
      "newPR": "NUOVO PR",
      "topLifts": "TOP ESERCIZI",
      "durationMinute": "min",
      "durationHour": "h",
      "durationMinuteShort": "m",
      "footerSets": "serie",
      "footerDensitySuffix": "/min",
      "fallbackLabel": "Volume Totale",
      "timeLabel": "Tempo Totale",
      "tutLabel": "TUT",
      "impulseUnit": "kg·s",
      "impulseLabel": "Impulso",
      "e1rmSuffix": "E1RM"
    },
    "postSession": {
      "blockCalories": "Calorie",
      "blockEffort": "Sforzo",
      "blockDistance": "Distanza",
      "effortHr": "{{avg}} media · {{peak}} picco bpm",
      "effortHrMax": "{{pct}}% FCmax",
      "shareTitle": "Sessione $t(brand.product)",
      "shareErrorTitle": "Condivisione fallita",
      "headlineLabelPR": "NUOVO E1RM",
      "headlineLabelDelta": "GRANDE BALZO +{{delta}}",
      "headlineLabelSolid": "SESSIONE SOLIDA",
      "headlineSolidValue": "{{volume}} in {{duration}}",
      "headlineFallback": "{{label}} — {{sets}} serie",
      "blockTopLifts": "Top esercizi",
      "fromSet": "da {{weight}} × {{reps}}",
      "blockVolume": "Volume",
      "blockDuration": "Durata",
      "blockDensity": "Densità",
      "blockNotes": "Note",
      "barsTitle": "Lavoro per muscolo",
      "bodyTitle": "Muscoli allenati",
      "sharing": "Preparazione…",
      "shareCta": "Condividi scheda sessione",
      "done": "Fatto",
      "summaryTitle": "Allenamento salvato",
      "maxProposed_one": "Nuovo MAX proposto per {{exercises}}: lo trovi nelle notifiche.",
      "maxProposed_other": "Nuovi MAX proposti per {{exercises}}: li trovi nelle notifiche."
    },
    "common": {
      "back": "Indietro",
      "save": "Salva",
      "cancel": "Annulla",
      "close": "Chiudi"
    },
    "account": {
      "title": "Account",
      "labelDiagnostics": "DIAGNOSTICA",
      "navSub": "Nome, password, esporta, elimina, esci",
      "nameLabel": "NOME",
      "namePlaceholder": "Il tuo nome",
      "saved": "Salvato",
      "passwordLabel": "CAMBIA PASSWORD",
      "currentPassword": "Password attuale",
      "newPassword": "Nuova password",
      "confirmPassword": "Conferma nuova password",
      "passwordChanged": "Password cambiata.",
      "passwordSubmit": "Aggiorna password",
      "deleteNeedsConnection": "Per cancellare l'account serve una connessione. Riconnettiti e riprova: questa richiesta non viene mai messa in coda."
    },
    "prefs": {
      "title": "Unità e visualizzazione",
      "navSub": "Unità, lingua, suggerimenti",
      "unitsLabel": "Unità",
      "unitsHelp": "Unità di peso predefinita per le nuove serie. Puoi comunque cambiarla per riga nel logger.",
      "weekStartLabel": "La settimana inizia il",
      "weekStartHelp": "Il giorno in cui riparte la tua settimana di allenamento. Gli obiettivi settimanali per muscolo contano da qui.",
      "unitsKg": "Chilogrammi (kg)",
      "unitsLb": "Libbre (lb)",
      "glucoseUnitsLabel": "Unità glicemia",
      "glucoseUnitsHelp": "Come viene mostrata e inserita la glicemia. Salvata allo stesso modo.",
      "glucoseMmol": "mmol/L",
      "glucoseMgdl": "mg/dL",
      "themePaletteLabel": "Palette del tema",
      "themePaletteHelp": "Scegli la palette di colori usata in tutta l'app.",
      "themeModeLabel": "Aspetto",
      "themeModeHelp": "Segui l'impostazione di sistema, oppure forza chiaro o scuro.",
      "themeMode": {
        "system": "Sistema",
        "light": "Chiaro",
        "dark": "Scuro"
      }
    },
    "timeline": {
      "setNumber": "Serie {{n}}",
      "fail": "Fallita",
      "failTip": "Fallita registra la serie come tentata ma non completata. Conta comunque come eseguita (parte il timer di recupero), mostra ✕ nella timeline ed è esclusa dall'e1RM.",
      "failTipA11y": "Cosa significa Fallita?",
      "e1rmValue": "e1RM {{value}}",
      "e1rmPctOfBest": "{{pct}}% del best",
      "e1rmNewBest": "record",
      "e1rmLegend": "e1RM",
      "setVolume": "Σ {{value}} {{unit}}",
      "myorepTag": "Myo-rep",
      "dropsetTag": "Drop",
      "myorepA11y": "Serie myo-rep",
      "dropsetA11y": "Serie dropset",
      "setVolumeA11y": "Volume del set {{value}} {{unit}}",
      "noBodyweight": "Peso corporeo non ancora impostato",
      "approachBadge": "Riscaldamento",
      "approachBadgeA11y": "serie di riscaldamento, non conta come serie allenante",
      "setSummaryBothSidesA11y": "{{reps}} ripetizioni a {{weight}} {{unit}} per lato, contati entrambi i lati",
      "e1rmLegendA11y": "Cos'è l'e1RM?",
      "e1rmTip": "L'e1RM è il tuo massimale stimato su 1 ripetizione per la serie (Epley, rip ≤ 12). «% del best» lo confronta col tuo miglior e1RM nello storico recente — più basso = margine per spingere; ↑ record = nuovo massimale stimato.",
      "durationLabel": "Durata",
      "hourShort": "h",
      "minShort": "min",
      "secShort": "sec",
      "started": "Allenamento avviato",
      "addSet": "Aggiungi serie",
      "insertSetBefore": "Inserisci una serie prima della serie {{n}}",
      "removeSet": "Rimuovi serie",
      "prevSet": "Serie precedente",
      "nextSet": "Serie successiva",
      "allLogged": "Tutte le serie registrate — tocca + per aggiungerne.",
      "rosterLabel": "Esercizi",
      "rosterHint": "tocca per cambiare",
      "focusEmptyHasRoster": "Seleziona un esercizio qui sopra per iniziare, oppure aggiungine uno nuovo.",
      "focusAllLogged": "Tutte le serie registrate. Aggiungi un esercizio qui sopra, o salva qui sotto.",
      "cueNextSet": "→ Serie {{n}}/{{total}}",
      "cueNextExercise": "→ {{name}}",
      "rosterExpandA11y": "Espandi la lista degli esercizi",
      "rosterCollapseA11y": "Comprimi la lista degli esercizi",
      "rosterState": {
        "done": "completato",
        "inProgress": "in corso",
        "notDone": "da iniziare"
      },
      "rosterOccurrenceA11y": "{{label}} ({{index}} di {{count}})",
      "exerciseNote": "Nota esercizio",
      "notePlaceholder": "Aggiungi una nota alla timeline…",
      "noteSend": "Invia nota",
      "noteExpandA11y": "Nota — tocca per leggerla tutta",
      "noteDeleteA11y": "Elimina nota",
      "uncompleteSetA11y": "Togli il set {{n}} di {{exercise}} — torna da rifare",
      "dropsetActive": "Dropset — modifica i round qui sotto.",
      "editingLogged": "Modifica della serie {{n}} registrata — le modifiche si salvano col workout.",
      "addSetLocked": "Stai modificando una sessione passata: non puoi aggiungere serie. Correggi i valori o rimuovi una serie.",
      "createGroupLocked": "Stai modificando una sessione passata: non puoi creare un superset.",
      "splitGroupLocked": "Stai modificando una sessione passata: non puoi sciogliere un superset.",
      "setTypeLocked": "Stai modificando una sessione passata: non puoi cambiare il tipo di serie (dropset/myorep).",
      "addStepLocked": "Stai modificando una sessione passata: non puoi aggiungere uno step al dropset.",
      "setState": {
        "pending": "Serie {{n}} di {{total}}, da fare",
        "done": "Serie {{n}} di {{total}}, completata",
        "pr": "Serie {{n}} di {{total}}, record personale",
        "failed": "Serie {{n}} di {{total}}, fallita"
      },
      "holdLabel": "Tenuta"
    },
    "home": {
      "targetsTopPatterns": "Pattern principali",
      "targetsSummary": "{{on}} di {{total}} a target",
      "targetsHint": "Fissa un programma con target settimanali per valutarli rispetto a un obiettivo.",
      "targetsZoneOnTarget": "a target",
      "targetsZoneOver": "oltre",
      "targetsZoneUnder": "in crescita",
      "targetsNoCoverage": "non previsto",
      "targetsIncomplete": "incompleto",
      "targetsIncompleteWhy": "Un esercizio registrato questa settimana non è nel catalogo, quindi le sue serie non contano per nessun muscolo.",
      "targetsIncompleteNoBodyweight": "Una seduta di questa settimana è stata salvata senza il tuo peso corporeo, quindi le sue serie a corpo libero contano zero. Lo ricalcola l'amministratore: tu non devi fare niente.",
      "targetsIncompleteMayBeHigher": "Il numero reale potrebbe essere più alto.",
      "targetsIncompleteA11y": "Perché incompleto",
      "targetsPrescribed": "piano {{n}}",
      "targetsEmptyTitle": "Nessun obiettivo ancora",
      "targetsEmptySub": "Imposta quanto vuoi allenare ogni muscolo a settimana. Il tuo piano ci lavora sopra; il meter Home ti dice a che punto sei.",
      "targetsEmptyCta": "Imposta i tuoi obiettivi",
      "weekEyebrow": "Questa settimana",
      "weeklySessions": "Allenamenti",
      "weeklyVolume": "Volume",
      "weeklyA11y": "{{sessions}} allenamenti, {{volume}} di volume",
      "viewProgress": "Vedi progressi",
      "badgesTitle": "Badge",
      "prPrev": "Record precedente",
      "prNext": "Record successivo",
      "prPosition": "Record {{n}} di {{total}}",
      "eyebrow": "OGGI",
      "blankTitle": "Pronto ad allenarti?",
      "blankLoading": "Caricamento del piano…",
      "blankBody": "Nessun programma attivo al momento. In libreria $t(brand.product) ha programmi già pronti: ne segui uno con un tocco. Oppure avvia un allenamento vuoto.",
      "blankLibrary": "Sfoglia i programmi pronti",
      "newWorkout": "Nuovo allenamento",
      "programMeta": "{{program}} · Settimana {{week}}",
      "morePreview": " +altri {{count}}",
      "startToday": "▶ Avvia sessione",
      "blankInstead": "Avvia invece un allenamento vuoto",
      "recentPrValue": "{{weight}} × {{reps}}",
      "recentPrValueBodyweight": "{{reps}} reps PC",
      "weightTitle": "Peso corporeo",
      "weightSaved": "Salvato ✓",
      "weightCurrent": "Ultimo: {{weight}}",
      "weightNone": "Registra il peso per seguire l'andamento.",
      "weightSave": "Salva",
      "repeatWorkout": "Ripeti un allenamento",
      "form": {
        "title": "Prontezza",
        "ready": "Pronto",
        "caution": "Attenzione",
        "rest": "Riposo",
        "reasonNoData": "Registra una sessione per iniziare a monitorare la prontezza.",
        "reasonBalanced": "Il tuo carico di allenamento sembra equilibrato.",
        "reasonFreshStart": "Stai riprendendo — vai con calma e costruisci una base.",
        "reasonShortRest": "Sessioni ravvicinate — tieni d'occhio il recupero.",
        "reasonHighFrequency": "Settimana ad alto volume — valuta un giorno più leggero.",
        "reasonLoadSpike": "Il carico è salito molto rispetto alla media recente.",
        "reasonLongGap": "È passato un po' — riparti leggero per risalire."
      },
      "glucoseSave": "Salva",
      "weightSaveA11y": "Salva il peso corporeo",
      "glucoseSaveA11y": "Salva la glicemia",
      "config": {
        "title": "Personalizza la Home",
        "open": "Personalizza la Home",
        "active": "Attive",
        "inactive": "Disattive",
        "dragHint": "Trascina una scheda dalla maniglia per riordinarla.",
        "inactiveEmpty": "Niente di nascosto. Tocca ✕ su una scheda per nasconderla.",
        "pinned": "Sempre visibile",
        "hide": "Nascondi {{name}}",
        "show": "Mostra {{name}}",
        "reorder": "Riordina {{name}}",
        "reorderKeys": "Riordina {{name}}, usa i tasti freccia",
        "reorderHint": "Trascina per spostare, oppure usa le azioni per spostare su o giù.",
        "moveUp": "Sposta su",
        "moveDown": "Sposta giù",
        "reset": "Ripristina predefinita",
        "saveError": "Non è stato possibile salvare la Home. Riprova.",
        "widget": {
          "hero": "Oggi",
          "readiness": "Prontezza",
          "weeklyTargets": "Questa settimana",
          "quickWeight": "Peso corporeo",
          "quickGlucose": "Glicemia",
          "badges": "Badge",
          "coverage": "Copertura muscolare",
          "e1rmTrends": "Trend E1RM",
          "repsAtLoad": "Ripetizioni a carico fisso",
          "movementBalance": "Bilanciamento dei movimenti",
          "painVolume": "Dolore × volume",
          "intensityHeatmap": "Heatmap di intensità",
          "exerciseFrequency": "Esercizi più trascurati",
          "painMap": "Mappa del dolore",
          "measurements": "Misure"
        },
        "columnMain": "Colonna principale",
        "columnRail": "Colonna laterale",
        "columnEmpty": "Nessuna scheda in questa colonna."
      },
      "painMapEmpty": "Nessun dolore segnato.",
      "painMapOpenHint": "Apre la tua mappa del dolore per modificarla."
    },
    "superset": {
      "startingWith": "Inizia il superset con",
      "joinExisting": "Unisci a esistente",
      "pairInWorkout": "Abbina (in questo allenamento)",
      "templates": "Superset salvati",
      "templateInsertHint": "Inserisci questo superset; tieni premuto per eliminare",
      "templateDeleteBody": "Rimuovere questo superset salvato?",
      "createCta": "Crea superset ({{n}})",
      "cueCycle": "{{group}}, esercizio {{pos}} di {{total}}. Tocca per andare a {{next}}.",
      "cueStatic": "{{group}}, esercizio {{pos}} di {{total}}",
      "menuOpen": "Opzioni superset",
      "menuSaveTemplate": "Salva come template",
      "menuAddExercise": "Aggiungi esercizio",
      "menuMoveUp": "Sposta su",
      "menuMoveDown": "Sposta giù",
      "menuRemoveMember": "Rimuovi questo esercizio",
      "menuSplit": "Sciogli superset",
      "namePlaceholder": "Nome del superset (facoltativo)"
    },
    "premium": {
      "badge": "Premium",
      "lockedA11y": "{{name}}, Premium, non fa parte del report base"
    },
    "widgetConfig": {
      "stateClosed": "Chiusa",
      "stateOpen": "Aperta",
      "expand": "Espandi {{name}}",
      "collapse": "Comprimi {{name}}"
    },
    "bell": {
      "channelName": "Avvisi"
    }
  },
  "tabs": {
    "workout": "Allenamento",
    "plan": "Pianifica",
    "progress": "Progressi",
    "profile": "Profilo",
    "catalog": "Catalogo",
    "admin": "Admin",
    "workoutEyebrow": "Sessione di oggi",
    "planEyebrow": "Programmazione",
    "progressEyebrow": "Grafici e report",
    "profileEyebrow": "Account e massimali",
    "catalogEyebrow": "Catalogo esercizi",
    "adminEyebrow": "Console admin",
    "progressEmpty": "Registra prima una sessione — i grafici compaiono quando ci sono dati."
  },
  "shell": {
    "navAria": "Navigazione principale"
  },
  "theme": {
    "aria": "Tema",
    "light": "Chiaro",
    "dark": "Scuro",
    "auto": "Auto"
  },
  "settings": {
    "restDefaults": {
      "title": "Default rest timer",
      "globalLabel": "Default globale",
      "globalUnset": "Non impostato — uso {{n}}s",
      "customLabel": "Esercizi con default personalizzato",
      "customEmpty": "Nessun override per esercizio. Apri il banner di rest nel Logger e tocca ⚙ per impostarne uno.",
      "customRemoveA11y": "Rimuovi rest personalizzato per {{name}}",
      "clearGlobal": "Reset"
    },
    "hints": {
      "title": "Suggerimenti",
      "label": "Mostra i suggerimenti",
      "help": "Tieni premuto un bottone del logger per sapere cosa fa, o tocca l'intestazione di una colonna. Disattiva per nascondere i suggerimenti che compaiono da soli."
    },
    "exerciseAgePulse": {
      "label": "Segnala un esercizio fermo da tempo",
      "help": "Un lampeggio sulla pastiglia dello storico quando un esercizio non lo fai da un pezzo. Spegnilo per tenere l'età senza il lampeggio."
    },
    "effortNudge": {
      "label": "Promemoria sforzo",
      "help": "Un impulso raro e discreto sulla barra dello sforzo quando un set aspetta di essere loggato."
    },
    "inWorkoutMeter": {
      "label": "Meter target in allenamento",
      "help": "Una striscia in cima alla card dell'esercizio con il target settimanale dei muscoli che stai allenando."
    },
    "audio": {
      "title": "Audio",
      "soundLabel": "Suono timer",
      "soundHelp": "Suona quando il timer di riposo termina.",
      "vibrationLabel": "Vibrazione",
      "vibrationHelp": "Vibra quando il timer di riposo termina.",
      "previewButton": "Ascolta",
      "pickerTitle": "Scegli un suono",
      "pickerCancel": "Annulla",
      "category": {
        "serious": "Standard",
        "fun": "Buffi"
      },
      "soundOptions": {
        "none": "Nessuno",
        "chime_crisp": "Campanella",
        "ding_dong": "Din-don",
        "meditation_bell": "Campana tibetana",
        "tada_fanfare": "Ta-da",
        "cartoon_boing": "Boing",
        "ah_yeah": "Yeah!"
      }
    },
    "timerDefaults": {
      "range": "Inserisci {{min}}–{{max}}s",
      "globalTitle": "Default globali",
      "restGlobal": "Timer di recupero",
      "holdGlobal": "Timer di tenuta",
      "saveRow": "Salva {{label}}",
      "customLabel": "Override per esercizio",
      "customEmpty": "Nessun override per esercizio. Tocca + Aggiungi.",
      "unset": "Non impostato — {{n}}s",
      "add": "+ Aggiungi",
      "editRestA11y": "Modifica recupero per {{name}}",
      "editHoldA11y": "Modifica tenuta per {{name}}",
      "editA11y": "Modifica i timer di {{name}}",
      "isDefault": "default",
      "equalsDefaultHint": "Un valore lasciato uguale al default globale non viene salvato come override.",
      "remove": "Rimuovi"
    },
    "backend": {
      "section": "Backend",
      "title": "Backend",
      "navSub": "Scegli dove scrive questa app",
      "pickLabel": "Scrivi i miei dati su",
      "pickHelp": "Solo build dev. Ogni backend tiene le sue sessioni, le sue code e la sua bozza di allenamento: cambiare non tocca l’altro.",
      "stageProduction": "PRODUZIONE",
      "stageLab": "LABORATORIO",
      "liveLabel": "STAI SCRIVENDO SU",
      "liveChecking": "Controllo…",
      "liveUnknown": "Sconosciuto — il backend non ha risposto",
      "liveNotProduction": "Qui non c’è il tuo allenamento vero.",
      "confirmTitle": "Cambiare backend?",
      "confirmBody": "L’app si ricarica su {{stage}}. Lì potresti dover entrare di nuovo, e le liste in cache vengono buttate.",
      "confirmCta": "Cambia",
      "blockedByQueue": "Non cambiato: alcune scritture non sono ancora partite. Torna online e lascia svuotare le code."
    },
    "animations": {
      "cellularLabel": "Scarica le animazioni anche senza Wi-Fi",
      "cellularHelp": "Spento di default. Le animazioni ci sono comunque: questo permette solo all'app di portarsele avanti su rete mobile, fra i 20 e i 30 MB per un programma."
    },
    "crashReports": {
      "label": "Invia le segnalazioni di crash",
      "help": "Dopo un crash, l'avvio successivo manda al nostro server cosa si è rotto, dove nel codice, la memoria in uso e la versione di app e Android. Mai i tuoi allenamenti, note, pesi o dati di salute."
    }
  },
  "web": {
    "preauth": {
      "tagline": "Allenamento della forza che si costruisce sul tuo sforzo, su come stai adesso e sull'attrezzatura che hai davvero.",
      "status": "In sviluppo. Registrazione chiusa.",
      "contactLabel": "Accesso o informazioni"
    },
    "crash": {
      "body": "L'app ha incontrato un errore imprevisto. I tuoi dati salvati sono al sicuro — ricarica per continuare.",
      "reload": "Ricarica",
      "retryBody": "L'app ha incontrato un errore imprevisto. I tuoi dati salvati sono al sicuro — riprova, e se questa schermata torna, mandaci il messaggio qui sotto.",
      "retry": "Riprova"
    },
    "postSession": {
      "headlineLabelPR": "NUOVO E1RM",
      "headlineLabelDelta": "GRANDE BALZO +{{delta}}",
      "headlineLabelSolid": "SESSIONE SOLIDA",
      "headlineSolidValue": "{{volume}} in {{duration}}",
      "headlineFallback": "{{label}} — {{sets}} serie",
      "blockE1rm": "E1RM",
      "fromSet": "da {{weight}} × {{reps}}",
      "blockVolume": "Volume",
      "blockDuration": "Durata",
      "blockDensity": "Densità",
      "barsTitle": "Lavoro per muscolo",
      "bodyTitle": "Muscoli allenati",
      "sharing": "Preparazione…",
      "shareCta": "Condividi scheda sessione"
    }
  },
  "muscle": {
    "quadriceps": "Quadricipiti",
    "hamstrings": "Ischiocrurali",
    "glutes": "Glutei",
    "adductors": "Adduttori",
    "abductors": "Abduttori",
    "calves": "Polpacci",
    "core": "Core",
    "obliques": "Obliqui",
    "erectors": "Lombari",
    "pectoralis": "Petto",
    "anterior-delts": "Deltoidi anteriori",
    "lateral-delts": "Deltoidi laterali",
    "triceps": "Tricipiti",
    "lats": "Dorsali",
    "rhomboids": "Romboidi",
    "rear-delts": "Deltoidi posteriori",
    "traps": "Trapezi",
    "biceps": "Bicipiti",
    "forearms": "Avambracci"
  },
  "experience": {
    "menuLabel": "Profilo attivo",
    "athlete": "Atleta",
    "coach": "Coach",
    "admin": "Admin"
  },
  "composer": {
    "targetAxisExercise": "Esercizio",
    "targetKeyExercise": "Esercizio",
    "targetRefAvg": "~{{n}}/sett media",
    "targetRefNone": "Nessun dato nelle ultime 4 settimane",
    "targetRefProgram": "il programma prescrive ~{{n}}/sett",
    "targetUseAvg": "Usa la media",
    "targetUseProgram": "Usa valore programma",
    "projectionTitle": "Come cadono i target",
    "projectionWeek": "Settimana {{n}}",
    "projectionContext": "Set / carico che il programma prescrive nella settimana {{n}}.",
    "projectionTarget": "Target",
    "projectionWeekTotal": "Sett.",
    "projectionRamp": "Ciclo",
    "projectionWeekShort": "S{{n}}",
    "projectionEmpty": "Non previsto",
    "targetsTitle": "Target settimanali",
    "targetsEmptyTitle": "Nessun target settimanale",
    "targetsEmptySub": "Aggiungine uno per attivare il meter di livello.",
    "targetAdd": "Aggiungi target",
    "targetRemove": "Rimuovi target {{name}}",
    "targetCollapse": "Chiudi",
    "targetAxis": "Asse",
    "targetAxisMuscle": "Muscolo",
    "targetMetric": "Metrica",
    "targetMetricHardSets": "Hard set",
    "targetMetricTonnage": "Tonnellaggio",
    "targetMetricReps": "Reps",
    "targetKeyMuscle": "Muscolo",
    "targetValue": "Obiettivo settimanale",
    "targetUnitHardSets": "hard set",
    "targetUnitTonnage": "kg",
    "targetUnitReps": "reps",
    "targetBand": "±{{pct}}%",
    "targetNotScored": "non ancora nel meter",
    "targetNotScoredNote": "Questo tipo di target non è ancora nel level meter.",
    "targetBandLabel": "Tolleranza",
    "targetBandAsym": "−{{lo}}% / +{{hi}}%",
    "targetBandBelow": "Percentuale sotto l'obiettivo",
    "targetBandAbove": "Percentuale sopra l'obiettivo",
    "targetBandRange": "Sotto 0–99%, sopra 0% o più.",
    "compose": "Componi",
    "preview": "Anteprima",
    "addExercises": "Aggiungi esercizi",
    "editingBlockDay": "Stai modificando D{{d}} — Aggiorna agisce su questo giorno (seleziona altri giorni per applicarlo anche lì)",
    "editingRampDay": "Ramp settimanale su D{{d}} — Aggiorna agisce sulle settimane selezionate, solo questo giorno",
    "segments": "Segmenti",
    "rampSwitchHint": "Aggiorna o Annulla prima di cambiare segmento",
    "setupHint": "Imposta la forma iniziale — potrai aggiungere o togliere giorni e cambiare le settimane dopo, nell'editor.",
    "repsHint": "Reps «5+» = AMRAP: minimo 5, poi quante ne riesci.",
    "repsHintA11y": "Come si scrivono le ripetizioni",
    "addingWeek": "Nuova settimana W{{n}} — Aggiorna la aggiunge a questo esercizio",
    "cloneWeek": "Clona settimana…",
    "cloneWeekFrom": "Da",
    "cloneWeekApply": "Clona",
    "cloneWeekConflict": "{{name}} ha già contenuto in W{{week}} (D{{day}})",
    "cloneWeekEmpty": "Niente da clonare — scegli una settimana sorgente piena e almeno una destinazione",
    "editingWeekDay": "Stai modificando solo W{{n}} su D{{d}} — Aggiorna la stacca dal segmento",
    "perWeek": "Per settimana",
    "dupExercise": "{{name}} è già presente in D{{day}} nelle settimane selezionate",
    "days": "Giorni",
    "weeks": "Settimane",
    "setNote": "Nota del set",
    "removeExercise": "Rimuovi esercizio",
    "replaceExercise": "Sostituisci esercizio",
    "clone": "Clona",
    "remove": "Rimuovi",
    "removeConfirm": "Confermi? ({{n}} celle)",
    "verbatim": "Slot avanzato (multi-variante) — conservato tale e quale, non modificabile qui",
    "metaWeeks_one": "{{count}} settimana",
    "metaWeeks_other": "{{count}} settimane",
    "tabPlan": "Piano",
    "importPlanHint": "Gli esercizi entrano nel giorno in modifica, in tutte le settimane del ciclo.",
    "importPlanEmpty": "Nessun piano salvato.",
    "importPlanMeta_one": "{{count}} esercizio",
    "importPlanMeta_other": "{{count}} esercizi",
    "importPlanAction_one": "Aggiungi {{name}} a questo giorno ({{meta}}), nell’unica settimana del ciclo",
    "importPlanAction_other": "Aggiungi {{name}} a questo giorno ({{meta}}), in tutte e {{count}} le settimane del ciclo",
    "removeSlotConfirmTitle_one": "Rimuovere da quella settimana?",
    "removeSlotConfirmTitle_other": "Rimuovere da tutte e {{count}} le settimane?",
    "removeSlotConfirm_one": "Rimuovere {{name}} da questo giorno? La prescrizione di quella settimana viene cancellata.",
    "removeSlotConfirm_other": "Rimuovere {{name}} da questo giorno? Cancella la prescrizione di tutte e {{count}} le settimane, non solo di quella mostrata.",
    "metaDays_one": "{{count}} giorno di allenamento",
    "metaDays_other": "{{count}} giorni di allenamento",
    "gridToggle": "Griglia intensità",
    "addDay": "Aggiungi giorno",
    "removeDay": "Rimuovi giorno D{{n}}",
    "removeDayConfirm": "Conferma — rimuovi giorno D{{n}}?",
    "dayEmpty": "Nessun esercizio in questo giorno. Aggiungine uno per costruirlo.",
    "prescribeDayEmpty": "Nessun esercizio in questo giorno.",
    "prescribeFocusEmpty": "Tocca un esercizio qui sopra per prescriverne le serie.",
    "prescribeViewMatrix": "Matrice",
    "prescribeViewEditor": "Editor",
    "prescribeViewGroup": "Cambia vista",
    "checkEmptyCell": "W{{w}}·D{{d}} non ha esercizi",
    "checkPctNoMax": "{{name}} usa %MAX senza un MAX salvato",
    "exerciseNote": "Nota per l'esercizio",
    "exerciseNotePlaceholder": "Nota per questo esercizio (visibile durante il log)",
    "panelHint": "Tocca un esercizio per modificare, clonare o rimuovere",
    "warnLine_one": "{{count}} avviso",
    "warnLine_other": "{{count}} avvisi",
    "adjacencyWarnLine_one": "{{count}} avviso di recupero muscolare",
    "adjacencyWarnLine_other": "{{count}} avvisi di recupero muscolare",
    "adjacencyWarnItem": "{{muscle}} allenato in giorni adiacenti ({{count}}×)",
    "publishChecklist": "Avvisi aperti (puoi pubblicare comunque)",
    "publishClean": "Nessun avviso aperto.",
    "weekShort": "Settimana",
    "placed": "attivo",
    "notPlaced": "spento",
    "placementHint": "Tieni premuta una cella per mettere o togliere {{exercise}} lì.",
    "addWeek": "Aggiungi settimana vuota",
    "removeWeek": "Rimuovi settimana",
    "holdDayToRemoveHint": "Tieni premuto un giorno per rimuoverlo",
    "holdWeekToRemoveHint": "Tieni premuta una settimana per rimuoverla",
    "holdAddWeekToCloneHint": "Tieni premuto W ＋ per ripetere questa settimana",
    "holdCellToPlaceHint": "Tieni premuta una cella per metterci l’esercizio",
    "cloneWeekAction": "Aggiungi una settimana che ripete questa",
    "removeWeekConfirm": "Conferma — togli questa settimana e i suoi set",
    "coverageTitle": "Copertura — set duri/settimana",
    "coverageHint": "Media sull'intero ciclo. Uno zero si vede qui prima di allenarlo.",
    "rosterNotThisWeek": "non in questa settimana",
    "dayWeekCursor": "D{{d}}·W{{w}}",
    "prescribeNotThisWeek": "{{exercise}} non è previsto in {{cursor}}.",
    "prescribeLockedNewFields": "{{exercise}} ha serie diverse per giro, un intervallo di ripetizioni o assi di carico misti. Qui è in sola lettura: si modifica dal telefono.",
    "prescribePlaceHere": "Mettilo in {{cursor}}",
    "placementAddHere": "Metti {{exercise}} qui",
    "placementRemoveHere": "Togli {{exercise}} da qui",
    "weekCue": "Settimana {{pos}} di {{total}}. Tocca per la settimana successiva.",
    "weekCuePrev": "Settimana precedente",
    "targetRefThisWeek": "questa sett finora {{n}}",
    "setNoteChip": "Nota",
    "setNoteChipA11y": "Scrivi una nota su una serie di questo giro",
    "weekMenuHint": "Apre il menu del giro",
    "weekMenuHoldHint": "Tocca per il menu del giro. Tieni premuto per toglierlo.",
    "setNoteChipLocked": "Resta visibile finché una serie ha una nota",
    "importProgramBack": "Torna ai programmi",
    "importProgramDayHint": "I suoi esercizi si aggiungono in fondo al giorno che stai modificando. I giri che questo programma non ha restano vuoti, quelli in più si scartano.",
    "importProgramDayAction": "Aggiungi {{day}} di {{program}} a questo giorno ({{meta}})",
    "importProgramEmpty": "Ancora nessun altro programma.",
    "importProgramOpen": "{{name}} ({{meta}}): scegli un giorno",
    "importProgramDays_one": "{{count}} giorno",
    "importProgramDays_other": "{{count}} giorni",
    "importProgramRounds_one": "{{count}} giro",
    "importProgramRounds_other": "{{count}} giri"
  },
  "gym": {
    "setPlace": "Dove?",
    "whichPlace": "Dove ti alleni?",
    "newPlace": "Aggiungi posto",
    "fallback": "Predefinito",
    "chipA11y": "Luogo di allenamento",
    "footnote": "Ordina cosa vedi per primo. Non arriva mai a un coach.",
    "namePlaceTitle": "Dai un nome a questo posto",
    "namePlaceHint": "Nome del posto",
    "namePlaceSave": "Usa questo posto",
    "pinPlace": "Imposta {{place}} come luogo predefinito",
    "unpinPlace": "Togli {{place}} come luogo predefinito",
    "pinHint": "Ricorda questo come il luogo dove ti alleni di solito.",
    "unpinHint": "Dimentica il tuo luogo predefinito.",
    "pinErrorTitle": "Non salvato",
    "pinErrorBody": "Il tuo luogo predefinito non è cambiato."
  },
  "inbox": {
    "emptyTitle": "Posta in arrivo",
    "emptyBody": "Non c'è nulla che aspetta una risposta.",
    "accept": "Accetta",
    "decline": "Rifiuta",
    "acknowledge": "Capito",
    "feedback": {
      "statusChanged": {
        "title": "La tua segnalazione",
        "body": "La tua segnalazione è stata segnata come {{status}}."
      }
    },
    "sessionCorrection": {
      "orphaned": {
        "title": "Correzione in attesa su un altro telefono",
        "body": "Hai corretto un allenamento, ma era stato cancellato su un altro dispositivo. La correzione è ancora sul telefono dove l'hai salvata: lì apri le Notifiche (la campanella) e tocca Salva come nuovo."
      }
    },
    "maxBump": {
      "raise": {
        "title": "Nuovo MAX",
        "body": "{{exercise}}: l'allenamento indica un nuovo MAX di {{suggestedKg}}."
      },
      "lower": {
        "title": "Il MAX potrebbe essere sceso",
        "body": "{{exercise}}: l'allenamento indica {{suggestedKg}}. Il tuo MAX è {{currentKg}}, fissato {{weeks}}."
      },
      "confirm": "Conferma",
      "lowerTo": "Abbassa a {{suggestedKg}}",
      "skip": "Salta",
      "keep": "Lascia {{currentKg}}",
      "badDay": "Brutta giornata",
      "thisWeek": "questa settimana",
      "weeksAgo_one": "{{count}} settimana fa",
      "weeksAgo_other": "{{count}} settimane fa",
      "badDayHint": "Tiene il tuo MAX e non ne riparla per questo esercizio finché il calo non si ripresenta."
    },
    "bodyweight": {
      "missing": {
        "title": "Manca il tuo peso corporeo",
        "body": "Gli esercizi a corpo libero hanno bisogno del tuo peso per calcolare carico e volume. Aggiungilo in Io → Misure.",
        "cta": "Aggiungi peso",
        "dismiss": "Non ricordarmelo"
      }
    },
    "coachEdge": {
      "invitedByCoach": {
        "title": "Invito da un coach",
        "body": "Un coach ti ha invitato a essere suo atleta."
      },
      "invitedByAthlete": {
        "title": "Richiesta di coaching",
        "body": "Un atleta ti ha invitato a essere il suo coach."
      }
    },
    "assignment": {
      "program": {
        "title": "Nuovo programma",
        "body": "{{from}} vuole assegnarti {{itemName}}.",
        "bodySelf": "Ti sei inviato {{itemName}} da coach — qui sotto puoi accettarlo o rifiutarlo."
      },
      "plan": {
        "title": "Nuovo allenamento",
        "body": "{{from}} vuole assegnarti {{itemName}}.",
        "bodySelf": "Ti sei inviato {{itemName}} da coach — qui sotto puoi accettarlo o rifiutarlo."
      },
      "accepted": {
        "title": "Assegnazione accettata",
        "body": "{{itemName}} è stato accettato."
      },
      "rejected": {
        "title": "Assegnazione rifiutata",
        "body": "{{itemName}} è stato rifiutato."
      }
    },
    "followedProgram": {
      "updated": {
        "title": "Programma aggiornato",
        "body": "{{itemName}} è stato modificato dal suo autore."
      },
      "removed": {
        "title": "Programma non più condiviso",
        "body": "Non hai più accesso a {{itemName}}."
      },
      "gone": {
        "title": "Programma eliminato",
        "body": "{{itemName}} è stato eliminato dal suo autore."
      }
    },
    "followedPlan": {
      "updated": {
        "title": "Piano aggiornato",
        "body": "{{itemName}} è stato modificato dal suo autore."
      },
      "removed": {
        "title": "Piano non più condiviso",
        "body": "Non hai più accesso a {{itemName}}."
      },
      "gone": {
        "title": "Piano eliminato",
        "body": "{{itemName}} è stato eliminato dal suo autore."
      }
    },
    "actionError": "Non è andata a buon fine. Riprova.",
    "actionErrorItemGone": "Questa proposta non è più disponibile. Usa Rifiuta per togliere la carta.",
    "bell": {
      "label": "Avvisi",
      "title": "Notifiche",
      "close": "Chiudi le notifiche",
      "a11y_one": "{{count}} notifica",
      "a11y_other": "{{count}} notifiche"
    },
    "actionErrorNoLongerAssigned": "Chi l'ha inviata l'ha ritirata. Usa Rifiuta per togliere la carta.",
    "actionErrorWrongParty": "Può rispondere solo la persona invitata.",
    "actionErrorFanout": "Non è stato possibile aggiungerlo alla tua libreria. Riprova.",
    "loadError": "Non è stato possibile caricare le notifiche.",
    "retry": "Riprova",
    "local": {
      "eyebrow": "Questo telefono",
      "action": {
        "open": "Apri",
        "hide": "Nascondi",
        "retry": "Riprova",
        "details": "Dettagli",
        "retrying": "Riprovo…",
        "resume": "Riprendi",
        "discard": "Scarta",
        "merge": "Unisci",
        "sendSupport": "Invia al supporto",
        "sending": "Invio…"
      },
      "hcNoConsent": {
        "title": "Health Connect scollegato",
        "body": "Il tuo account non ha alcun consenso per Health Connect, quindi questo telefono ha smesso di importare. Quello che aveva già letto aspetta qui finché non ti ricolleghi."
      },
      "hcRefusalTitle": {
        "granted": "Consenso non registrato",
        "revoked": "Revoca non registrata",
        "revokedElsewhere": "Health Connect scollegato"
      },
      "hcDriftTitle": {
        "deviceOff": "Health Connect non consentito su questo telefono",
        "undated": "Conferma il consenso a Health Connect",
        "noRecord": "Conferma il consenso a Health Connect"
      },
      "hcUpdate": {
        "title": "Aggiorna Health Connect",
        "body": "$t(brand.product) non può leggere Health Connect finché non aggiorni la sua app."
      },
      "stuckWrites": {
        "title_one": "{{count}} salvataggio non è passato",
        "title_other": "{{count}} salvataggi non sono passati",
        "body": "Questo telefono ha già riprovato da solo. Riprova ora, o apri i dettagli per vedere cosa non è passato.",
        "bodyStill": "Appena riprovato, senza esito. Apri i dettagli per vedere cosa ha risposto il server, uno per uno."
      },
      "draftResume": {
        "title": "Allenamento non salvato",
        "body": "L'app si è chiusa durante il tuo allenamento del {{date}}, che è ancora su questo telefono. Per scartarlo usa Scarta nelle Notifiche. Tocca per riprenderlo.",
        "discardTitle": "Scartare questo allenamento?",
        "discardBody": "Le serie che hai registrato il {{date}} non sono mai state salvate. Scartandolo le cancelli da questo telefono per sempre."
      },
      "workoutRecovery": {
        "title": "Allenamento del {{date}} da salvare",
        "titleCorrection": "Correzione del {{date}} non salvata",
        "body": "L'app si è chiusa prima che questo allenamento fosse salvato, e questo telefono l'ha tenuto. Serie fatte: {{done}} su {{total}}. Salvalo come nuovo, uniscilo a uno dello stesso giorno, o scartalo.",
        "bodySent": "Inviato al supporto. L'allenamento resta su questo telefono finché non lo salvi, lo unisci o lo scarti."
      }
    },
    "actionErrorOffline": "Serve una connessione. Ricollegati e riprova."
  },
  "editorV3": {
    "addExerciseToRound": "Aggiungi {{name}} in W{{n}}",
    "addToRound": "Aggiungi in W{{n}}",
    "alignTrimHint": "Toglie le serie in più alla fine. Annulla nel messaggio le riporta.",
    "backToDay": "Torna a {{day}}",
    "clear": "Svuota giorno",
    "clearBody_one": "Verrà tolto {{count}} esercizio.",
    "clearBody_other": "Verranno tolti {{count}} esercizi.",
    "clearTitle": "Svuotare {{day}}?",
    "copyName": "{{name}} (copia)",
    "copyOnto": "Copia su…",
    "copyOntoBody_one": "{{day}} ha {{count}} esercizio. Lo sostituisce una copia di {{from}}.",
    "copyOntoBody_other": "{{day}} ha {{count}} esercizi. Li sostituisce una copia di {{from}}.",
    "copyOntoFootnote": "Il giorno che scegli perde quello che ha adesso.",
    "copyOntoQuestion": "Copiare {{day}} su quale giorno?",
    "copyOntoTitle": "Sostituire {{day}}?",
    "copyRoundBody_one": "{{round}} ha {{count}} esercizio fra i giorni. Lo sostituisce una copia di {{from}}.",
    "copyRoundBody_other": "{{round}} ha {{count}} esercizi fra i giorni. Li sostituisce una copia di {{from}}.",
    "copyRoundFootnote": "Il giro che scegli perde quello che ha adesso, in ogni giorno.",
    "copyRoundQuestion": "Copiare {{round}} su quale giro?",
    "copyRoundTitle": "Sostituire {{round}}?",
    "dayChipA11y": "Giorno {{n}} {{name}}",
    "dayCleared": "{{day}} svuotato",
    "dayCopied": "Copiato su {{day}}",
    "dayDuplicated": "Giorno duplicato",
    "dayEmpty": "Ancora nessun esercizio in {{day}}.",
    "dayMenuA11y": "{{day}}, menu del giorno",
    "dayName": "Nome del giorno",
    "dayRemoved": "{{day}} rimosso",
    "daysA11y": "Giorni",
    "dissolveSuperset": "Sciogli superset",
    "duplicateDay": "Duplica giorno",
    "duplicateRound": "Duplica giro",
    "exerciseMenuA11y": "{{name}}, menu",
    "exerciseRemoved": "{{name}} rimosso",
    "exerciseTipA11y": "Info su {{name}}",
    "historyLoad": "come l'ultima volta",
    "lensA11y": "Leggi il giorno per",
    "lensExercises": "Esercizi",
    "lensRound": "Per giro",
    "moveDayEarlier": "Sposta prima",
    "moveDayLater": "Sposta dopo",
    "moveRoundEarlier": "Sposta prima",
    "moveRoundLater": "Sposta dopo",
    "notInRound": "Non in questo giro",
    "offRoundOnlyInDay": "L'unico esercizio di questo giorno in W{{n}}",
    "offRoundOnlyRound": "Non c'è in nessun altro giro",
    "remove": "Rimuovi",
    "removeDay": "Rimuovi giorno",
    "removeDayBody_one": "Il giorno se ne va con il suo esercizio.",
    "removeDayBody_other": "Il giorno se ne va con i suoi {{count}} esercizi.",
    "removeDayEmptyBody": "Il giorno è vuoto.",
    "removeDayTitle": "Rimuovere {{day}}?",
    "removeExerciseBody": "Lascia questo giorno in tutti i giri.",
    "removeExerciseTitle": "Rimuovere {{name}}?",
    "removeFromRound": "Togli da W{{n}}",
    "removeRound": "Togli W{{n}}",
    "removeRoundBody": "Le sue serie spariscono da ogni giorno. I giri dopo scalano di un posto.",
    "removeRoundTitle": "Togliere W{{n}}?",
    "removedFromRound": "{{name}} tolto da W{{n}}",
    "renameDay": "Rinomina",
    "renameSuperset": "Rinomina superset",
    "renameTitle": "Rinomina {{day}}",
    "replace": "Sostituisci",
    "replaceExercise": "Sostituisci esercizio",
    "roundA11y": "Giro {{n}}: {{line}}",
    "roundChipA11y": "Giro {{n}}",
    "roundCopied": "Copiato su {{round}}",
    "roundDuplicated": "W{{n}} duplicato",
    "roundLastInDay": "{{name}} è l'unico esercizio di questo giorno in W{{n}}. Togli l'esercizio o il giro.",
    "roundLastOfExercise": "W{{n}} è l'unico giro in cui c'è {{name}}. Togli l'esercizio.",
    "roundScope": "Ripetizioni, carico e secondi cambiano solo in questo giro. Asse, limite di tempo e serie cambiano in tutti i giri.",
    "roundScopeLens": "Ripetizioni, carico, secondi e serie cambiano solo in questo giro. Asse e limite di tempo cambiano in tutti i giri.",
    "alignPadEachRound": "+ Allunga al più lungo in ogni giro",
    "alignTrimEachRound": "− Accorcia al più corto in ogni giro",
    "setsTrimmedEachRound": "Superset fatto, serie accorciate al più corto in ogni giro",
    "roundSetAdded": "W{{n}}: una serie in più",
    "roundSetRemoved": "W{{n}}: una serie in meno",
    "roundSetCount_one": "W{{n}}: {{count}} serie",
    "roundSetCount_other": "W{{n}}: {{count}} serie",
    "roundOnlySet": "W{{n}} ha una sola serie. Togli invece l'esercizio dal giro.",
    "roundMixedBound": "W{{n}} invariato: una serie a tempo e una a ripetizioni si scambierebbero di posto.",
    "setRangeA11y": "da {{lo}} a {{hi}} serie da",
    "roundsA11y": "Giri",
    "secondsUnit": "s",
    "setsTrimmed": "Superset fatto, serie accorciate a {{n}}",
    "supersetN": "Superset {{n}}",
    "supersetName": "Nome del superset",
    "supersetNameHint": "Lascialo vuoto per tornare al numero.",
    "supersetWithNext": "Superset con l'esercizio dopo",
    "variants": "Si alterna con {{names}}. Qui non si modifica ancora.",
    "problems_one": "{{count}} problema",
    "problems_other": "{{count}} problemi",
    "problemPrev": "Problema precedente, {{n}} di {{total}}",
    "problemNext": "Problema successivo, {{n}} di {{total}}",
    "problemGoA11y": "Problema {{n}} di {{total}}, {{where}}: {{message}}. Vai lì",
    "select": "Seleziona",
    "selectDone": "Fine",
    "selectA11y": "Seleziona esercizi in {{day}}",
    "selectDoneA11y": "Fine selezione in {{day}}",
    "copyToOtherDays": "Copia in altri giorni",
    "copyTo": "Copia in…",
    "copyToDaysQuestion": "In quali giorni copiare {{what}}?",
    "copyToDaysFootnote": "Ogni giorno riceve la sua copia, in fondo. Un superset arriva intero.",
    "copyToDaysNone": "Copia",
    "copyToDaysConfirm_one": "Copia in {{count}} giorno",
    "copyToDaysConfirm_other": "Copia in {{count}} giorni",
    "copiedToDays": "Copiato in {{days}}.",
    "addedOneToDays": "{{name}} aggiunto in {{days}}.",
    "addedManyToDays_one": "{{count}} esercizio aggiunto in {{days}}.",
    "addedManyToDays_other": "{{count}} esercizi aggiunti in {{days}}.",
    "addedAgain_one": "{{days}} lo aveva già: ora c'è due volte.",
    "addedAgain_other": "{{days}} ne aveva già qualcuno: ora ci sono due volte.",
    "valuesFromRole": "Valori dal ruolo del giorno.",
    "removeSelectedTitle_one": "Togliere {{count}} esercizio?",
    "removeSelectedTitle_other": "Togliere {{count}} esercizi?",
    "removeSelectedBody_one": "Lascia questo giorno in tutti i giri.",
    "removeSelectedBody_other": "Lasciano questo giorno in tutti i giri.",
    "selectedRemoved_one": "{{count}} esercizio tolto",
    "selectedRemoved_other": "{{count}} esercizi tolti",
    "nExercises_one": "{{count}} esercizio",
    "nExercises_other": "{{count}} esercizi",
    "selectedCount_one": "{{count}} selezionato",
    "selectedCount_other": "{{count}} selezionati",
    "programDayImported": "{{day}} di {{program}} aggiunto.",
    "roundsDropped_one": "{{rounds}} lasciato fuori: questo programma ha meno giri.",
    "roundsDropped_other": "{{rounds}} lasciati fuori: questo programma ha meno giri.",
    "daysFull_one": "{{days}} supererebbe {{max}} esercizi: lì non si aggiunge niente.",
    "daysFull_other": "{{days}} supererebbero {{max}} esercizi: lì non si aggiunge niente.",
    "importNothing": "Non è stato aggiunto niente: {{day}} non ha esercizi nei giri di questo programma.",
    "roundTypeMenu": "Tipo di giro…",
    "roundTypeQuestion": "Che giro è {{round}}?",
    "roundTypeNormal": "Normale",
    "roundTypeDeload": "Scarico",
    "roundTypeTest": "Prova",
    "roundTypedA11y": "Giro {{n}}, {{type}}: {{line}}",
    "roundChipTypedA11y": "Giro {{n}}, {{type}}",
    "roundTypeSet": "W{{n}} {{type}}. Applicato a: tutto il programma.",
    "roundRemovedByRules": "W{{n}} tolto. Le celle a mano dopo scorrono con il loro giro.",
    "roundTypeFootnoteRules": "Il tipo vale per tutto il programma. Ogni riga ne riceve l'effetto dalla sua regola.",
    "rule": {
      "name": {
        "constant": "Costante",
        "effortRamp": "Rampa di sforzo",
        "tetrad": "Tetrade, prova e scarico",
        "perSet": "Per serie",
        "linear": "Lineare",
        "repsThenLoad": "Ripetizioni poi carico",
        "triple": "Tripla progressione",
        "timed": "A tempo",
        "history": "Storico",
        "waves": "Onde",
        "blocks": "A blocchi",
        "pyramid": "Piramide",
        "repsUp": "Ripetizioni crescenti",
        "topBackoff": "Testa e scarico"
      },
      "preset": {
        "linearKg": "Lineare in kg"
      },
      "manual": "Valori a mano",
      "manualBody": "Nessuna regola riconosciuta. Ogni cella si modifica a mano.",
      "title": "Regola · {{name}}",
      "perRound": "{{step}} a giro",
      "upTo": "{{what}} fino a {{cap}}",
      "ramp_one": "da {{from}} a {{to}} in {{count}} giro",
      "ramp_other": "da {{from}} a {{to}} in {{count}} giri",
      "cycle": "a turno {{values}}",
      "blocks_one": "{{count}} blocco, che riparte",
      "blocks_other": "{{count}} blocchi, ognuno riparte",
      "threshold": "ripetizioni da {{min}} a {{max}} di {{step}}",
      "thenSets": "poi serie fino a {{n}}",
      "thenLoad": "poi {{step}}",
      "repsStep": "{{step}} ripetizioni",
      "amrapInTest": "ultima serie AMRAP nel giro di prova",
      "testLast": "prova {{step}} sull'ultima serie",
      "testTop": "prova {{step}} sulle serie di testa",
      "test": "prova {{step}}",
      "deloadPct": "scarico al {{pct}}%",
      "deload": "scarico {{step}}",
      "deloadSets_one": "{{count}} serie in meno nello scarico",
      "deloadSets_other": "{{count}} serie in meno nello scarico",
      "same": "uguale a ogni giro",
      "applied": "Regola cambiata. Applicato a: i giri che la seguono.",
      "appliedMany_one": "Regola applicata a {{count}} esercizio. Applicato a: i giri che la seguono.",
      "appliedMany_other": "Regola applicata a {{count}} esercizi. Applicato a: i giri che la seguono.",
      "rowRealigned": "Riga riallineata alla regola.",
      "roundRealigned": "{{round}} riallineato alla regola.",
      "blockAdded": "Aggiunti {{from}}-{{to}}.",
      "byHand": "{{round}} serie {{set}}: scritto a mano. Applicato a: solo qui.",
      "followsAgain": "Torna a seguire la regola.",
      "handCount_one": "{{count}} cella a mano",
      "handCount_other": "{{count}} celle a mano",
      "handDone_one": "{{count}} a mano nei giri fatti",
      "handDone_other": "{{count}} a mano nei giri fatti",
      "realign": "Riallinea",
      "realignHint": "Ogni cella torna alla regola",
      "change": "Cambia regola",
      "byHandMark": "a mano",
      "realignRound": "Riallinea {{round}} alla regola",
      "typedStays": "Il valore scritto qui resta tuo: la regola non lo riscrive.",
      "addBlock_one": "{{count}} giro",
      "addBlock_other": "{{count}} giri",
      "blockAdd_one": "Aggiungi {{count}} giro",
      "blockAdd_other": "Aggiungi {{count}} giri",
      "blockTitle": "Aggiungi {{from}}-{{to}}",
      "blockShape": "Una tetrade in più: due giri normali, uno di prova, uno di scarico.",
      "blockCarry": "Le righe a chili e a ripetizioni continuano da dove erano.",
      "blockEffort": "Le righe a sforzo ripetono la forma. Il carico sale con il MAX misurato nel giro di prova.",
      "sheetTitle": "Regola",
      "sheetTitleMany_one": "Regola per {{count}} esercizio",
      "sheetTitleMany_other": "Regola per {{count}} esercizi",
      "apply": "Applica",
      "presets": "Modelli",
      "changes": "cambia",
      "roundsChange_one": "{{count}} giro cambia.",
      "roundsChange_other": "{{count}} giri cambiano.",
      "alsoTitle": "Applica anche a:",
      "alsoSame": "Stesso esercizio, altri giorni",
      "alsoOthers": "Altri esercizi",
      "alsoShowAll": "Mostra tutti",
      "alsoShowLess": "Mostra meno",
      "alsoEach": "Ogni esercizio tiene i suoi numeri di partenza.",
      "lostTest": "Niente AMRAP nel giro di prova.",
      "lostTestMany": "Niente AMRAP nel giro di prova per: {{names}}.",
      "lostDeload": "Niente scarico.",
      "lostDeloadMany": "Niente scarico per: {{names}}.",
      "stallNever": "In questi giri il carico non sale mai.",
      "stallAt": "In questi giri il carico non sale. Primo aumento: {{round}}.",
      "noRoundChanges": "Nessun giro cambia.",
      "handStays_one": "La {{count}} cella a mano resta.",
      "handStays_other": "Le {{count}} celle a mano restano.",
      "supersetFollows": "Il superset prende lo stesso numero di serie.",
      "undoable": "Si annulla.",
      "waveLess": "Un valore in meno nel ciclo",
      "waveMore": "Un valore in più nel ciclo",
      "selectionAction": "Regola",
      "field": {
        "sets": "Serie",
        "reps": "Ripetizioni",
        "effort": "Sforzo",
        "step": "Passo a giro",
        "cap": "Tetto",
        "load": "Da",
        "deloadPct": "Scarico",
        "repsMin": "Rip. min",
        "repsMax": "Rip. max",
        "repsStep": "Passo rip.",
        "loadStep": "Poi",
        "seconds": "Secondi",
        "efforts": "Sforzi del ciclo",
        "setsMax": "Serie fino a",
        "repsSetStep": "Rip. per serie",
        "loadSetStep": "Carico per serie",
        "backoffSets": "Serie di scarico",
        "topEffort": "Sforzo della testa",
        "backoffEffort": "Sforzo dello scarico",
        "off": "Nessuno"
      },
      "backoff": "serie di scarico {{step}}",
      "eachSet": "ogni serie {{steps}}",
      "handAxisResets_one": "{{count}} valore scritto a mano viene sostituito: la nuova regola usa un'altra unità.",
      "handAxisResets_other": "{{count}} valori scritti a mano vengono sostituiti: la nuova regola usa un'altra unità.",
      "lockedStay": "Fatto fino a {{round}}: quei giri restano come sono.",
      "reference": "rif. ≈ {{load}}",
      "pickPreset": "Nessun modello scrive questa regola. Scegline uno per sostituirla.",
      "pickPresetManual": "Nessuna regola riconosciuta. Scegli un modello per sostituire i valori a mano.",
      "blockFull": "Un programma ha al massimo {{max}} giri: non c'è posto per un'altra tetrade."
    },
    "tetrad": {
      "scratchTitle": "Da zero",
      "scratchBody": "Un giorno vuoto e quattro giri.",
      "rounds": "Giri",
      "roundsA11y_one": "{{count}} giro",
      "roundsA11y_other": "{{count}} giri",
      "perWeek": "Sedute a settimana",
      "perWeekA11y_one": "{{count}} seduta a settimana",
      "perWeekA11y_other": "{{count}} sedute a settimana",
      "dayEmpty": "Nessun esercizio: il giorno ne vuole almeno uno.",
      "removeExercise": "Togli {{name}}",
      "back": "Indietro",
      "needName": "Prima dai un nome al programma.",
      "needDay": "Ogni giornata vuole almeno un esercizio: rimettine uno.",
      "putBack": "Rimetti {{name}}",
      "takenOut": "tolto"
    },
    "model": {
      "fromModel": "Da un modello",
      "fromModelBody": "Il modello scrive i giorni e i giri. Tu scegli il livello, il tempo per seduta e gli esercizi.",
      "fromTemplate": "Da un template",
      "fromTemplateBody": "Una copia di un programma pubblico, da cambiare come vuoi.",
      "noModel": "Ancora nessun modello.",
      "noTemplate": "Ancora nessun template.",
      "loading": "Caricamento…",
      "loadError": "Non si è caricato. Tocca per riprovare.",
      "level": "Livello",
      "minutes": "Minuti per seduta",
      "minutesA11y_one": "{{count}} minuto",
      "minutesA11y_other": "{{count}} minuti",
      "minutes45": "Niente esercizi facoltativi, e una serie in meno agli accessori.",
      "minutes60": "Niente esercizi facoltativi.",
      "minutes75": "Tutti gli esercizi del modello.",
      "rotateHint_one": "Il giorno si ripete: un giro dura {{length}} giorni.",
      "rotateHint_other": "I {{count}} giorni si alternano: un giro dura {{length}} giorni.",
      "blocksHint_one": "Il modello gira una volta.",
      "blocksHint_other": "Il modello gira {{count}} volte: ogni volta riparte un gradino più su.",
      "swapA11y_one": "{{name}}. Scambialo con l'alternativa",
      "swapA11y_other": "{{name}}. Scambialo con una di {{count}} alternative",
      "alternatives": "Alternative",
      "alternativesCount_one": "{{count}} alternativa",
      "alternativesCount_other": "{{count}} alternative"
    },
    "roundLocked": "W{{n}} è già fatto: resta com'è.",
    "lock": {
      "unlock": "Sblocca",
      "unlockA11y": "Sblocca i giri già fatti",
      "title": "Sbloccare i giri fatti?",
      "body": "Le sedute già fatte rileggono la prescrizione dal programma: modificare {{rounds}} cambia cosa risulta prescritto nello storico. Restano sbloccati finché non chiudi l'editor.",
      "done": "fatto",
      "doneA11y": "fatto, sola lettura",
      "offDone": "Non in questo giro, ed è già fatto: sblocca in cima per aggiungere l'esercizio.",
      "readOnly": "{{round}} è già fatto: sola lettura. Si sblocca in cima all'editor.",
      "range": "{{from}}-{{to}}"
    },
    "grid": {
      "structure": "Struttura",
      "exercise": "Esercizio",
      "lensEffort": "Sforzo",
      "lensReps": "Ripetizioni",
      "lensLoad": "Carico",
      "lensSets": "Serie",
      "dayPeak": "Picco",
      "dayPeakA11y": "Picco: {{band}}",
      "setsFieldA11y": "{{name}}, {{round}}: serie in questo giro",
      "setsNote": "Scrivi le serie di un giro: la modifica vale solo per quel giro, su tutto il superset.",
      "lensA11y": "Mostra nella griglia",
      "roundHeadA11y": "{{round}}, menu del giro",
      "cellA11y": "{{name}}, {{round}}: {{line}}",
      "note": "Una lente alla volta. «Carico» mostra i chili scritti, o ≈ il carico dal tuo MAX per le righe a sforzo. Tocca una cella per aprirla a destra.",
      "pickExercise": "Scegli un esercizio nella griglia per vederlo qui."
    }
  }
}
